/* door-quote-cart.js -- extracted from door-quote-cart.liquid (Shopify 256 KB template limit).
   Logic unchanged. Load via: <script src="{{ 'door-quote-cart.js' | asset_url }}" defer></script>
*/
(function () {
    var CART_KEY = 'door_quote_cart_v1';
    var root = document.getElementById('door-quote-cart');
    if (!root) return;
    var apiBase = (root.getAttribute('data-api-base') || 'https://api.vintagedoors.com').replace(/\/$/, '');
    var hubspotEndpoint = apiBase + '/hubspot/api/hubspot-create-deal.php';
    var email = (root.getAttribute('data-customer-email') || '').trim();
    var phone = (root.getAttribute('data-customer-phone') || '').trim();
    var firstName = (root.getAttribute('data-customer-first-name') || '').trim();
    var lastName = (root.getAttribute('data-customer-last-name') || '').trim();
    var profileComplete = root.getAttribute('data-profile-complete') === '1';
    var quotePageUrl =
        (root.getAttribute('data-quote-page-url') || '/pages/request-a-quote').trim() || '/pages/request-a-quote';
    var completeProfileUrl =
        (root.getAttribute('data-complete-profile-url') || '/pages/complete-profile').trim() || '/pages/complete-profile';
    var listEl = document.getElementById('door-quote-list');
    var footerEl = document.getElementById('door-quote-footer');
    var msgEl = document.getElementById('door-quote-msg');
    var requestBtn = document.getElementById('door-quote-request-btn');
    var saveLaterBtn = document.getElementById('door-quote-save-later-btn');
    var folderSelect = document.getElementById('door-quote-save-folder');
    var newFolderInput = document.getElementById('door-quote-new-folder-name');
    var items = [];
    var removedSourceIds = [];
    var saveLaterNamingMode = false;
    // New Customer Accounts ignore routes.account_login_url return_to for storefront pages.
    // Always use /customer_authentication/login?return_to=<relative path>.
    var loginAuthPath = '/customer_authentication/login';

    function shopifyRoot() {
        return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    }

    function withRoot(path) {
        var p = String(path || '');
        if (!p) return '/';
        if (p.indexOf('http') === 0) return p;
        if (p.charAt(0) !== '/') p = '/' + p;
        var rootPath = shopifyRoot();
        if (rootPath && rootPath !== '/') return rootPath.replace(/\/$/, '') + p;
        return p;
    }

    function resolveQuoteItemCollectionHandle(item) {
        var opts = (item && item.options) || {};
        var direct = opts._route_collection || opts._collection_handle || item.collection_handle || '';
        if (direct)
            return String(direct)
                .replace(/^\/+|\/+$/g, '')
                .trim();
        var list = opts._product_collection_handles || opts._product_collections || item.product_collection_handles || [];
        if (Array.isArray(list) && list.length) {
            for (var i = 0; i < list.length; i++) {
                var entry = list[i];
                if (typeof entry === 'string' && entry.trim()) return entry.replace(/^\/+|\/+$/g, '').trim();
                if (entry && entry.handle)
                    return String(entry.handle)
                        .replace(/^\/+|\/+$/g, '')
                        .trim();
            }
        }
        return '';
    }

    function buildQuoteItemProductUrl(item) {
        var handle = item && item.product_handle ? String(item.product_handle).trim() : '';
        if (!handle && item && item.options && item.options._product_handle) {
            handle = String(item.options._product_handle).trim();
        }
        if (!handle) return '';
        // MERGE: seo_pdp_url — quote links use clean /products/{handle} (no /collections/ or ?view=)
        var url = withRoot('/products/' + encodeURIComponent(handle));
        var configId = item && item.source_config_id;
        if (configId != null && configId !== '') {
            url += (url.indexOf('?') >= 0 ? '&' : '?') + 'config_id=' + encodeURIComponent(configId);
        }
        return url;
    }

    function wrapQuoteProductLink(html, url, className) {
        if (!url) return html;
        return '<a href="' + escapeHtml(url) + '" class="' + className + '">' + html + '</a>';
    }

    /** Shopify return_to must be a relative storefront path. */
    function toRelativeStorePath(path) {
        var p = String(path || '').trim();
        if (!p) return '/';
        try {
            if (p.indexOf('http') === 0) {
                var u = new URL(p);
                p = u.pathname + (u.search || '');
            }
        } catch (eUrl) { }
        if (p.charAt(0) !== '/') p = '/' + p;
        return p;
    }

    function buildStorefrontLoginUrl(returnPath) {
        var rel = toRelativeStorePath(returnPath);
        return loginAuthPath + '?return_to=' + encodeURIComponent(rel);
    }

    function setAuthReturnToQuoteCart() {
        try {
            var path = toRelativeStorePath(quotePageUrl);
            var origin = window.location && window.location.origin ? window.location.origin : '';
            localStorage.setItem('door_config_return_path', path);
            if (origin) localStorage.setItem('door_config_return_url', origin + path);
        } catch (eRet) { }
    }

    /**
     * Guests can view the cart. Submit actions require login + completed profile.
     * Login returns to quote page; incomplete profile is gated on this page / complete-profile.
     */
    function ensureReadyForSubmit(intent) {
        if (!email) {
            setAuthReturnToQuoteCart();
            try {
                localStorage.setItem('door_quote_auth_intent', intent || 'quote');
            } catch (eIntent) { }
            showMsg('Please log in to continue. Your quote cart will be waiting.', 'ok');
            // Land on quote cart after login (not Shopify account/orders).
            window.location.href = buildStorefrontLoginUrl(quotePageUrl);
            return false;
        }
        if (!profileComplete) {
            setAuthReturnToQuoteCart();
            try {
                localStorage.setItem('door_quote_auth_intent', intent || 'quote');
            } catch (eIntent2) { }
            showMsg('Please complete your profile to continue.', 'ok');
            window.location.href = withRoot(completeProfileUrl);
            return false;
        }
        return true;
    }

    function readCart() {
        try {
            var raw = localStorage.getItem(CART_KEY);
            if (!raw) return { items: [] };
            var parsed = JSON.parse(raw);
            if (!parsed || !Array.isArray(parsed.items)) return { items: [] };
            return parsed;
        } catch (e) {
            return { items: [] };
        }
    }

    function writeCart(cart) {
        var payload = {
            items: cart && Array.isArray(cart.items) ? cart.items : [],
            updated_at: new Date().toISOString(),
        };
        if (cart && cart.preferred_folder_id != null && cart.preferred_folder_id !== '') {
            payload.preferred_folder_id = cart.preferred_folder_id;
        }
        if (cart && cart.preferred_folder_name) {
            payload.preferred_folder_name = cart.preferred_folder_name;
        }
        if (cart && Array.isArray(cart.removed_source_config_ids) && cart.removed_source_config_ids.length) {
            payload.removed_source_config_ids = cart.removed_source_config_ids;
        }
        localStorage.setItem(CART_KEY, JSON.stringify(payload));
        try {
            window.dispatchEvent(
                new CustomEvent('door-quote-cart-updated', {
                    detail: { count: payload.items.length },
                })
            );
        } catch (eEvt) { }
    }

    function persistItems() {
        var cart = readCart();
        writeCart({
            items: items.map(function (it) {
                var copy = Object.assign({}, it);
                delete copy._expanded;
                return copy;
            }),
            preferred_folder_id: cart.preferred_folder_id,
            preferred_folder_name: cart.preferred_folder_name,
            removed_source_config_ids: removedSourceIds.slice(),
        });
    }

    function normalizeRemovedSourceIds(list) {
        var out = [];
        var seen = {};
        (Array.isArray(list) ? list : []).forEach(function (id) {
            var n = parseInt(id, 10);
            if (isNaN(n) || n <= 0) return;
            var key = String(n);
            if (seen[key]) return;
            seen[key] = true;
            out.push(n);
        });
        return out;
    }

    function rememberRemovedSourceId(sourceId) {
        var n = parseInt(sourceId, 10);
        if (isNaN(n) || n <= 0) return 0;
        if (removedSourceIds.indexOf(n) === -1) removedSourceIds.push(n);
        return n;
    }

    function forgetRemovedSourceId(sourceId) {
        var key = String(sourceId);
        removedSourceIds = removedSourceIds.filter(function (id) {
            return String(id) !== key;
        });
    }

    function parseFetchJson(r) {
        // Dp start 27-08 — empty/non-JSON bodies must not throw "Unexpected end of JSON input"
        return Promise.resolve()
            .then(function () {
                return r && typeof r.text === 'function' ? r.text() : '';
            })
            .then(function (text) {
                var data = null;
                var raw = text == null ? '' : String(text).replace(/^\uFEFF/, '').trim();
                if (raw) {
                    try {
                        data = JSON.parse(raw);
                    } catch (eParse) {
                        data = { error: 'Invalid server response' };
                    }
                } else {
                    data = { error: 'Empty server response (HTTP ' + (r && r.status ? r.status : '?') + ')' };
                }
                return { ok: !!(r && r.ok), data: data, status: r ? r.status : 0 };
            })
            .catch(function () {
                return { ok: false, data: { error: 'Could not read server response' }, status: r ? r.status : 0 };
            });
        // Dp end 27-08
    }

    function deleteSavedConfig(configId) {
        var n = parseInt(configId, 10);
        if (isNaN(n) || n <= 0 || !email) return Promise.resolve({ ok: false });
        return fetch(apiBase + '/api/configurations.php', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: n, email: email }),
        })
            .then(function (r) {
                return parseFetchJson(r).then(function (parsed) {
                    return { ok: parsed.ok || parsed.status === 404, data: parsed.data };
                });
            })
            .catch(function () {
                return { ok: false };
            });
    }

    function deleteRemovedSavedConfigs() {
        if (!email || !removedSourceIds.length) return Promise.resolve();
        var pending = removedSourceIds.slice();
        var chain = Promise.resolve();
        pending.forEach(function (id) {
            chain = chain.then(function () {
                return deleteSavedConfig(id).then(function (result) {
                    if (result && result.ok) forgetRemovedSourceId(id);
                });
            });
        });
        return chain.then(function () {
            persistItems();
        });
    }

    function showMsg(text, type) {
        if (!msgEl) return;
        msgEl.textContent = text || '';
        var typeClass = '';
        if (type === 'error') typeClass = ' door-quote-msg--error';
        else if (type === 'ok') typeClass = ' door-quote-msg--ok';
        else if (type === 'info') typeClass = ' door-quote-msg--info';
        msgEl.className = 'door-quote-msg is-visible' + typeClass;
    }

    function hideMsg() {
        if (!msgEl) return;
        msgEl.textContent = '';
        msgEl.className = 'door-quote-msg';
    }

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    /** Match configurator desiredOptionOrder for quote summary display. */
    var SUMMARY_LABEL_ORDER = [
        'door unit design',
        'panel unit design',
        'sidelight',
        'transom',
        'door setup',
        'pre-hung',
        'prehung',
        'top style',
        'wood',
        'select wood',
        'screen and storm',
        'screen type',
        'select screen',
        'storm glass',
        'select glass',
        'glass type',
        'frame color',
        'additional options',
        'swing',
        'where will the door',
        'door location',
        'exposure',
        'measurement',
        'stile and rail',
        'applied molding',
        'sdl',
        'panel profile',
        'hinge',
        'lockset',
        'shelf',
        'priming',
        'door sweep',
        'door seal',
        'pet door',
        'bevel',
        'exact door',
        'finished opening',
        'rough opening',
        'jamb',
        'hardware',
        'casing',
    ];

    function summaryLabelRank(label) {
        var key = String(label || '')
            .toLowerCase()
            .replace(/[_-]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
        if (!key) return 9000;
        for (var i = 0; i < SUMMARY_LABEL_ORDER.length; i++) {
            if (key.indexOf(SUMMARY_LABEL_ORDER[i]) !== -1) return i;
        }
        return 8000;
    }

    function orderSummaryRows(rows) {
        if (!Array.isArray(rows) || rows.length < 2) return rows || [];
        return rows.slice().sort(function (a, b) {
            var la = typeof a === 'string' ? a : (a && (a.label || a.id)) || '';
            var lb = typeof b === 'string' ? b : (b && (b.label || b.id)) || '';
            var ra = summaryLabelRank(la);
            var rb = summaryLabelRank(lb);
            if (ra !== rb) return ra - rb;
            return String(la).localeCompare(String(lb));
        });
    }

    function insertsAdditionalOptionFallbackLabel(value) {
        var val = String(value || '').trim();
        var map = {
            top_bottom_inserts_glass: 'Top & Bottom Inserts',
            top_bottom_inserts_screen: 'Top & Bottom Inserts',
            top_bottom_inserts: 'Top & Bottom Inserts',
            fixed_glass: 'Fixed Glass',
            fixed_screen: 'Fixed Screen',
        };
        if (map[val]) return map[val];
        return val.replace(/_/g, ' ');
    }

    function dpCleanHardwareMeasureValue(val) {
        var s = String(val == null ? '' : val).trim();
        if (!s) return '';
        s = s.replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
        s = s
            .replace(/\s*(?:inches?|_?inch)\s*$/i, '')
            .replace(/["']+$/g, '')
            .trim();
        return s;
    }

    // Dp start 25-08 — hardware thickness match (2 1/4 → 2 1/4t); include hardware_swing_direction
    function dpFormatHardwareThicknessToken(val) {
        var s = dpCleanHardwareMeasureValue(val);
        if (!s) return '';
        return String(s)
            .replace(/_/g, ' ')
            .replace(/\s+/g, ' ')
            .replace(/\s*(?:inches?|_?inch|t)\s*$/i, '')
            .trim();
    }

    // Dp start 02-09 — only show hardware swing when that hardware product has the field
    function dpHardwareRowHasSwingField(row) {
        if (!row || typeof row !== 'object') return false;
        var opts = row.hardware_swing_direction_options || row.swing_direction_options;
        return Array.isArray(opts) && opts.length > 0;
    }

    function dpHardwareSelectionsHaveSwingField(opts) {
        opts = opts || {};
        var hw = opts._hardware_selections || opts.hardware_options;
        if (!Array.isArray(hw)) return false;
        for (var i = 0; i < hw.length; i++) {
            if (dpHardwareRowHasSwingField(hw[i])) return true;
        }
        return false;
    }
    // Dp end 02-09

    function formatHardwareSelectionSummaryLineFromRow(row) {
        if (!row || typeof row !== 'object') return '';
        var line = String(row.title || row.product_id || 'Hardware').trim() || 'Hardware';
        var seen = {};
        function appendPart(text) {
            text = String(text || '').trim();
            if (!text) return;
            var key = text.toLowerCase();
            if (seen[key]) return;
            seen[key] = true;
            line += ' — ' + text;
        }
        appendPart(row.finish_label || row.finish_value);
        appendPart(row.function_label || row.function_value);
        var extras = [
            ['closer_color_label', 'closer_color_value', 'Closer Color'],
            ['thickness_label', 'thickness_value', 'Door Thickness'],
            ['swing_direction_label', 'swing_direction_value', 'Swing Direction'],
            ['hardware_swing_direction_label', 'hardware_swing_direction_value', 'Hardware Swing Direction'],
            ['backset_label', 'backset_value', 'Hardware Backset'],
            ['track_length_label', 'track_length_value', 'Track Length'],
            ['connected_doors_label', 'connected_doors_value', 'Number of Connected Doors'],
            ['upper_track_length_label', 'upper_track_length_value', 'Upper Track Length'],
            ['max_door_size_label', 'max_door_size_value', 'Max Door Size'],
            ['carriage_pack_type_label', 'carriage_pack_type_value', 'Carriage Pack Type'],
            ['strap_hinge_length_label', 'strap_hinge_length_value', 'Strap Hinge Length'],
        ];
        extras.forEach(function (field) {
            if (field[2] === 'Hardware Swing Direction' && !dpHardwareRowHasSwingField(row)) return;
            var raw = row[field[0]] || row[field[1]] || '';
            var isThick = field[2] === 'Door Thickness';
            var val = isThick ? dpFormatHardwareThicknessToken(raw) : dpCleanHardwareMeasureValue(raw);
            if (!val) return;
            // Values-only extras (match finish/function); no "Door Thickness:" prefix.
            appendPart(val);
        });
        if (row.qty && row.qty > 1) line += ' (×' + row.qty + ')';
        return line;
    }
    // Dp end 25-08
    function enrichHardwareSummaryRows(rows, opts) {
        var hw = (opts && (opts._hardware_selections || opts.hardware_options)) || [];
        if (typeof hw === 'string') {
            try {
                hw = JSON.parse(hw);
            } catch (eEnHw) {
                hw = [];
            }
        }
        if (!Array.isArray(hw) || !hw.length) return rows || [];
        var hwIdx = 0;
        var out = (Array.isArray(rows) ? rows : []).map(function (r) {
            var label = typeof r === 'string' ? r : (r && (r.label || r.id)) || '';
            var labelKey = String(label).toLowerCase().replace(/[_-]+/g, ' ').trim();
            if (labelKey.indexOf('hardware') !== 0) return r;
            if (labelKey.indexOf('hardware function') !== -1) return r;
            // Dp start 03-09 — skip already-numbered Hardware N rows from re-map
            if (/^hardware\s+\d+$/.test(labelKey)) {
                hwIdx += 1;
                var numbered = hw[hwIdx - 1] || hw[0];
                var formattedN = formatHardwareSelectionSummaryLineFromRow(numbered);
                if (!formattedN) return r;
                if (typeof r === 'string') return formattedN.indexOf(':') !== -1 ? formattedN : label + ': ' + formattedN;
                return Object.assign({}, r, { value: formattedN });
            }
            // Dp end 03-09
            var row = hw[hwIdx] || hw[0];
            hwIdx += 1;
            var formatted = formatHardwareSelectionSummaryLineFromRow(row);
            if (!formatted) return r;
            // Dp start 03-09 — label Hardware 1 / Hardware 2 when multiple selections
            var hwLabel = hw.length > 1 ? 'Hardware ' + hwIdx : 'Hardware';
            if (typeof r === 'string') {
                return formatted.indexOf(':') !== -1 ? formatted : hwLabel + ': ' + formatted;
            }
            return Object.assign({}, r, { label: hwLabel, value: formatted });
            // Dp end 03-09
        });
        // Dp start 03-09 — add summary rows for extra hardware selections not in selected_summary
        while (hwIdx < hw.length) {
            hwIdx += 1;
            var extra = hw[hwIdx - 1];
            var extraFmt = formatHardwareSelectionSummaryLineFromRow(extra);
            if (!extraFmt) continue;
            var extraLabel = hw.length > 1 ? 'Hardware ' + hwIdx : 'Hardware';
            out.push({ label: extraLabel, value: extraFmt });
        }
        // Dp end 03-09
        return out;
    }

    function mergeInsertsAdditionalOptionsIntoSummaryRows(rows, opts) {
        var out = Array.isArray(rows) ? rows.slice() : [];
        var already = out.some(function (r) {
            var label = typeof r === 'string' ? r : (r && (r.label || r.id)) || '';
            return String(label).toLowerCase().indexOf('additional option') !== -1;
        });
        if (already) return out;
        var raw = opts && opts.screen_and_storm_inserts_additional_options;
        var vals = Array.isArray(raw) ? raw : raw != null && raw !== '' ? [raw] : [];
        vals = vals
            .map(function (v) {
                return String(v || '').trim();
            })
            .filter(Boolean);
        if (!vals.length) return out;
        out.push({
            label: 'Additional Options',
            value: vals.map(insertsAdditionalOptionFallbackLabel).join(', '),
        });
        return out;
    }

    // Dp start 17-08
    function dpPanelUnitInch(intVal, fracVal) {
        var n = (parseFloat(intVal) || 0) + (parseFloat(fracVal) || 0);
        if (!n && String(intVal || '') === '') return '';
        if (Math.abs(n - Math.round(n)) < 0.000001) return String(Math.round(n));
        return String(n);
    }
    function dpPanelUnitSillInch(intVal, fracVal) {
        var intN = parseFloat(intVal);
        var fracN = parseFloat(fracVal) || 0;
        if ((intVal == null || String(intVal) === '') && !fracN) return '';
        var intLabel = isNaN(intN) ? '5' : String(Math.round(intN));
        if (!fracN) return intLabel;
        var fracMap = { 0.125: '1/8', 0.25: '1/4', 0.375: '3/8', 0.5: '1/2', 0.625: '5/8', 0.75: '3/4', 0.875: '7/8' };
        var fLabel = '';
        Object.keys(fracMap).forEach(function (k) {
            if (!fLabel && Math.abs(parseFloat(k) - fracN) < 0.0001) fLabel = fracMap[k];
        });
        return fLabel ? intLabel + ' ' + fLabel : String((isNaN(intN) ? 0 : intN) + fracN);
    }
    function dpPorchInchLabel(inches) {
        if (isNaN(inches)) return '';
        var rounded = Math.round(inches * 16) / 16;
        if (rounded < 0) rounded = 0;
        var intPart = Math.floor(rounded + 1e-9);
        var fracPart = Math.round((rounded - intPart) * 1000) / 1000;
        var map = [
            { value: 0, label: '00' },
            { value: 0.0625, label: '1/16' },
            { value: 0.125, label: '1/8' },
            { value: 0.1875, label: '3/16' },
            { value: 0.25, label: '1/4' },
            { value: 0.3125, label: '5/16' },
            { value: 0.375, label: '3/8' },
            { value: 0.4375, label: '7/16' },
            { value: 0.5, label: '1/2' },
            { value: 0.5625, label: '9/16' },
            { value: 0.625, label: '5/8' },
            { value: 0.6875, label: '11/16' },
            { value: 0.75, label: '3/4' },
            { value: 0.8125, label: '13/16' },
            { value: 0.875, label: '7/8' },
            { value: 0.9375, label: '15/16' },
        ];
        var fracLabel = '';
        var bestDiff = 1;
        map.forEach(function (entry) {
            var diff = Math.abs(entry.value - fracPart);
            if (diff < bestDiff) {
                bestDiff = diff;
                fracLabel = entry.label;
            }
        });
        if (bestDiff > 1e-4) fracLabel = '';
        if (!fracLabel || fracLabel === '0' || fracLabel === '00') return String(intPart);
        return intPart + ' ' + fracLabel;
    }
    function dpPorchStopsAstragalsFromOpening(op) {
        var out = { stops: '', astragals: '' };
        if (!op) return out;
        if (op.stops && op.astragals) {
            out.stops = String(op.stops);
            out.astragals = String(op.astragals);
            return out;
        }
        var h = (parseFloat(op.height_int || op.heightInt) || 0) + (parseFloat(op.height_frac || op.heightFrac) || 0);
        if (!h) return out;
        var panels = Math.max(1, parseInt(op.panels || op.quantity, 10) || 1);
        var hLabel = dpPorchInchLabel(h);
        var tbLabel = dpPorchInchLabel(Math.max(0, h - 56.25));
        out.stops = '(4) ' + tbLabel + '" top and bottom; (4) ' + hLabel + '" left and right';
        out.astragals = '(' + panels + ') ' + hLabel + '"';
        return out;
    }
    function dpPanelUnitHumanize(v) {
        return String(v || '')
            .replace(/[_-]+/g, ' ')
            .replace(/\b\w/g, function (c) {
                return c.toUpperCase();
            });
    }
    function dpIsPorchEnclosureSummaryLabel(label) {
        var key = String(label || '')
            .toLowerCase()
            .replace(/[_-]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
        if (!key || key === 'panel unit design') return false;
        if (/^(porch|panel) opening #\d+/.test(key)) return true;
        if (/finished opening (width|height)/.test(key)) return true;
        if (key === 'panel thickness' || / panel thickness$/.test(key)) return true;
        if (key.indexOf('panels per opening') !== -1) return true;
        if (key.indexOf('add trim system') !== -1) return true;
        if (key === 'sill' || key.indexOf('sill width') !== -1) return true;
        if (/^door #\d+/.test(key)) return true;
        // Dp start 25-08 — bare Swing / Hinge / Lockset rows (no Door #) are rebuilt from openings
        if (
            key === 'swing direction' ||
            key === 'choose swing direction' ||
            key === 'hinge finish' ||
            key === 'lockset preparation' ||
            key === 'lockset prep'
        ) {
            return true;
        }
        // Dp end 25-08
        if (key === 'stops' || key === 'astragals') return true;
        return false;
    }
    function dpPanelUnitEnclosureRowsFromOptions(opts) {
        var rows = [];
        if (!opts || typeof opts !== 'object') return rows;
        var openings = opts.panel_unit_enclosure_openings || opts._panel_unit_enclosure_openings;
        if (typeof openings === 'string') {
            try {
                openings = JSON.parse(openings);
            } catch (eParse) {
                openings = [];
            }
        }
        if (!Array.isArray(openings) || !openings.length) return rows;
        var thickMap = { 1.125: '1 1/8', 1.25: '1 1/4', 1.375: '1 3/8', 1.5: '1 1/2', 1.75: '1 3/4', 2.25: '2 1/4' };
        var multi = openings.length > 1;
        openings.forEach(function (op, idx) {
            if (!op) return;
            var prefix = multi ? (idx === 0 ? 'Porch Opening #' : 'Panel Opening #') + (idx + 1) + ' ' : '';
            var wTxt = dpPanelUnitInch(op.width_int || op.widthInt, op.width_frac || op.widthFrac);
            var hTxt = dpPanelUnitInch(op.height_int || op.heightInt, op.height_frac || op.heightFrac);
            // Dp start 25-08 — drop literal inch mark; unit letter (w/h/t) is appended
            // later by dpFormatQuoteDescDimToken to match door products (36w not 36"w)
            if (wTxt) rows.push({ label: prefix + 'Finished Opening Width', value: wTxt });
            if (hTxt) rows.push({ label: prefix + 'Finished Opening Height', value: hTxt });
            var panelThickRaw = op.thickness != null && String(op.thickness).trim() !== '' ? String(op.thickness).trim() : '1.125';
            rows.push({
                label: prefix + 'Panel Thickness',
                value: String(thickMap[panelThickRaw] || panelThickRaw).replace(/"+$/g, ''),
            });
            // Dp end 25-08
            if (op.panels || op.quantity)
                rows.push({ label: prefix + 'Panels per opening', value: String(op.panels || op.quantity) });
            var trimOn =
                op.trim_system === 'true' ||
                op.trim_system === true ||
                op.trim_system === '1' ||
                op.trimSystem === true ||
                op.trimSystem === 'true';
            rows.push({ label: prefix + 'Add Trim System', value: trimOn ? 'On' : 'Off' });
            if (trimOn) {
                var sTxt = dpPanelUnitSillInch(op.sill_depth || op.sillDepth || '5', op.sill_frac || op.sillFrac || '0');
                if (sTxt) rows.push({ label: prefix + 'Sill Width', value: sTxt + '"' });
                var sa = dpPorchStopsAstragalsFromOpening(op);
                if (sa.stops) rows.push({ label: prefix + 'Stops', value: sa.stops });
                if (sa.astragals) rows.push({ label: prefix + 'Astragals', value: sa.astragals });
            }
            (op.doors || []).forEach(function (door, doorIdx) {
                if (!door) return;
                // Dp start 25-08 — Door # from stored number, else index (Panels per Opening order)
                /*
              var dn = door.door_number || door.doorNumber;
              if (!dn) return;
              */
                var dnRaw = door.door_number || door.doorNumber || door.number || door.index;
                var dn = parseInt(dnRaw, 10);
                if (!dn || dn < 1) dn = doorIdx + 1;
                // Dp end 25-08
                var swing = door.swing_direction || door.swingDirection;
                var hinge = door.hinge_finish || door.hingeFinish;
                var lockset = door.lockset_preparation || door.locksetPreparation;
                if (swing)
                    rows.push({ label: prefix + 'Door #' + dn + ' Swing Direction', value: dpPanelUnitHumanize(swing) });
                if (hinge) rows.push({ label: prefix + 'Door #' + dn + ' Hinge Finish', value: dpPanelUnitHumanize(hinge) });
                if (lockset)
                    rows.push({ label: prefix + 'Door #' + dn + ' Lockset Preparation', value: dpPanelUnitHumanize(lockset) });
            });
        });
        return rows;
    }
    function dpPanelUnitIndividualRowsFromOptions(opts) {
        var rows = [];
        if (!opts || typeof opts !== 'object') return rows;
        if (typeof dpHasPorchEnclosureOpenings === 'function' && dpHasPorchEnclosureOpenings(opts)) return rows;
        var design = String(opts.panel_unit_design || opts['Panel Unit Design'] || '').toLowerCase().replace(/[_-]+/g, ' ');
        var panels = opts.panel_unit_individual_measurements || opts._panel_unit_individual_measurements;
        if (typeof panels === 'string') {
            try {
                panels = JSON.parse(panels);
            } catch (eInd) {
                panels = [];
            }
        }
        if (!Array.isArray(panels) || !panels.length) return rows;
        if (design && design.indexOf('enclosure') !== -1) return rows;
        var thickMap = { '1.125': '1 1/8', '1.25': '1 1/4', '1.375': '1 3/8', '1.5': '1 1/2', '1.75': '1 3/4', '2.25': '2 1/4' };
        panels.forEach(function (panel, idx) {
            if (!panel) return;
            var prefix = 'Panel Set #' + (idx + 1);
            var wN = (parseFloat(panel.width_int || panel.widthInt) || 0) + (parseFloat(panel.width_frac || panel.widthFrac) || 0);
            var hN = (parseFloat(panel.height_int || panel.heightInt) || 0) + (parseFloat(panel.height_frac || panel.heightFrac) || 0);
            var wTok = wN ? (typeof dpPorchInchLabel === 'function' ? dpPorchInchLabel(wN) : String(wN)) : '';
            var hTok = hN ? (typeof dpPorchInchLabel === 'function' ? dpPorchInchLabel(hN) : String(hN)) : '';
            if (wTok && hTok) rows.push({ label: prefix, value: wTok + 'w x ' + hTok + 'h' });
            else if (wTok) rows.push({ label: prefix, value: wTok + 'w' });
            else if (hTok) rows.push({ label: prefix, value: hTok + 'h' });
            var tRaw = panel.thickness != null && String(panel.thickness).trim() !== '' ? String(panel.thickness).trim() : '';
            if (tRaw) {
                rows.push({
                    label: prefix + ' Thickness',
                    value: String(thickMap[tRaw] || tRaw).replace(/"+$/g, '')
                });
            }
            var qty = panel.quantity != null ? String(panel.quantity).trim() : '';
            if (qty) rows.push({ label: prefix + ' Quantity', value: qty });
        });
        return rows;
    }

    function dpIsPanelSetSummaryLabel(label) {
        var key = String(label || '')
            .toLowerCase()
            .replace(/[_-]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
        if (!key) return false;
        return /^panel set\s*#?\s*\d+/.test(key) || /^panel unit set\s*#?\s*\d+/.test(key);
    }

    function dpMergePanelUnitIndividualSummaryRows(rows, opts) {
        rows = Array.isArray(rows) ? rows.slice() : [];
        var extra = dpPanelUnitIndividualRowsFromOptions(opts);
        if (!extra.length) {
            // Still reformat legacy combined "Width: …, Height: …, Thickness: …, Qty: …" lines
            return rows.map(function (r) {
                if (!r || typeof r === 'string') return r;
                var lbl = String(r.label || r.id || '').trim();
                if (!dpIsPanelSetSummaryLabel(lbl)) return r;
                var nk = dpNormalizeFieldKey(lbl);
                // Already a size / thickness / quantity row — leave alone
                if (/thickness$/.test(nk) || /quantity$/.test(nk) || /qty$/.test(nk)) return r;
                var val = String(r.value || '').trim();
                if (!/width\s*:/i.test(val) || !/height\s*:/i.test(val)) return r;
                var wm = val.match(/width\s*:\s*([^,"]+)/i);
                var hm = val.match(/height\s*:\s*([^,"]+)/i);
                var tm = val.match(/thickness\s*:\s*([^,"]+)/i);
                var qm = val.match(/(?:qty|quantity)\s*:\s*([^,"]+)/i);
                var wTok = wm ? String(wm[1]).replace(/["']+/g, '').trim() : '';
                var hTok = hm ? String(hm[1]).replace(/["']+/g, '').trim() : '';
                var out = [];
                if (wTok && hTok) out.push({ label: lbl, value: wTok + 'w x ' + hTok + 'h' });
                else if (wTok) out.push({ label: lbl, value: wTok + 'w' });
                else if (hTok) out.push({ label: lbl, value: hTok + 'h' });
                if (tm) {
                    out.push({
                        label: lbl + ' Thickness',
                        value: String(tm[1]).replace(/["']+/g, '').trim()
                    });
                }
                if (qm) {
                    out.push({
                        label: lbl + ' Quantity',
                        value: String(qm[1]).replace(/["']+/g, '').trim()
                    });
                }
                return out.length ? out : r;
            }).reduce(function (acc, item) {
                if (Array.isArray(item)) return acc.concat(item);
                acc.push(item);
                return acc;
            }, []);
        }
        rows = rows.filter(function (r) {
            var lbl = typeof r === 'string' ? r : (r && (r.label || r.id)) || '';
            return !dpIsPanelSetSummaryLabel(lbl);
        });
        return rows.concat(extra);
    }

    function dpMergePanelUnitEnclosureSummaryRows(rows, opts) {
        rows = dpMergePanelUnitIndividualSummaryRows(rows, opts);
        rows = Array.isArray(rows) ? rows.slice() : [];
        var extra = dpPanelUnitEnclosureRowsFromOptions(opts);
        // Dp start 27-08 — only strip porch Door # / swing / hinge / lockset rows when
        // enclosure openings exist. Door products must keep Lockset Prep, Hinge Finish,
        // Swing Direction, and Optional Shelf in the quote description.
        if (!extra.length) return rows;
        // Dp end 27-08
        rows = rows.filter(function (r) {
            var lbl = typeof r === 'string' ? r : (r && (r.label || r.id)) || '';
            return !dpIsPorchEnclosureSummaryLabel(lbl);
        });
        rows = rows.filter(function (r) {
            var lbl = typeof r === 'string' ? '' : String((r && (r.label || r.id)) || '');
            var k = dpNormalizeFieldKey(lbl);
            if (!k) return true;
            if (k === 'exact door size' || k === 'exact door width' || k === 'exact door height') return false;
            if (
                k === 'door thickness' ||
                k === 'exact door thickness' ||
                k === 'sidelight thickness' ||
                k === 'transom thickness' ||
                k === 'gate thickness' ||
                k === 'exact gate thickness'
            )
                return false;
            if (k === 'finished opening size' || k === 'finished opening width' || k === 'finished opening height') return false;
            if (k === 'rough opening size' || k === 'rough opening width' || k === 'rough opening height') return false;
            return true;
        });
        // Dp start 25-08 — drop unlabeled summary values that duplicate Door #N field values
        if (extra.length && typeof dpParsePorchDoorField === 'function') {
            var doorVals = {};
            extra.forEach(function (e) {
                if (!e || !dpParsePorchDoorField(e.label || '')) return;
                var vk = dpNormalizeFieldKey(e.value || '');
                if (vk) doorVals[vk] = true;
            });
            rows = rows.filter(function (r) {
                var lbl = typeof r === 'string' ? '' : String((r && (r.label || r.id)) || '').trim();
                var val = typeof r === 'string' ? r : String((r && r.value) || '');
                if (lbl) return true;
                var vk = dpNormalizeFieldKey(val);
                return !vk || !doorVals[vk];
            });
        }
        // Dp end 25-08
        if (extra.length) return rows.concat(extra);
        return rows;
    }
    // Dp end 17-08

    // Dp start 20-08 / 21-08 — vertical spec description (one value per line)
    function dpIsSelectedOptionValue(val) {
        if (val == null) return false;
        if (Array.isArray(val)) {
            if (!val.length) return false;
            return val.some(function (x) {
                return dpIsSelectedOptionValue(x);
            });
        }
        if (typeof val === 'boolean') return val === true;
        var s = String(val).trim();
        if (!s) return false;
        var n = s.toLowerCase();
        if (
            [
                'none',
                'no',
                'n/a',
                'na',
                'false',
                'true',
                '0',
                'no_lock_prep',
                'none_selected',
                'not_selected',
                'select',
                'please select',
                '--',
                '-',
                'verify swing direction',
                'verify finish',
            ].indexOf(n) !== -1
        )
            return false;
        // Dp start 25-08 — hide bare fraction decimals leaked from saved option keys
        if (/^0\.\d+$/.test(s)) return false;
        // Dp end 25-08
        // Dp start 02-09 — "No Swing - Pocket Door" / barn style are valid swing selections
        if (/^no[\s_-]*swing/i.test(s)) return true;
        // Dp end 02-09
        // Hide "No Lock Prep", "No Shelf", "No Priming", "No Door Sweep", "No Door Stop", etc.
        if (/^no\s+/i.test(s)) return false;
        if (/^none(\s|$)/i.test(s)) return false;
        return true;
    }

    // Dp start 27-08 — schema choice label for stored ids (single_bore → Single Bore, s2m → S2M Accent Shelf)
    function dpHasPorchEnclosureOpenings(opts) {
        if (!opts || typeof opts !== 'object') return false;
        var openings = opts.panel_unit_enclosure_openings || opts._panel_unit_enclosure_openings;
        if (typeof openings === 'string') {
            try {
                openings = JSON.parse(openings);
            } catch (eOpen) {
                openings = [];
            }
        }
        return Array.isArray(openings) && openings.length > 0;
    }

    function dpSchemaChoiceDisplay(opts, key, value) {
        var vs = String(value == null ? '' : value).trim();
        if (!vs) return '';
        var schema = opts && opts._pricing_schema;
        if (!Array.isArray(schema)) return vs;
        var kn = dpNormalizeFieldKey(key);
        var want = dpNormalizeFieldKey(vs);
        if (!kn || !want) return vs;
        for (var i = 0; i < schema.length; i++) {
            var opt = schema[i];
            if (!opt) continue;
            var oid = dpNormalizeFieldKey(opt.id || '');
            var olab = dpNormalizeFieldKey(opt.label || '');
            if (oid !== kn && olab !== kn && String(opt.id || '') !== String(key || '')) continue;
            var choices = opt.options || opt.choices || [];
            if (!Array.isArray(choices)) continue;
            for (var c = 0; c < choices.length; c++) {
                var ch = choices[c] || {};
                var cv = String(ch.value != null ? ch.value : ch.id || '').trim();
                var cl = String(ch.label || ch.title || '').trim();
                if (dpNormalizeFieldKey(cv) === want || dpNormalizeFieldKey(cl) === want) {
                    return cl || cv || vs;
                }
            }
        }
        return vs;
    }

    function dpIsMeasurementInternalKey(key) {
        var raw = String(key == null ? '' : key);
        var snake = raw.toLowerCase().replace(/-/g, '_');
        var k = dpNormalizeFieldKey(raw);
        if (!k) return true;
        var bare =
            typeof dpStripOpeningPrefixFromLabel === 'function'
                ? dpNormalizeFieldKey(dpStripOpeningPrefixFromLabel(raw))
                : k;
        var keep = {
            'exact door width': 1,
            'exact door height': 1,
            'exact door size': 1,
            'door thickness': 1,
            'pre hung unit depth': 1,
            'rough opening size': 1,
            'rough opening width': 1,
            'rough opening height': 1,
            'finished opening size': 1,
            'finished opening width': 1,
            'finished opening height': 1,
            'exact sidelight width': 1,
            'exact sidelight height': 1,
            'exact transom height': 1,
            'transom thickness': 1,
            'panel thickness': 1,
            'custom thickness': 1,
            'millwork custom thickness': 1,
            thickness: 1,
            'sill width': 1,
            sill: 1,
            'panels per opening': 1,
            'add trim system': 1,
            stops: 1,
            astragals: 1,
        };
        if (keep[k] || keep[bare]) return false;
        if (/\b\d+\s+\d+\b/.test(k)) return true;
        if (/_label$/.test(snake) && /(width|height|thickness|frac|int|pre_hung|depth|sidelight|transom)/.test(snake))
            return true;
        if (/\blabel$/.test(k) && /(width|height|thickness|frac|int|pre hung|depth)/.test(k)) return true;
        if (
            /(width|height|thickness|depth).*\b(int|frac|fraction)\b|\b(int|frac|fraction)\b.*(width|height|thickness|depth)/.test(
                k
            )
        )
            return true;
        if (
            /(^|_)(int|frac|fraction)($|_)/.test(snake) &&
            /(width|height|thickness|depth|pre_hung|sidelight|transom|rough|finished|exact|panel|door|jamb)/.test(snake)
        )
            return true;
        if (/(rough|finished|exact|jamb|screen storm)\s+(door\s+)?thickness/.test(k)) return true;
        if (/panel\s+door\s+thickness/.test(k)) return true;
        if (/(exact|rough|jamb|panel)\s+pre\s+hung/.test(k)) return true;
        if (/pre\s+hung\s+(int|frac)/.test(k)) return true;
        if (/transom transom thickness|sidelight sidelight thickness/.test(k)) return true;
        if (/panel unit set\s*\d+/.test(k) && /(thickness|quantity|width|height|qty)/.test(k)) return true;
        return false;
    }

    function dpQuoteDescFieldFamily(label) {
        // Dp merge code 10-09 start — when called with a full "Label: value" line, family from the label only
        var rawLab = String(label == null ? '' : label);
        var colonFam = rawLab.indexOf(':');
        if (colonFam > 0) rawLab = rawLab.slice(0, colonFam);
        var k = dpNormalizeFieldKey(rawLab);
        // Dp merge code 10-09 end
        if (!k) return '';
        // Dp start 03-09 — Door #N Swing/Hinge/Lockset must stay per-door (swing family was dropping #2+)
        if (typeof dpParsePorchDoorField === 'function' && dpParsePorchDoorField(label)) {
            return '';
        }
        if (/^door\s*#?\s*\d+\s+/.test(k)) {
            return '';
        }
        if (k === 'panel thickness' || /panel thickness$/.test(k)) return '';
        // Dp end 03-09
        if (
            k === 'select wood' ||
            k === 'wood' ||
            k === 'wood type' ||
            k === 'wood species' ||
            k === 'wood type storm porch'
        )
            return 'wood';
        if (/storm glass/.test(k)) return 'storm_glass';
        if (/sidelight style/.test(k)) return 'sidelight_style';
        if (/sidelight location/.test(k)) return 'sidelight_location';
        if (k === 'door setup' || k === 'pre hung' || k === 'prehung') return 'door_setup';
        // Dp merge code 10-09 start — Unit Depth + Jamb Width are the same front measurement
        if (
            k.indexOf('pre hung unit depth') === 0 ||
            k.indexOf('prehung unit depth') === 0 ||
            k.indexOf('pre hung jamb width') === 0 ||
            // Dp start VDN-390 23-10
            k.indexOf('prehung jamb width') === 0 ||
            k.indexOf('pre hung jamb depth') === 0 ||
            k.indexOf('prehung jamb depth') === 0
            // Dp end VDN-390 23-10
        ) {
            return 'prehung_jamb_width';
        }
        // Dp merge code 10-09 end
        if ((/screen/.test(k) && /storm/.test(k) && /insert/.test(k)) || k === 'screen & storm' || k === 'screen and storm')
            return 'screen_storm';
        if (/beveled? glass/.test(k) || k === 'glass bevel') return 'bevel';
        if (/lockset/.test(k) && k.indexOf('door') === -1) return 'lockset';
        if (k === 'optional shelf' || k === 'shelf') return 'shelf';
        if (/stile and rail/.test(k)) return 'stile_rail';
        if (k === 'sdl' || k === 'sdl profile') return 'sdl';
        if (k === 'panel profile' || k === 'applied molding') return 'panel_profile';
        if (/hardware swing/.test(k)) return 'hardware_swing';
        if (/swing/.test(k)) return 'swing';
        if (k === 'hinge finish') return 'hinge';
        if (k === 'closer color') return 'closer_color';
        if (k === 'select glass' || k === 'glass' || k === 'glass type') return 'glass';
        if (/transom style/.test(k)) return 'transom_style';
        if (k === 'sidelight thickness') return 'sidelight_thickness';
        if (k === 'transom thickness') return 'transom_thickness';
        // Keep Hardware Door Thickness separate from product Door Thickness
        if (k === 'hardware door thickness' || /^hardware\s+\d+\s+door thickness$/.test(k)) {
            var hwThickM = k.match(/^hardware\s+(\d+)\s+door thickness$/);
            return hwThickM ? 'hardware_door_thickness_' + hwThickM[1] : 'hardware_door_thickness';
        }
        if (
            (k === 'door thickness' || k === 'exact door thickness' || (k.indexOf('door') !== -1 && /thickness/.test(k))) &&
            k.indexOf('hardware') === -1
        ) {
            return 'door_thickness';
        }
        var setM = k.match(/panel (?:unit )?set\s*#?\s*(\d+)(.*)$/);
        if (setM) {
            var setRest = String(setM[2] || '').trim();
            if (/thickness/.test(setRest)) return 'panel_set_' + setM[1] + '_thickness';
            if (/quantity|qty/.test(setRest)) return 'panel_set_' + setM[1] + '_qty';
            return 'panel_set_' + setM[1];
        }
        return k;
    }
    // Dp end 27-08

    function dpMergeExtraOptionsIntoSummaryRows(rows, opts, flags) {
        rows = Array.isArray(rows) ? rows.slice() : [];
        flags = flags || {};
        if (!opts || typeof opts !== 'object') {
            rows = rows.filter(function (r) {
                if (!r) return false;
                if (typeof r === 'string') return dpIsSelectedOptionValue(r);
                return dpIsSelectedOptionValue(r.value || r.display || r.name || '');
            });
            return rows;
        }

        // Dp start 25-08 — match saved option display values (Beveled Glass, swing); skip raw frac/True leaks
        function dpMatchSavedOptionDisplay(key, value) {
            var kn = dpNormalizeFieldKey(key);
            var vs = String(value == null ? '' : value).trim();
            var vl = vs.toLowerCase();
            if (kn === 'glass bevel' || kn === 'beveled glass' || kn === 'bevel glass' || kn === 'add beveled glass') {
                if (
                    value === true ||
                    vl === 'true' ||
                    vl === '1' ||
                    vl === 'yes' ||
                    vl === 'on' ||
                    vl.indexOf('add') !== -1 ||
                    vl === 'beveled glass' ||
                    vl === 'bevel glass'
                ) {
                    return 'Beveled Glass';
                }
                return '';
            }
            if (
                (kn === 'door thickness' || kn === 'thickness') &&
                vs &&
                !/t$/i.test(vs) &&
                /\d/.test(vs) &&
                !/[wh]$/i.test(vs)
            ) {
                return dpFormatHardwareThicknessToken(vs);
            }
            if (
                kn === 'hardware swing direction' ||
                kn === 'swing direction' ||
                kn === 'hardware_swing_direction' ||
                kn === 'swing_direction'
            ) {
                if (!vs) return '';
                if (dpNormalizeFieldKey(vs) === 'verify swing direction') return '';
                var schemaSwing =
                    typeof dpSchemaChoiceDisplay === 'function' ? dpSchemaChoiceDisplay(opts, key, vs) : '';
                if (schemaSwing) return schemaSwing;
                return vs.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
                    return c.toUpperCase();
                });
            }
            return null;
        }

        function dpIsRawSavedMatchLeak(key, value) {
            var k = String(key || '');
            var kn = k.toLowerCase();
            if (
                kn.charAt(0) === '_' ||
                kn.indexOf('_cm') !== -1 ||
                kn.indexOf('_in') !== -1 ||
                kn.indexOf('_fraction') !== -1 ||
                /_frac$/i.test(k) ||
                /_frac_/i.test(k)
            ) {
                return true;
            }
            var s = String(value == null ? '' : value).trim();
            if (/^(true|false)$/i.test(s) && kn.indexOf('bevel') === -1 && kn.indexOf('glass bevel') === -1) {
                return true;
            }
            if (/^0\.\d+$/.test(s)) return true;
            // Dp start 27-08 — skip collapsed measurement int/frac/label keys
            if (typeof dpIsMeasurementInternalKey === 'function' && dpIsMeasurementInternalKey(k)) return true;
            // Dp end 27-08
            return false;
        }

        // Map bevel True / Add Beveled Glass BEFORE filter so matched values are kept
        rows = rows
            .map(function (r) {
                if (!r || typeof r === 'string') return r;
                var lab = String((r && (r.label || r.id)) || '').trim();
                var matched = dpMatchSavedOptionDisplay(lab, r.value != null ? r.value : r.display);
                if (matched !== null && matched !== '') {
                    return Object.assign({}, r, { value: matched });
                }
                if (matched === '') return null;
                return r;
            })
            .filter(Boolean);

        rows = rows.filter(function (r) {
            if (!r) return false;
            if (typeof r === 'string') return dpIsSelectedOptionValue(r);
            return dpIsSelectedOptionValue(r.value || r.display || r.name || '');
        });
        // Dp end 25-08

        var extraKeys = [
            { key: 'transom_style', label: 'Transom Style' },
            { key: 'transom_count', label: 'Single or Double Transom?' },
            { key: 'sidelight_style', label: 'Sidelight Style', aliases: ['select_your_sidelight_style'] },
            { key: 'sidelight_location', label: 'Sidelight Location' },
            // Dp start 25-08 — saved match keys that must appear when selected
            { key: 'glass_bevel', label: 'Beveled Glass' },
            { key: 'swing_direction', label: 'Swing Direction', aliases: ['swing_direction_value', 'swing_direction_label'] },
            { key: 'hardware_swing_direction', label: 'Hardware Swing Direction', aliases: ['hardware_swing_direction_value', 'hardware_swing_direction_label'] },
            { key: 'door_thickness', label: 'Door Thickness' },
            // Dp end 25-08
            // Dp start 27-08 — selected fields that were dropping from the quote description
            { key: 'lockset_prep', label: 'Lockset Prep', aliases: ['lockset_preparation', 'lockset'] },
            { key: 'optional_shelf', label: 'Optional Shelf', aliases: ['shelf'] },
            { key: 'hinge_finish', label: 'Hinge Finish' },
            { key: 'stile_and_rail_profile', label: 'Stile and Rail Profile' },
            { key: 'screen_and_storm_inserts', label: 'Screen & Storm Inserts', aliases: ['screen_storm_inserts'] },
            { key: 'door_unit_design', label: 'Door Unit Design' },
            { key: 'door_setup', label: 'Door Setup', aliases: ['pre_hung'] },
            { key: 'panel_unit_design', label: 'Panel Unit Design' },
            { key: 'sdl_profile', label: 'SDL Profile', aliases: ['sdl'] },
            { key: 'panel_profile', label: 'Panel Profile', aliases: ['applied_molding'] },
            // Dp end 27-08
        ];

        extraKeys.forEach(function (item) {
            var val = opts[item.key];
            // Dp start 27-08 — alias keys + skip porch-owned swing/hinge/lockset
            if ((val == null || String(val).trim() === '') && item.aliases) {
                for (var a = 0; a < item.aliases.length; a++) {
                    if (opts[item.aliases[a]] != null && String(opts[item.aliases[a]]).trim() !== '') {
                        val = opts[item.aliases[a]];
                        break;
                    }
                }
            }
            if (
                typeof dpHasPorchEnclosureOpenings === 'function' &&
                dpHasPorchEnclosureOpenings(opts) &&
                (item.key === 'lockset_prep' ||
                    item.key === 'hinge_finish' ||
                    item.key === 'swing_direction' ||
                    item.key === 'hardware_swing_direction')
            ) {
                return;
            }
            // Dp start 02-09 — Hardware Swing Direction only when the hardware product has that field
            if (item.key === 'hardware_swing_direction' && !dpHardwareSelectionsHaveSwingField(opts)) {
                return;
            }
            // Dp end 02-09
            // Dp start 31-08 — Hinge Finish only applies to pre-hung / hung doors; skip for slab-only doors
            if (item.key === 'hinge_finish') {
                var setupCheck = String(opts.door_setup || opts.pre_hung || '').toLowerCase();
                if (!setupCheck && Array.isArray(rows)) {
                    for (var rsi = 0; rsi < rows.length; rsi++) {
                        var rRow = rows[rsi];
                        var rLbl = typeof rRow === 'string' ? '' : String((rRow && (rRow.label || rRow.id)) || '');
                        var rNorm = typeof dpNormalizeFieldKey === 'function' ? dpNormalizeFieldKey(rLbl) : rLbl.toLowerCase().replace(/[_-]+/g, ' ').trim();
                        if (rNorm === 'door setup' || rNorm === 'pre hung' || rNorm === 'prehung') {
                            setupCheck = String(typeof rRow === 'string' ? rRow : ((rRow && (rRow.value || rRow.display)) || '')).toLowerCase();
                            break;
                        }
                    }
                }
                if (setupCheck && setupCheck.indexOf('slab') !== -1) {
                    return;
                }
            }
            // Dp end 31-08
            // Dp start 02-09 — show Door Unit Design: Single Door (was skipped for single_door value)
            /*
            if (item.key === 'door_unit_design' && /^single[\s_-]*door$/i.test(String(val == null ? '' : val))) {
              return;
            }
            */
            // Dp end 02-09
            if (typeof dpIsMeasurementInternalKey === 'function' && dpIsMeasurementInternalKey(item.key)) {
                return;
            }
            // Dp end 27-08
            // Dp start 25-08
            var matched = dpMatchSavedOptionDisplay(item.key, val);
            if (matched !== null) {
                if (!matched) return;
                val = matched;
            } else if (!dpIsSelectedOptionValue(val)) {
                return;
            }
            // Dp end 25-08
            var strVal = String(val).trim();
            var exists = rows.some(function (r) {
                var l = typeof r === 'string' ? r : (r && (r.label || r.id)) || '';
                var ln = String(l).toLowerCase().replace(/[_-]+/g, ' ').trim();
                if (ln === item.label.toLowerCase() || ln === item.key.toLowerCase().replace(/[_-]+/g, ' ')) return true;
                if (item.key === 'glass_bevel' && (ln === 'beveled glass' || ln === 'bevel glass')) return true;
                if (item.key === 'hardware_swing_direction' && ln === 'hardware swing direction') return true;
                if (item.key === 'swing_direction' && (ln === 'swing direction' || ln === 'choose swing direction'))
                    return true;
                // Dp start 27-08
                if (typeof dpQuoteDescFieldFamily === 'function') {
                    var itemFam = dpQuoteDescFieldFamily(item.label);
                    if (itemFam && dpQuoteDescFieldFamily(l) === itemFam) return true;
                }
                if (item.key === 'lockset_prep' && ln.indexOf('lockset') !== -1 && ln.indexOf('door') === -1) return true;
                if (item.key === 'optional_shelf' && (ln === 'optional shelf' || ln === 'shelf')) return true;
                if (item.key === 'hinge_finish' && ln === 'hinge finish') return true;
                if (item.key === 'stile_and_rail_profile' && ln === 'stile and rail profile') return true;
                if (
                    item.key === 'screen_and_storm_inserts' &&
                    (ln === 'screen & storm inserts' || ln === 'screen and storm inserts' || ln === 'screen storm inserts')
                )
                    return true;
                if (item.key === 'door_unit_design' && ln === 'door unit design') return true;
                if (item.key === 'door_setup' && (ln === 'door setup' || ln === 'pre hung')) return true;
                if (item.key === 'panel_unit_design' && ln === 'panel unit design') return true;
                if (item.key === 'sdl_profile' && (ln === 'sdl profile' || ln === 'sdl')) return true;
                if (item.key === 'panel_profile' && ln === 'panel profile') return true;
                // --- Dp start 01-09 (Select your sidelight style → Sidelight Style) ---
                if (item.key === 'sidelight_style' && /sidelight style/.test(ln)) return true;
                // --- Dp end 01-09 ---
                // Dp end 27-08
                return false;
            });
            if (!exists) {
                var displayVal =
                    matched !== null
                        ? strVal
                        : strVal.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
                            return c.toUpperCase();
                        });
                // Dp start 27-08 — prefer schema choice label (Lockset Prep, Optional Shelf, …)
                if (typeof dpSchemaChoiceDisplay === 'function') {
                    var fromSchema = dpSchemaChoiceDisplay(opts, item.key, strVal);
                    if ((!fromSchema || fromSchema === strVal) && item.aliases) {
                        for (var sa = 0; sa < item.aliases.length; sa++) {
                            fromSchema = dpSchemaChoiceDisplay(opts, item.aliases[sa], strVal);
                            if (fromSchema && fromSchema !== strVal) break;
                        }
                    }
                    if (!fromSchema || fromSchema === strVal) {
                        fromSchema = dpSchemaChoiceDisplay(opts, item.key, displayVal);
                    }
                    if (fromSchema) displayVal = fromSchema;
                }
                // Dp end 27-08
                rows.push({ label: item.label, value: displayVal });
            }
        });

        // Dp start 31-08 — strip any stale Hinge Finish row if door is Slab Only
        var finalSetup = String(opts.door_setup || opts.pre_hung || '').toLowerCase();
        if (!finalSetup && Array.isArray(rows)) {
            for (var fsi = 0; fsi < rows.length; fsi++) {
                var frRow = rows[fsi];
                var frLbl = typeof frRow === 'string' ? '' : String((frRow && (frRow.label || frRow.id)) || '');
                var frNorm = typeof dpNormalizeFieldKey === 'function' ? dpNormalizeFieldKey(frLbl) : frLbl.toLowerCase().replace(/[_-]+/g, ' ').trim();
                if (frNorm === 'door setup' || frNorm === 'pre hung' || frNorm === 'prehung') {
                    finalSetup = String(typeof frRow === 'string' ? frRow : ((frRow && (frRow.value || frRow.display)) || '')).toLowerCase();
                    break;
                }
            }
        }
        if (finalSetup && finalSetup.indexOf('slab') !== -1) {
            rows = rows.filter(function (r) {
                if (!r) return false;
                var l = typeof r === 'string' ? r : String((r && (r.label || r.id)) || '');
                var ln = typeof dpNormalizeFieldKey === 'function' ? dpNormalizeFieldKey(l) : l.toLowerCase().replace(/[_-]+/g, ' ').trim();
                return ln !== 'hinge finish' && ln !== 'hingefinish';
            });
        }
        // Dp end 31-08

        // Dp start 27-08 — labeled description keeps collapsed measurement rows; do not dump raw option keys
        if (flags.skipCatchAll) return rows;
        // Dp end 27-08

        try {
            Object.keys(opts).forEach(function (k) {
                if (
                    !k ||
                    k.charAt(0) === '_' ||
                    k.indexOf('_cm') !== -1 ||
                    k.indexOf('_in') !== -1 ||
                    k.indexOf('_fraction') !== -1
                )
                    return;
                // Dp start 25-08 — also skip _frac keys and bare True / 0.xx leaks
                if (dpIsRawSavedMatchLeak(k, opts[k])) return;
                // Dp end 25-08
                // Dp start 27-08
                if (typeof dpIsMeasurementInternalKey === 'function' && dpIsMeasurementInternalKey(k)) return;
                // Dp end 27-08
                var kn = String(k).toLowerCase();
                if (kn === 'hardware_options' || kn === 'casing_options') return;
                var v = opts[k];
                // Dp start 25-08
                var mapped = dpMatchSavedOptionDisplay(k, v);
                if (mapped !== null) {
                    if (!mapped) return;
                    v = mapped;
                } else if (!dpIsSelectedOptionValue(v) || typeof v === 'object') {
                    return;
                }
                // Dp end 25-08
                var valStr = Array.isArray(v) ? v.filter(dpIsSelectedOptionValue).join(', ') : String(v).trim();
                if (!dpIsSelectedOptionValue(valStr)) return;

                var kLower = k.toLowerCase().replace(/[_-]+/g, ' ');
                var exists = rows.some(function (r) {
                    var l = typeof r === 'string' ? r : (r && (r.label || r.id)) || '';
                    var lLower = String(l).toLowerCase().replace(/[_-]+/g, ' ');
                    if (lLower === kLower || lLower.indexOf(kLower) !== -1) return true;
                    // Dp start 27-08 — Wood vs Wood Type, Storm Glass vs Storm Glass Type, etc.
                    if (
                        typeof dpQuoteDescFieldFamily === 'function' &&
                        dpQuoteDescFieldFamily(l) &&
                        dpQuoteDescFieldFamily(l) === dpQuoteDescFieldFamily(k)
                    )
                        return true;
                    // Dp end 27-08
                    return false;
                });
                if (!exists) {
                    var displayLbl = k.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
                        return c.toUpperCase();
                    });
                    var displayVal =
                        mapped !== null
                            ? valStr
                            : valStr.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
                                return c.toUpperCase();
                            });
                    rows.push({ label: displayLbl, value: displayVal });
                }
            });
        } catch (eCatchAllRows2008) { }

        return rows;
    }
    function dpAppendSelectedSummaryToDescription(text, sumRows) {
        text = String(text == null ? '' : text).trim();
        var lower = text.toLowerCase();
        (Array.isArray(sumRows) ? sumRows : []).forEach(function (sr) {
            if (!sr) return;
            var sVal = typeof sr === 'string' ? sr : sr.value || sr.display || '';
            sVal = String(sVal).trim();
            if (!dpIsSelectedOptionValue(sVal)) return;
            var piece = dpNormalizeDescriptionValue(sVal);
            if (!piece) return;
            if (lower && lower.indexOf(piece.toLowerCase()) !== -1) return;
            text = text ? text + '\n' + piece : piece;
            lower = text.toLowerCase();
        });
        return text;
    }

    function dpStripDescriptionLabel(line) {
        line = String(line == null ? '' : line).trim();
        if (!line) return '';
        if (/^https?:\/\//i.test(line)) return line;
        var m = line.match(/^([^:]+):\s*([\s\S]+)$/);
        if (!m) return line;
        var rest = String(m[2]).trim();
        return rest !== '' ? rest : line;
    }

    function dpNormalizeDescriptionValue(value) {
        // Keep values as saved for PDF/draft parity (e.g. "36 0", "12 0") — do not tidyMeasure here.
        var v = String(dpStripDescriptionLabel(value) || '').trim();
        if (!v) return '';
        if (/^\[object object\]$/i.test(v)) return '';
        // Full Exposure… / Partial Exposure… / Protected Location… → short title only
        var exp = v.match(/^(Full Exposure|Partial Exposure|Protected Location)\b/i);
        if (exp) {
            var map = {
                'full exposure': 'Full Exposure',
                'partial exposure': 'Partial Exposure',
                'protected location': 'Protected Location',
            };
            v = map[String(exp[1]).toLowerCase()] || exp[1];
        }
        if (!dpIsSelectedOptionValue(v)) return '';
        return v;
    }

    function dpIsDimToken(value) {
        value = String(value == null ? '' : value).trim();
        if (!value) return false;
        var m = value.match(/^[^:]+:\s*([\s\S]+)$/);
        if (m) return dpIsDimToken(m[1]);
        return /^\d[\d\s\/]*(?:wf|hf|[wht])(?:\s+Premium\b[\s\S]*)?$/i.test(value);
    }

    function dpIsMeasurementTypeLabel(value) {
        var n = String(value == null ? '' : value)
            .trim()
            .toLowerCase()
            .replace(/_/g, ' ');
        // Dp start 02-09 — slab storefront token is finished_opening (not finished_opening_size)
        if (n === 'finished opening' || n === 'finished opening size') return true;
        // Dp end 02-09
        return /^(exact door size|rough opening size|finished (?:door |opening )?size|pre-hung unit size|pre hung unit size|jamb unit size|exact unit size|exact transom size|exact sidelight size|exact gate size|exact panel size|(first|second|third|fourth|fifth) opening size)$/.test(
            n
        );
    }

    function dpIsFinishedOpeningMeasurementKey(mtKey) {
        mtKey = dpNormalizeFieldKey(mtKey || '');
        return (
            mtKey === 'finished opening size' ||
            mtKey === 'finished_opening_size' ||
            mtKey === 'finished opening' ||
            mtKey === 'finished_opening'
        );
    }

    function dpIsRoughOpeningMeasurementKey(mtKey) {
        mtKey = dpNormalizeFieldKey(String(mtKey || '').replace(/_/g, ' '));
        return mtKey === 'rough opening size' || mtKey === 'rough_opening_size';
    }

    // Dp start 02-09 — detect rough-opening flow from live option keys (cart may omit measurement_type)
    function dpHasRoughOpeningInputs(opts) {
        opts = opts || {};
        var rw = dpCombineDimensionInchesLabel(
            dpReadOptKeys(opts, ['rough-width-int', 'rough_width_int', 'rough_opening_width']),
            dpReadOptKeys(opts, ['rough-width-frac', 'rough-width-frac_label', 'rough_width_frac', 'rough_width_fraction'])
        );
        var rh = dpCombineDimensionInchesLabel(
            dpReadOptKeys(opts, ['rough-height-int', 'rough_height_int', 'rough_opening_height']),
            dpReadOptKeys(opts, ['rough-height-frac', 'rough-height-frac_label', 'rough_height_frac', 'rough_height_fraction'])
        );
        return !!(rw || rh);
    }

    function dpResolveMeasurementContextKey(opts, rows) {
        var mtKey = dpEffectiveMeasurementTypeKey(opts, rows);
        var nk = dpNormalizeFieldKey(String(mtKey || '').replace(/_/g, ' '));
        if (dpIsRoughOpeningMeasurementKey(nk)) return 'rough opening size';
        if (dpIsFinishedOpeningMeasurementKey(nk)) return nk;
        if (nk === 'jamb unit size') return 'jamb unit size';
        if (nk === 'exact door size') return 'exact door size';
        // Dp merge code 10-09 start — exact sidelight / transom / gate are first-class measurement contexts
        if (nk === 'exact sidelight size') return 'exact sidelight size';
        if (nk === 'exact transom size') return 'exact transom size';
        if (nk === 'exact gate size') return 'exact gate size';
        // Dp merge code 10-09 end
        if (nk === 'pre hung unit size' || nk === 'pre-hung unit size') return nk;
        var raw = opts.measurement_type || opts['measurement-type'] || '';
        if (Array.isArray(raw)) raw = raw[0] || '';
        raw = String(raw || '').toLowerCase().replace(/-/g, '_');
        if (raw.indexOf('jamb') !== -1 && raw.indexOf('unit') !== -1) return 'jamb unit size';
        if (raw.indexOf('exact') !== -1 && raw.indexOf('door') !== -1) return 'exact door size';
        // Dp merge code 10-09 start — raw token → context (selected front measurement type)
        if (raw.indexOf('exact') !== -1 && raw.indexOf('sidelight') !== -1) return 'exact sidelight size';
        if (raw.indexOf('exact') !== -1 && raw.indexOf('transom') !== -1) return 'exact transom size';
        if (raw.indexOf('exact') !== -1 && raw.indexOf('gate') !== -1) return 'exact gate size';
        // Dp merge code 10-09 end
        if (raw.indexOf('pre_hung') !== -1 || raw.indexOf('pre-hung') !== -1 || raw.indexOf('prehung') !== -1) {
            return 'pre hung unit size';
        }
        if (raw.indexOf('rough') !== -1) return 'rough opening size';
        if (raw.indexOf('finished') !== -1) return 'finished opening size';
        // Only infer rough from live inputs when measurement type is unset (avoid stale rough keys on jamb configs)
        if (!raw && dpHasRoughOpeningInputs(opts)) return 'rough opening size';
        if (!raw && !nk) {
            var list = Array.isArray(rows) ? rows : [];
            for (var ri = 0; ri < list.length; ri++) {
                var rowItem = list[ri];
                if (!rowItem || typeof rowItem === 'string') continue;
                var rowLab = dpNormalizeFieldKey((rowItem.label || rowItem.id || '') + '');
                if (rowLab === 'rough opening width' || rowLab === 'rough opening height') {
                    return 'rough opening size';
                }
            }
        }
        return nk;
    }

    function dpIsRoughOpeningMeasurementContext(opts, rows) {
        return dpIsRoughOpeningMeasurementKey(dpResolveMeasurementContextKey(opts, rows));
    }

    // Dp start 03-09 — only store/show Rough Opening W/H when front selected Rough Opening Size
    function dpWasRoughOpeningSelectedFromFront(opts, rows) {
        opts = opts || {};
        var raw = opts.measurement_type || opts['measurement-type'] || '';
        if (Array.isArray(raw)) raw = raw[0] || '';
        raw = String(raw || '').toLowerCase().replace(/-/g, '_');
        if (raw.indexOf('rough') !== -1) return true;
        var list = Array.isArray(rows) ? rows : [];
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            if (!item || typeof item === 'string') continue;
            var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
            var val = String(item.value != null ? item.value : item.display || '').toLowerCase();
            if (
                (lab === 'measurements' || lab === 'measurement type' || lab === 'how will you measure') &&
                val.indexOf('rough') !== -1
            ) {
                return true;
            }
            if (dpIsMeasurementTypeLabel(item.value) && val.indexOf('rough') !== -1) return true;
            if (dpIsMeasurementTypeLabel(item.label) && lab.indexOf('rough') !== -1) return true;
            // Dp merge code 10-09 start — summary already has Rough Opening Size/W/H (admin/liquid parity)
            if (
                (lab === 'rough opening size' || lab === 'rough opening width' || lab === 'rough opening height') &&
                String(item.value != null ? item.value : item.display || '').trim()
            ) {
                return true;
            }
            // Dp merge code 10-09 end
        }
        return false;
    }
    // Dp end 03-09

    function dpReadRoughOpeningWidthHeight(opts, rows) {
        opts = opts || {};
        rows = rows || [];
        var rw = dpCombineDimensionInchesLabel(
            dpReadOptKeys(opts, ['rough-width-int', 'rough_width_int', 'rough_opening_width']),
            dpReadOptKeys(opts, ['rough-width-frac', 'rough-width-frac_label', 'rough_width_frac', 'rough_width_fraction'])
        );
        var rh = dpCombineDimensionInchesLabel(
            dpReadOptKeys(opts, ['rough-height-int', 'rough_height_int', 'rough_opening_height']),
            // Dp merge code 10-09 start — live height frac before stale *_label
            dpReadOptKeys(opts, [
                'rough-height-frac',
                'rough_height_frac',
                'rough_height_fraction',
                'rough_height_fraction_value',
                'exact-door-height-frac',
                'exact_door_height_frac',
                'door_height_fraction_value',
                'door_height_fraction',
                'door_height_frac',
                'rough-height-frac_label',
                'exact-door-height-frac_label',
            ])
            // Dp merge code 10-09 end
        );
        // Dp merge code 10-09 start — repair when int+frac became stale 15/16 but setCombined is better
        if (rh && typeof dpRepairHeightIfStale1516 === 'function') {
            rh = dpRepairHeightIfStale1516(rh, opts, 'rough');
        }
        // Dp merge code 10-09 end
        (Array.isArray(rows) ? rows : []).forEach(function (item) {
            if (!item || typeof item === 'string') return;
            var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
            var val = String(item.value != null ? item.value : '').trim();
            if (!val) return;
            if (lab === 'rough opening width' && !rw) rw = val;
            if (lab === 'rough opening height' && !rh) rh = val;
        });
        return { rw: rw, rh: rh };
    }

    function dpInjectRoughOpeningDescriptionLines(outLines, opts, rows) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        // Dp start 03-09 — Rough Opening Size selected → combined Rough Opening Size: Ww x Hh (not separate W/H)
        if (!dpWasRoughOpeningSelectedFromFront(opts, rows)) {
            return outLines.filter(function (L) {
                return !/^Rough Opening (Width|Height|Size)\s*:/i.test(String(L || ''));
            });
        }
        if (typeof dpIsNonJambSlabOrBrickSetup === 'function' && dpIsNonJambSlabOrBrickSetup(opts, rows)) {
            return outLines.filter(function (L) {
                return !/^Rough Opening (Width|Height)\s*:/i.test(String(L || ''));
            });
        }
        // MERGE: rough_label_fix — jamb two-tab keeps Rough Opening Size (value is rough_opening_size)
        var sizeTitle09 = 'Rough Opening Size';
        var dims = dpReadRoughOpeningWidthHeight(opts, rows);
        outLines = outLines.filter(function (L) {
            return !/^Rough Opening (Width|Height)\s*:/i.test(String(L || ''));
        });
        var hasRoughSize = outLines.some(function (L) {
            return /^(Rough Opening Size|Finished Opening Size)\s*:/i.test(String(L || ''));
        });
        if (hasRoughSize || (!dims.rw && !dims.rh)) {
            // MERGE: rough_label_fix — keep Rough Opening Size title (do not rename to Finished)
            return outLines;
        }
        function dpRoughDimToken03(val, suffix) {
            var v = String(val || '')
                .replace(/\s*inches?\s*$/i, '')
                .replace(/\s+0$/i, '')
                .replace(/\s*[wh]$/i, '')
                .trim();
            return v ? v + suffix : '';
        }
        var tokens = [];
        if (dims.rw) tokens.push(dpRoughDimToken03(dims.rw, 'w'));
        if (dims.rh) tokens.push(dpRoughDimToken03(dims.rh, 'h'));
        if (!tokens.length) return outLines;
        var insert = [sizeTitle09 + ': ' + tokens.join(' x ')];
        // Dp end 03-09 / 09-09
        var anchor = -1;
        for (var i = 0; i < outLines.length; i++) {
            if (/^Panel Profile\s*:/i.test(String(outLines[i] || ''))) {
                anchor = i + 1;
                break;
            }
        }
        if (anchor < 0) {
            for (var j = 0; j < outLines.length; j++) {
                if (/^Stile and Rail Profile\s*:/i.test(String(outLines[j] || ''))) {
                    anchor = j + 1;
                    break;
                }
            }
        }
        if (anchor < 0) {
            for (var k = 0; k < outLines.length; k++) {
                if (/^(Door Thickness|Sidelight Thickness|Transom Thickness|Gate Thickness|Pre-?Hung Unit Depth|Exact Door Width)\s*:/i.test(String(outLines[k] || ''))) {
                    anchor = k;
                    break;
                }
            }
        }
        if (anchor < 0) return outLines.concat(insert);
        outLines.splice.apply(outLines, [anchor, 0].concat(insert));
        return outLines;
    }
    // Dp end 02-09

    // Dp start 02-09 — standalone Opening W/H rows collapse into one Rough/Finished Opening Size line
    function dpIsCollapsedOpeningDimLabel(label) {
        var k = dpNormalizeFieldKey(label || '');
        return (
            k === 'rough opening width' ||
            k === 'rough opening height' ||
            k === 'finished opening width' ||
            k === 'finished opening height'
        );
    }

    function dpStripRedundantOpeningDimensionRows(rows, opts) {
        rows = Array.isArray(rows) ? rows.slice() : [];
        opts = opts || {};
        var mtKey = dpNormalizeFieldKey(String(dpEffectiveMeasurementTypeKey(opts, rows) || '').replace(/_/g, ' '));
        var isFinishedMt = dpIsFinishedOpeningMeasurementKey(mtKey);
        var isRoughMt = mtKey === 'rough opening size' || mtKey === 'rough_opening_size';
        if (!isFinishedMt && !isRoughMt) return rows;
        return rows.filter(function (item) {
            if (!item) return false;
            if (typeof item === 'string') {
                var sm = String(item).match(/^([^:]+):/);
                return !dpIsCollapsedOpeningDimLabel(sm ? sm[1] : '');
            }
            return !dpIsCollapsedOpeningDimLabel((item.label || item.id || '') + '');
        });
    }

    function dpFilterRedundantOpeningDimensionLines(outLines, opts, rows) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        var hasRoughCombined = outLines.some(function (L) {
            return /^Rough Opening Size\s*:/i.test(String(L || ''));
        });
        var hasFinishedCombined = outLines.some(function (L) {
            return /^Finished Opening Size\s*:/i.test(String(L || ''));
        });
        return outLines.filter(function (L) {
            var s = String(L || '');
            if (/^Rough Opening Width\s*:/i.test(s) || /^Rough Opening Height\s*:/i.test(s)) {
                // Dp start 03-09 — Rough Opening Size selected → drop separate W/H when combined line exists
                return !hasRoughCombined;
                // Dp end 03-09
            }
            if (/^Finished Opening Width\s*:/i.test(s) || /^Finished Opening Height\s*:/i.test(s)) {
                return !hasFinishedCombined;
            }
            return true;
        });
    }

    function dpFilterFinishedOpeningSizeForRoughMt(outLines, opts, rows) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        // Dp start 03-09 — Finished Opening Size is Exact Door W/H; do not strip it for Rough Opening W/H
        return outLines;
        // Dp end 03-09
    }
    // Dp end 02-09

    // Dp start 02-09 — keep all measurement lines together after Panel Profile
    function dpIsQuoteDescMeasurementLine(line) {
        var m = String(line || '').match(/^([^:]+):/);
        if (!m) return false;
        var k = dpNormalizeFieldKey(m[1]);
        return (
            k === 'measurements' ||
            k === 'finished opening size' ||
            k === 'rough opening size' ||
            k === 'exact door size' ||
            k === 'jamb unit size' ||
            k === 'door thickness' ||
            k === 'exact door thickness' ||
            k === 'sidelight thickness' ||
            k === 'transom thickness' ||
            k === 'gate thickness' ||
            k === 'pre hung unit depth' ||
            k === 'pre-hung unit depth' ||
            // Dp merge code 10-09 start
            k === 'pre hung jamb width' ||
            k === 'pre-hung jamb width' ||
            k === 'prehung jamb width' ||
            // Dp merge code 10-09 end
            // Dp start VDN-390 23-10
            k === 'pre hung jamb depth' ||
            k === 'prehung jamb depth' ||
            // Dp end VDN-390 23-10
            k === 'exact door width' ||
            k === 'exact door height' ||
            k === 'rough opening width' ||
            k === 'rough opening height' ||
            k === 'finished opening width' ||
            k === 'finished opening height' ||
            k === 'exact sidelight width' ||
            k === 'sidelight width' ||
            k === 'exact sidelight height' ||
            k === 'sidelight height' ||
            // Dp start 03-09 — Gate / Sidelight / Transom Exact … Size in measurement block
            k === 'exact sidelight size' ||
            k === 'exact gate size' ||
            k === 'exact gate width' ||
            k === 'gate width' ||
            k === 'exact gate height' ||
            k === 'gate height' ||
            k === 'exact transom size' ||
            k === 'exact transom width' ||
            k === 'transom width' ||
            k === 'exact transom height' ||
            k === 'transom height' ||
            // Dp end 03-09
            k === 'brick molding'
        );
    }

    function dpMeasurementBlockLineRank(line) {
        var L = String(line || '');
        // Dp merge code 10-09 start — Finished Opening Size, then Exact Door Size, then Pre-hung / thickness
        if (/^Finished Opening Size\s*:/i.test(L)) return 0;
        if (/^Rough Opening Size\s*:/i.test(L)) return 1;
        if (/^Exact Door Size\s*:/i.test(L)) return 2;
        if (/^(Jamb Unit Size|Exact Gate Size|Exact Sidelight Size|Exact Transom Size)\s*:/i.test(L)) {
            return 3;
        }
        // Dp start VDN-390 23-10
        if (/^Pre-?Hung Unit Depth\s*:/i.test(L) || /^Pre-?hung\s+Jamb\s+(Depth|Width)\s*:/i.test(L)) return 4;
        // Dp end VDN-390 23-10
        if (/^Rough Opening Width\s*:/i.test(L)) return 5;
        if (/^Rough Opening Height\s*:/i.test(L)) return 6;
        if (/^(Exact Gate Width|Gate Width|Exact Gate Height|Gate Height)\s*:/i.test(L)) return 7;
        if (/^(Exact Sidelight Width|Sidelight Width|Exact Sidelight Height|Sidelight Height)\s*:/i.test(L)) return 7;
        if (/^(Exact Transom Width|Transom Width|Exact Transom Height|Transom Height)\s*:/i.test(L)) return 7;
        if (/^(Door Thickness|Sidelight Thickness|Transom Thickness|Gate Thickness|Exact Door Thickness)\s*:/i.test(L)) {
            return 8;
        }
        if (/^Exact Door Width\s*:/i.test(L)) return 9;
        if (/^Exact Door Height\s*:/i.test(L)) return 10;
        if (/^Brick Molding\s*:/i.test(L)) return 11;
        return 99;
        // Dp merge code 10-09 end
    }

    function dpEnsureMeasurementBlockAfterPanelProfile(outLines) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        var meas = [];
        var rest = [];
        outLines.forEach(function (L) {
            if (dpIsQuoteDescMeasurementLine(L)) meas.push(L);
            else rest.push(L);
        });
        if (!meas.length) return outLines;
        meas.sort(function (a, b) {
            return dpMeasurementBlockLineRank(a) - dpMeasurementBlockLineRank(b);
        });
        var anchor = -1;
        for (var i = 0; i < rest.length; i++) {
            if (/^Panel Profile\s*:/i.test(String(rest[i] || ''))) {
                anchor = i;
                break;
            }
        }
        if (anchor < 0) {
            for (var j = 0; j < rest.length; j++) {
                if (/^Stile and Rail Profile\s*:/i.test(String(rest[j] || ''))) {
                    anchor = j;
                    break;
                }
            }
        }
        if (anchor < 0) return outLines;
        rest.splice.apply(rest, [anchor + 1, 0].concat(meas));
        return rest;
    }

    function dpFilterRedundantExactDoorDimensionLines(outLines, opts, rows) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        var mtKey = dpNormalizeFieldKey(String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' '));
        // Dp merge code 10-09 start — jamb two-tab: keep Exact Door Size after Finished Opening Size
        var isJambTwo09 = typeof dpIsJambTwoTabMeasureMode === 'function' && dpIsJambTwoTabMeasureMode(opts, rows);
        if (isJambTwo09) {
            function dpExactSizeHasBothWh09(L) {
                var s = String(L || '');
                if (!/^Exact Door Size\s*:/i.test(s)) return false;
                // Require both …w and …h tokens (reject height-only / width-only)
                return /\d(?:\s+\d+\/\d+)?\s*w\b/i.test(s) && /\d(?:\s+\d+\/\d+)?\s*h\b/i.test(s);
            }
            var hasCompleteExactSize09 = outLines.some(dpExactSizeHasBothWh09);
            return outLines.filter(function (L) {
                var s = String(L || '');
                if (/^Exact Door Size\s*:/i.test(s)) {
                    // Drop incomplete Size so Width/Height can rebuild via ensure
                    return dpExactSizeHasBothWh09(s);
                }
                if (/^(Exact Door Width|Exact Door Height)\s*:/i.test(s)) {
                    return !hasCompleteExactSize09;
                }
                return true;
            });
        }
        // Dp merge code 10-09 end
        // Dp start 03-09 — hide Exact Door W/H when they already collapsed into Finished Opening Size
        // Dp merge code 10-09 start — keep combined Exact Door Size: Ww x Hh (only drop separate Width/Height)
        var hasFinishedOpeningSizeLine = outLines.some(function (L) {
            return /^Finished Opening Size\s*:/i.test(String(L || ''));
        });
        if (dpIsRoughOpeningMeasurementKey(mtKey) && hasFinishedOpeningSizeLine) {
            return outLines.filter(function (L) {
                return !/^(Exact Door Width|Exact Door Height)\s*:/i.test(String(L || ''));
            });
        }
        // Dp end 03-09 / 09-09
        if (dpIsRoughOpeningMeasurementKey(mtKey)) return outLines;
        var hasCombinedSize = outLines.some(function (L) {
            var s = String(L || '');
            return (
                /^Finished Opening Size\s*:/i.test(s) ||
                /^Jamb Unit Size\s*:/i.test(s) ||
                // Dp start 03-09
                /^Pre-Hung Unit Size\s*:/i.test(s)
                // Dp end 03-09
            );
        });
        if (!hasCombinedSize) return outLines;
        return outLines.filter(function (L) {
            // Dp merge code 10-09 start — do not strip Exact Door Size (needed after Finished Opening Size)
            return !/^(Exact Door Width|Exact Door Height)\s*:/i.test(String(L || ''));
            // Dp merge code 10-09 end
        });
    }

    // Dp start 03-09 — drop Gate / Sidelight / Transom W/H when Exact … Size line already exists
    function dpFilterRedundantExactComponentDimensionLines(outLines) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        var hasGateSize = outLines.some(function (L) {
            return /^Exact Gate Size\s*:/i.test(String(L || ''));
        });
        var hasSidelightSize = outLines.some(function (L) {
            return /^Exact Sidelight Size\s*:/i.test(String(L || ''));
        });
        var hasTransomSize = outLines.some(function (L) {
            return /^Exact Transom Size\s*:/i.test(String(L || ''));
        });
        return outLines.filter(function (L) {
            var s = String(L || '');
            if (hasGateSize && /^(Exact\s+)?Gate\s+(Width|Height)\s*:/i.test(s)) return false;
            if (hasSidelightSize && /^(Exact\s+)?Sidelight\s+(Width|Height)\s*:/i.test(s)) return false;
            if (hasTransomSize && /^(Exact\s+)?Transom\s+(Width|Height)\s*:/i.test(s)) return false;
            return true;
        });
    }
    // Dp end 03-09

    // Dp merge code 10-09 start — ensure Exact Sidelight Width / Exact Transom Height from live opts (admin parity)
    function dpEnsureExactSidelightWidthAndTransomHeightLines(outLines, opts, rows) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        opts = opts || {};
        rows = rows || [];
        var mt = '';
        try {
            mt = dpNormalizeFieldKey(String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' '));
        } catch (eMtSlTr09) { }

        function stripDimTok(v) {
            return String(v == null ? '' : v)
                .replace(/\s*inches?\s*$/i, '')
                .replace(/\s*[wh]$/i, '')
                .replace(/\s+0$/i, '')
                .trim();
        }
        function hasLine(re) {
            return outLines.some(function (L) {
                return re.test(String(L || ''));
            });
        }
        function insertAfterAnchor(line, anchors) {
            if (!line) return;
            var at = -1;
            var ai;
            for (ai = 0; ai < anchors.length; ai++) {
                var reA = anchors[ai];
                for (var i = 0; i < outLines.length; i++) {
                    if (reA.test(String(outLines[i] || ''))) {
                        at = i;
                        break;
                    }
                }
                if (at >= 0) break;
            }
            if (at < 0) outLines.push(line);
            else outLines.splice(at + 1, 0, line);
        }

        // Exact Sidelight Size mode already shows combined Size — do not also force Width
        // Gate products: never inject sidelight/transom lines
        var colSlTr09 = String(
            opts._route_collection || opts._collection_handle || opts._product_type || ''
        ).toLowerCase();
        if (mt === 'exact gate size' || colSlTr09.indexOf('gate') !== -1) {
            outLines = outLines.filter(function (L) {
                var s = String(L || '');
                return (
                    !/^(Exact\s+)?Sidelight\s+(Width|Height|Size)\s*:/i.test(s) &&
                    !/^(Exact\s+)?Transom\s+(Width|Height|Size)\s*:/i.test(s)
                );
            });
            return outLines;
        }

        if (mt !== 'exact sidelight size') {
            // Convert leftover Exact Sidelight Size → Width/Height when not sidelight-only mt
            var rebuiltSl = [];
            var droppedSlSize = false;
            for (var si = 0; si < outLines.length; si++) {
                var sL = String(outLines[si] || '');
                var sm = sL.match(/^Exact Sidelight Size\s*:\s*(.+)$/i);
                if (!sm) {
                    rebuiltSl.push(outLines[si]);
                    continue;
                }
                droppedSlSize = true;
                var sBody = String(sm[1] || '').trim();
                var swM = sBody.match(/(\d+(?:\s+\d+\/\d+)?|\d+\/\d+|\d+(?:\.\d+)?)\s*w\b/i);
                var shM = sBody.match(/(\d+(?:\s+\d+\/\d+)?|\d+\/\d+|\d+(?:\.\d+)?)\s*h\b/i);
                if (swM) rebuiltSl.push('Exact Sidelight Width: ' + stripDimTok(swM[1]) + 'w');
                if (shM) rebuiltSl.push('Exact Sidelight Height: ' + stripDimTok(shM[1]) + 'h');
                if (!swM && !shM && sBody) {
                    rebuiltSl.push('Exact Sidelight Width: ' + stripDimTok(sBody) + 'w');
                }
            }
            if (droppedSlSize) outLines = rebuiltSl;

            if (!hasLine(/^(Exact\s+)?Sidelight\s+Width\s*:/i) && !hasLine(/^Exact Sidelight Size\s*:/i)) {
                var slw = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, [
                        'sidelight_width',
                        'sidelight_width_int',
                        'sidelight-width',
                        'sidelight-width-int',
                        'sidelight-sidelight-width-int',
                        'sidelight_sidelight_width_int',
                        'sidelight_width_combined',
                    ]),
                    dpReadOptKeys(opts, [
                        'sidelight_width_fraction',
                        'sidelight_width_frac',
                        'sidelight-width-frac',
                        'sidelight-width-fraction',
                        'sidelight-sidelight-width-frac',
                        'sidelight_sidelight_width_frac',
                        'sidelight_sidelight_width_fraction',
                    ])
                );
                slw = stripDimTok(slw);
                if (slw) {
                    insertAfterAnchor('Exact Sidelight Width: ' + slw + 'w', [
                        /^Exact Door Size\s*:/i,
                        /^Jamb Unit Size\s*:/i,
                        /^Rough Opening Size\s*:/i,
                        /^Finished Opening Size\s*:/i,
                        /^Panel Profile\s*:/i,
                        /^Stile and Rail Profile\s*:/i,
                    ]);
                }
            }
        }

        if (mt !== 'exact transom size') {
            var rebuiltTr = [];
            var droppedTrSize = false;
            for (var ti = 0; ti < outLines.length; ti++) {
                var tL = String(outLines[ti] || '');
                var tm = tL.match(/^Exact Transom Size\s*:\s*(.+)$/i);
                if (!tm) {
                    rebuiltTr.push(outLines[ti]);
                    continue;
                }
                droppedTrSize = true;
                var tBody = String(tm[1] || '').trim();
                var twM = tBody.match(/(\d+(?:\s+\d+\/\d+)?|\d+\/\d+|\d+(?:\.\d+)?)\s*w\b/i);
                var thM = tBody.match(/(\d+(?:\s+\d+\/\d+)?|\d+\/\d+|\d+(?:\.\d+)?)\s*h\b/i);
                if (twM) rebuiltTr.push('Exact Transom Width: ' + stripDimTok(twM[1]) + 'w');
                if (thM) rebuiltTr.push('Exact Transom Height: ' + stripDimTok(thM[1]) + 'h');
                if (!twM && !thM && tBody) {
                    rebuiltTr.push('Exact Transom Height: ' + stripDimTok(tBody) + 'h');
                }
            }
            if (droppedTrSize) outLines = rebuiltTr;

            if (!hasLine(/^(Exact\s+)?Transom\s+Height\s*:/i) && !hasLine(/^Exact Transom Size\s*:/i)) {
                var th = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, [
                        'panel_transom_height_int',
                        'panel-transom-height-int',
                        'panel_transom_height',
                        'transom_height_int',
                        'transom-height-int',
                        'transom_height',
                        'transom_height_combined',
                    ]),
                    dpReadOptKeys(opts, [
                        'panel_transom_height_frac',
                        'panel_transom_height_fraction',
                        'panel-transom-height-frac',
                        'panel-transom-height-fraction',
                        'transom_height_frac',
                        'transom_height_fraction',
                        'transom-height-frac',
                    ])
                );
                th = stripDimTok(th);
                if (th) {
                    insertAfterAnchor('Exact Transom Height: ' + th + 'h', [
                        /^Exact Sidelight Width\s*:/i,
                        /^Exact Sidelight Height\s*:/i,
                        /^Exact Sidelight Size\s*:/i,
                        /^Exact Door Size\s*:/i,
                        /^Jamb Unit Size\s*:/i,
                        /^Panel Profile\s*:/i,
                    ]);
                }
            }
        }

        return outLines;
    }
    // Dp merge code 10-09 end
    // Dp end 02-09

    // Dp start 02-09 — Slab / Brick Molding: only Finished Opening tab is visible; stored token may still be rough_opening_size
    function dpResolveDoorSetupValue(opts, rows) {
        opts = opts || {};
        var setup = String(opts.door_setup || opts.pre_hung || '').trim();
        if (!setup && Array.isArray(rows)) {
            for (var dsi = 0; dsi < rows.length; dsi++) {
                var dRow = rows[dsi];
                if (!dRow || typeof dRow === 'string') continue;
                var dLab = dpNormalizeFieldKey((dRow.label || dRow.id || '') + '');
                if (dLab === 'door setup' || dLab === 'pre hung' || dLab === 'prehung') {
                    setup = String((dRow.value != null ? dRow.value : dRow.display) || '').trim();
                    break;
                }
            }
        }
        return setup;
    }

    function dpIsPreHungOnDoorJambSetup(setup) {
        var s = String(setup || '').toLowerCase();
        // Dp start 03-09 — pre_hung_on_jamb / pre-hung-on-jamb are still Pre-Hung on Jamb
        s = s.replace(/[_-]+/g, ' ');
        // Dp end 03-09
        if (!s) return false;
        if (s.indexOf('brick') !== -1) return false;
        if (s.indexOf('slab') !== -1 && s.indexOf('only') !== -1) return false;
        if ((s.indexOf('pre-hung') !== -1 || s.indexOf('pre hung') !== -1) && s.indexOf('jamb') !== -1) return true;
        if (s.indexOf('door jamb') !== -1) return true;
        return false;
    }

    function dpIsNonJambSlabOrBrickSetup(opts, rows) {
        var setup = dpResolveDoorSetupValue(opts, rows);
        if (!setup) return false;
        return !dpIsPreHungOnDoorJambSetup(setup);
    }
    // Dp end 02-09

    // Dp merge code 10-09 start — Pre-Hung on Jamb + sidelight/transom (Exact + Finished Opening tabs)
    function dpHasActiveSidelightOrTransom(opts, rows) {
        opts = opts || {};
        rows = Array.isArray(rows) ? rows : [];
        function isActive(v) {
            v = String(v == null ? '' : v).toLowerCase().trim();
            if (!v) return false;
            if (v === 'none' || v === 'no' || v === 'n/a' || v === 'n_a') return false;
            if (v.indexOf('none') === 0) return false;
            return true;
        }
        var keys = [
            'sidelight_location', 'sidelight-location', 'sidelight_style', 'sidelight_design',
            'transom_style', 'transom_design', 'transom_count', 'single_or_double_transom',
        ];
        for (var i = 0; i < keys.length; i++) {
            var v = dpReadOptKeys(opts, [keys[i]]);
            if (isActive(v)) return true;
        }
        for (var r = 0; r < rows.length; r++) {
            var item = rows[r];
            if (!item || typeof item === 'string') continue;
            var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
            var val = String(item.value != null ? item.value : item.display || '');
            if (
                (lab === 'sidelight location' || lab === 'sidelight style' || lab === 'sidelight design'
                    || lab === 'transom style' || lab === 'transom design' || lab === 'transom count'
                    || lab === 'single or double transom')
                && isActive(val)
            ) {
                return true;
            }
        }
        return false;
    }

    function dpIsJambTwoTabMeasureMode(opts, rows) {
        if (typeof dpIsPreHungOnDoorJambSetup !== 'function') return false;
        if (!dpIsPreHungOnDoorJambSetup(dpResolveDoorSetupValue(opts, rows))) return false;
        return dpHasActiveSidelightOrTransom(opts, rows);
    }
    // Dp merge code 10-09 end

    // Dp start 02-09 — human-readable title from saved measurement_type (quote description label)
    function dpResolveMeasurementTypeDisplayLabel(opts, rows) {
        opts = opts || {};
        rows = rows || null;
        var raw = opts.measurement_type || opts['measurement-type'] || '';
        if (Array.isArray(raw)) raw = raw[0] || '';
        raw = String(raw || '').trim();
        if (!raw) return '';
        var token = String(raw).replace(/-/g, '_').toLowerCase();
        if (token === 'rough_opening_size' && dpIsNonJambSlabOrBrickSetup(opts, rows)) {
            return 'Finished Opening Size';
        }
        // MERGE: rough_label_fix — jamb two-tab keeps Rough Opening Size (matches radio value + marketing copy)
        var measMap = {
            jamb_unit_size: 'Jamb Unit Size',
            pre_hung_unit_size: 'Pre-Hung Unit Size',
            exact_door_size: 'Exact Door Size',
            rough_opening_size: 'Rough Opening Size',
            finished_opening_size: 'Finished Opening Size',
            finished_opening: 'Finished Opening Size',
            exact_sidelight_size: 'Exact Sidelight Size',
            exact_transom_size: 'Exact Transom Size',
            exact_gate_size: 'Exact Gate Size',
            exact_panel_size: 'Exact Panel Size',
        };
        if (measMap[token]) return measMap[token];
        if (dpIsMeasurementTypeLabel(raw)) return String(raw).trim();
        if (/^[a-z0-9]+(?:_[a-z0-9]+)+$/i.test(raw) && typeof dpHumanizeFieldLabel === 'function') {
            return dpHumanizeFieldLabel(raw);
        }
        return String(raw).trim();
    }
    // Dp end 02-09

    function dpStripDimLineLabel(line) {
        line = String(line == null ? '' : line).trim();
        var m = line.match(/^([^:]+):\s*([\s\S]+)$/);
        if (!m) return line;
        var label = String(m[1]).trim();
        var rest = String(m[2]).trim();
        if (!rest || !/\b(size|opening|width|height|thickness)\b/i.test(label)) return line;
        if (dpIsMeasurementTypeLabel(label)) return line;
        var bits = rest.split(/\s+\/\s+/);
        for (var i = 0; i < bits.length; i++) {
            if (!dpIsDimToken(bits[i])) return line;
        }
        return rest;
    }

    function dpJoinDescriptionPartsMultiline(parts) {
        var out = [];
        var dimBuf = [];
        function flushDim() {
            if (!dimBuf.length) return;
            var tokens = [];
            for (var d = 0; d < dimBuf.length; d++) {
                var cur = String(dimBuf[d] || '').trim();
                if (!cur) continue;
                var mm = cur.match(/^[^:]+:\s*([\s\S]+)$/);
                if (mm && dpIsDimToken(String(mm[1]).trim())) tokens.push(String(mm[1]).trim());
                else tokens.push(cur);
            }
            dimBuf = [];
            if (!tokens.length) return;
            // Dp start 25-08 — Exact Door Size style: 36w x 80h x 1 1/2t
            var line = tokens.join(' x ');
            out.push(line);
        }
        for (var i = 0; i < parts.length; i++) {
            var p = String(parts[i] == null ? '' : parts[i]).trim();
            if (!p) continue;
            var peel = p.match(/^([^:]+):\s*([\s\S]+)$/);
            if (peel && dpIsMeasurementTypeLabel(String(peel[1]).trim())) {
                flushDim();
                var title = String(peel[1]).trim();
                var rest = String(peel[2]).trim();
                if (title) out.push(title);
                if (rest && dpIsDimToken(rest)) {
                    dimBuf.push(rest);
                    continue;
                }
                p = rest || '';
                if (!p) continue;
            }
            if (dpIsDimToken(p)) {
                dimBuf.push(p);
                continue;
            }
            flushDim();
            if (p.indexOf(' / ') !== -1) {
                var peel2 = p.match(/^([^:]+):\s*([\s\S]+)$/);
                if (peel2 && dpIsMeasurementTypeLabel(String(peel2[1]).trim())) {
                    var title2 = String(peel2[1]).trim();
                    if (title2) out.push(title2);
                    p = String(peel2[2]).trim();
                }
                p = dpStripDimLineLabel(p);
                var bits = p.split(/\s+\/\s+/);
                var allDim = bits.length > 0;
                for (var b = 0; b < bits.length; b++) {
                    if (!dpIsDimToken(bits[b])) {
                        allDim = false;
                        break;
                    }
                }
                if (allDim) {
                    dimBuf = bits;
                    flushDim();
                    continue;
                }
            } else {
                if (!dpIsMeasurementTypeLabel(p)) {
                    p = dpStripDimLineLabel(p);
                }
                if (dpIsDimToken(p)) {
                    dimBuf.push(p);
                    continue;
                }
            }
            var nv = dpIsMeasurementTypeLabel(p) ? p : dpNormalizeDescriptionValue(p);
            if (nv) out.push(nv);
        }
        flushDim();
        return out.filter(Boolean).join('\n');
    }

    function dpFormatDescriptionMultiline(text) {
        text = String(text == null ? '' : text)
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .trim();
        if (!text) return '';
        var lines = text.split('\n');
        var out = [];
        for (var i = 0; i < lines.length; i++) {
            var line = String(lines[i] || '').trim();
            if (!line) continue;
            if (line.indexOf(' / ') !== -1) {
                var converted = dpJoinDescriptionPartsMultiline(line.split(/\s+\/\s+/));
                if (converted) {
                    var parts = converted.split('\n');
                    for (var p = 0; p < parts.length; p++) {
                        var piece = dpNormalizeDescriptionValue(parts[p]);
                        if (piece) out.push(piece);
                    }
                    continue;
                }
            }
            var one = dpNormalizeDescriptionValue(line);
            if (one) out.push(one);
        }
        return out.join('\n');
    }

    function dpDescriptionLinesHtml(text, expanded) {
        text = dpFormatDescriptionMultiline(text);
        if (!text) return '';
        var segs = text
            .split('\n')
            .map(function (s) {
                return dpNormalizeDescriptionValue(s);
            })
            .filter(Boolean);
        // Dp start 26-08 — de-dupe + bold labels
        var uniq = [];
        var seenSeg = {};
        segs.forEach(function (seg) {
            var sk = dpNormalizeFieldKey(seg);
            if (!sk) return;
            // Dp start 27-08 — keep both hardware Qty and casing Qty even when the number matches
            // Dp start 03-09 — keep repeated Hardware N / Finish / Hardware Qty lines for multi hardware
            if (seenSeg[sk]) {
                if (
                    /^qty\s*:/i.test(seg) ||
                    /^hardware\s+\d+\s*:/i.test(seg) ||
                    /^hardware\s+\d+\s+(qty|finish|closer color|door thickness|function|swing direction)\s*:/i.test(seg) ||
                    /^hardware qty\s*:/i.test(seg) ||
                    /^finish\s*:/i.test(seg) ||
                    /^closer color\s*:/i.test(seg) ||
                    /^hardware function\s*:/i.test(seg) ||
                    /^hardware swing direction\s*:/i.test(seg) ||
                    /^hardware door thickness\s*:/i.test(seg)
                ) {
                    sk = sk + '|' + uniq.length;
                } else {
                    return;
                }
            }
            // Dp end 03-09
            // Dp end 27-08
            seenSeg[sk] = true;
            uniq.push(seg);
        });
        segs = uniq;
        if (!segs.length) return '';
        var limit = expanded ? segs.length : Math.min(3, segs.length);
        var html = '';
        for (var i = 0; i < limit; i++) {
            html +=
                '<li>' +
                (typeof dpLabeledDescriptionLineToHtml === 'function'
                    ? dpLabeledDescriptionLineToHtml(segs[i])
                    : escapeHtml(segs[i])) +
                '</li>';
        }
        return { html: html, segs: segs, truncated: !expanded && segs.length > 3 };
        // Dp end 26-08
    }
    // Dp end 20-08 / 21-08

    /** Trailing zero fraction: "50 0" -> "50", "36 0" -> "36". */
    function tidyMeasure(v) {
        var s = String(v == null ? '' : v).trim();
        return s.replace(/\s+0$/, '');
    }

    function collectQuoteDescriptionRows(item) {
        var opts = (item && item.options) || {};
        var rows = item && item.selected_summary;
        if (!Array.isArray(rows) || !rows.length) {
            rows = opts._selected_summary && Array.isArray(opts._selected_summary) ? opts._selected_summary : [];
        }
        rows = Array.isArray(rows) ? rows.slice() : [];
        rows = mergeInsertsAdditionalOptionsIntoSummaryRows(rows, opts);
        rows = enrichHardwareSummaryRows(rows, opts);
        rows = dpMergePanelUnitEnclosureSummaryRows(rows, opts);
        rows = dpMergeExtraOptionsIntoSummaryRows(rows, opts);
        return rows;
    }

    // Dp start 24-08 — description as "Label : Value" from selected items (product-page order, skip unselected, no repeat fields)
    function dpNormalizeFieldKey(label) {
        return String(label == null ? '' : label)
            .toLowerCase()
            .replace(/[_-]+/g, ' ')
            .replace(/[^\w\s]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function dpHumanizeFieldLabel(label) {
        var s = String(label == null ? '' : label).trim();
        if (!s) return '';
        // --- Dp start 01-09 (quote description display labels) ---
        var nk = dpNormalizeFieldKey(s);
        if (nk === 'select your sidelight style') return 'Sidelight Style';
        if (nk === 'door backset') return 'Hardware Backset';
        // --- Dp end 01-09 (quote description display labels) ---
        if (/^[a-z0-9]+(?:_[a-z0-9]+)+$/.test(s)) {
            return s.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
                return c.toUpperCase();
            });
        }
        return s;
    }

    function dpSplitSelectedRow(row) {
        if (row == null) return { label: '', value: '' };
        if (typeof row === 'string') {
            var s = String(row).trim();
            var m = s.match(/^([^:]+):\s*([\s\S]+)$/);
            if (m) {
                var lab = String(m[1]).trim();
                var rest = String(m[2]).trim();
                if (lab && rest && !/^https?$/i.test(lab) && !dpIsDimToken(lab)) {
                    return { label: lab, value: rest };
                }
            }
            return { label: '', value: s };
        }
        return {
            label: String((row && (row.label || row.id)) || '').trim(),
            value: String((row && (row.value != null ? row.value : row.display || row.name)) || '').trim(),
        };
    }

    function dpTidyLabeledValue(value) {
        var v = String(value == null ? '' : value).trim();
        if (!v) return '';
        v = v.replace(/\s+\/\s*$/, '').trim();
        var exp = v.match(/^(Full Exposure|Partial Exposure|Protected Location)\b/i);
        if (exp) {
            var map = {
                'full exposure': 'Full Exposure',
                'partial exposure': 'Partial Exposure',
                'protected location': 'Protected Location',
            };
            v = map[String(exp[1]).toLowerCase()] || exp[1];
        }
        // Dp start 25-08 — saved match display values
        if (/^(add\s+beveled\s+glass|bevel(?:ed)?\s+glass)$/i.test(v)) {
            v = 'Beveled Glass';
        }
        if (/\bUpgrade\b/i.test(v) && !/\*Upgrade\*/i.test(v)) {
            v = v.replace(/\bUpgrade\b/i, '*Upgrade*');
        }
        // Strip measurement suffix noise so thickness token stays e.g. 2 1/4t
        v = v.replace(/\s+Premium\s+Thickness\b.*/i, '').trim();
        v = v.replace(/\s+Thickness\s+Upgrade\b.*/i, '').trim();
        // Dp end 25-08
        // Dp start 24-08 — humanize raw measurement_type tokens (e.g. jamb_unit_size)
        if (/^[a-z0-9]+(?:_[a-z0-9]+)+$/.test(v)) {
            var measMap = {
                jamb_unit_size: 'Jamb Unit Size',
                pre_hung_unit_size: 'Pre-Hung Unit Size',
                exact_door_size: 'Exact Door Size',
                rough_opening_size: 'Rough Opening Size',
                finished_opening_size: 'Finished Opening Size',
                exact_sidelight_size: 'Exact Sidelight Size',
                exact_transom_size: 'Exact Transom Size',
                exact_gate_size: 'Exact Gate Size',
                exact_panel_size: 'Exact Panel Size',
            };
            if (measMap[v]) {
                v = measMap[v];
            } else {
                v = dpHumanizeFieldLabel(v);
            }
        }
        // Dp end 24-08
        return v;
    }

    function dpFormatLabeledDescriptionLine(label, value) {
        // Only list when a real selected value exists (empty / none / not selected → omit entirely).
        var cleanVal = dpTidyLabeledValue(value);
        if (!cleanVal) return '';
        if (!dpIsSelectedOptionValue(cleanVal)) return '';
        if (/^https?:\/\//i.test(cleanVal) || /^\[object object\]$/i.test(cleanVal)) return '';
        label = dpHumanizeFieldLabel(label);
        // Dp start 25-08 — Expected Shopify: selective Label: Value (keep others value-only)
        var nk = dpNormalizeFieldKey(label);
        // Never list cart Qty mid-description (appended last via dpAppendQuantityToDescriptionText)
        if (nk === 'quantity') {
            return '';
        }
        // Dp start 27-08 — hardware / casing selected qty
        // Dp start 03-09 — keep Hardware N Qty / Finish / … (do not collapse to bare Qty/Finish)
        var hwNumFmt = nk.match(/^hardware\s+(\d+)(?:\s+(.+))?$/);
        if (hwNumFmt) {
            var hn = hwNumFmt[1];
            var hrest = String(hwNumFmt[2] || '').trim();
            if (!hrest) return 'Hardware ' + hn + ': ' + cleanVal;
            if (hrest === 'qty' || hrest === 'quantity') return 'Hardware ' + hn + ' Quantity: ' + cleanVal;
            if (hrest === 'closer color') return 'Hardware ' + hn + ' Closer Color: ' + cleanVal;
            if (hrest === 'door thickness' || hrest === 'hardware door thickness') {
                if (typeof dpFormatHardwareThicknessToken === 'function') {
                    cleanVal = dpFormatHardwareThicknessToken(cleanVal);
                }
                cleanVal = String(cleanVal || '').trim();
                if (!cleanVal) return '';
                return 'Hardware ' + hn + ' Door Thickness: ' + cleanVal;
            }
            if (hrest === 'finish') return 'Hardware ' + hn + ' Finish: ' + cleanVal;
            if (hrest === 'function' || hrest === 'hardware function') {
                return 'Hardware ' + hn + ' Function: ' + cleanVal;
            }
            if (/swing/.test(hrest)) return 'Hardware ' + hn + ' Swing Direction: ' + cleanVal;
            return (
                'Hardware ' +
                hn +
                ' ' +
                hrest.replace(/\b\w/g, function (c) {
                    return c.toUpperCase();
                }) +
                ': ' +
                cleanVal
            );
        }
        // Dp end 03-09
        if (nk === 'hardware qty' || nk === 'hardware quantity') {
            return 'Hardware Quantity: ' + cleanVal;
        }
        // Dp merge code 10-09 start — keep Casing prefix on length / qty (like Hardware N Qty)
        if (nk === 'casing qty' || nk === 'casing quantity') {
            return 'Casing Qty: ' + cleanVal;
        }
        if (nk === 'casing length') {
            return 'Casing Length: ' + cleanVal;
        }
        // Dp merge code 10-09 end
        if (nk === 'qty') {
            return '';
        }
        // Dp end 27-08
        // Dp start 02-09 — humanize stored door_unit_design tokens; show Single Door when labeled
        if (nk === 'door unit design') {
            if (/^single_door$/i.test(cleanVal)) cleanVal = 'Single Door';
            else if (/^double_door$/i.test(cleanVal)) cleanVal = 'Double Door';
        }
        // Dp start 26-08 — omit primary design rows from quote description (edited elsewhere / not list details)
        // Dp start 27-08 — show all selected fields (including defaults). Hide only bare unlabeled "Single Door".
        if (/^single[\s_-]*door$/i.test(cleanVal) && !label) {
            return '';
        }
        // Dp end 02-09
        /*
        if (
          nk === 'door unit design' ||
          nk === 'door setup' ||
          nk === 'stile and rail profile' ||
          nk === 'screen & storm inserts' ||
          nk === 'screen and storm inserts' ||
          nk === 'screen storm inserts'
        ) {
          return '';
        }
        */
        // Dp end 27-08
        // Dp end 26-08
        // --- Dp start 01-09 (quote description: label bare bevel / hinge value-only rows) ---
        if (!label) {
            if (/^beveled glass$/i.test(cleanVal)) return 'Beveled Glass: ' + cleanVal;
            if (/hinges?$/i.test(cleanVal) && !/^verify finish$/i.test(cleanVal)) {
                return 'Hinge Finish: ' + cleanVal;
            }
            return cleanVal;
        }
        // --- Dp end 01-09 ---
        // --- Dp start 01-09 (quote description: always Label: Value for bevel / hinge) ---
        if (nk === 'beveled glass' || nk === 'glass bevel' || nk === 'bevel glass' || nk === 'add beveled glass') {
            return 'Beveled Glass: ' + cleanVal;
        }
        // --- Dp end 01-09 (quote description: always Label: Value for bevel / hinge) ---
        if (nk === dpNormalizeFieldKey(cleanVal)) {
            // --- Dp start 01-09 — keep Label: Value when label matches value (Beveled Glass, etc.) ---
            if (nk === 'beveled glass' || nk === 'glass bevel' || nk === 'bevel glass') {
                return 'Beveled Glass: ' + cleanVal;
            }
            // --- Dp end 01-09 ---
            return cleanVal;
        }
        // Dp start 03-09 — Porch Door #N: full Label: Value sequence (Swing → Hinge → Lockset Preparation)
        // Keep Opening prefix so Panel Opening #2 Door #1 matches other porch fields.
        if (typeof dpParsePorchDoorField === 'function') {
            var porchDoor = dpParsePorchDoorField(label);
            if (porchDoor) {
                var openingPrefixDoor = typeof dpExtractOpeningPrefix === 'function' ? dpExtractOpeningPrefix(label) : '';
                if (porchDoor.f === 0) {
                    return openingPrefixDoor + 'Door #' + porchDoor.n + ' Swing Direction: ' + cleanVal;
                }
                if (porchDoor.f === 1) {
                    return openingPrefixDoor + 'Door #' + porchDoor.n + ' Hinge Finish: ' + cleanVal;
                }
                if (porchDoor.f === 2) {
                    return openingPrefixDoor + 'Door #' + porchDoor.n + ' Lockset Preparation: ' + cleanVal;
                }
            }
        }
        var porchDoorMatch = nk.match(
            /^(?:(?:porch|panel)\s+opening\s*#?\s*\d+\s+)?door\s*#?\s*(\d+)\s+(swing direction|hinge finish|lockset preparation|lockset prep)$/
        );
        if (porchDoorMatch) {
            var porchFieldTitle =
                porchDoorMatch[2] === 'lockset prep' || porchDoorMatch[2] === 'lockset preparation'
                    ? 'Lockset Preparation'
                    : porchDoorMatch[2] === 'swing direction'
                        ? 'Swing Direction'
                        : porchDoorMatch[2] === 'hinge finish'
                            ? 'Hinge Finish'
                            : porchDoorMatch[2].replace(/\b\w/g, function (c) {
                                return c.toUpperCase();
                            });
            var openingPrefixMatch = typeof dpExtractOpeningPrefix === 'function' ? dpExtractOpeningPrefix(label) : '';
            return openingPrefixMatch + 'Door #' + porchDoorMatch[1] + ' ' + porchFieldTitle + ': ' + cleanVal;
        }
        // Dp end 03-09
        // Dp end 25-08
        // Dp start 03-09 — force Select Storm Glass → Storm Glass
        if (nk === 'select storm glass' || nk === 'storm glass' || nk === 'storm glass type') {
            return 'Storm Glass: ' + cleanVal;
        }
        // Dp end 03-09
        // Dp start 02-09 — storefront: omit Hinge Finish when unselected (Verify Finish is admin-only)
        if (nk === 'hinge finish') {
            if (/^verify finish$/i.test(cleanVal)) return '';
            var hingeDisplay = /hinges?$/i.test(cleanVal) ? cleanVal : cleanVal + ' Hinges';
            return 'Hinge Finish: ' + hingeDisplay;
        }
        // Dp end 02-09
        var explainMap = {
            'sdl profile': 'SDL',
            sdl: 'SDL',
            finish: 'Hardware Finish',
            'hardware finish': 'Hardware Finish',
            'closer color': 'Closer Color',
            'hardware function': 'Hardware Function',
            // Dp start 27-08
            'hardware swing direction': 'Hardware Swing Direction',
            // Dp end 27-08
            'hardware door thickness': 'Hardware Door Thickness',
            'door thickness': 'Door Thickness',
            length: 'Length',
            'custom length': 'Length',
            'millwork length': 'Length',
            'custom thickness': 'Thickness',
            'millwork custom thickness': 'Thickness',
            'exact sidelight width': 'Exact Sidelight Width',
            'sidelight width': 'Sidelight Width',
            'exact sidelight height': 'Exact Sidelight Height',
            'sidelight height': 'Sidelight Height',
            'exact sidelight size': 'Exact Sidelight Size',
            // Dp start 03-09 — Transom / Gate Width / Height → Exact … Size collapse
            'exact transom width': 'Exact Transom Width',
            'transom width': 'Transom Width',
            'exact transom height': 'Exact Transom Height',
            'transom height': 'Transom Height',
            'exact transom size': 'Exact Transom Size',
            'exact gate width': 'Exact Gate Width',
            'gate width': 'Gate Width',
            'exact gate height': 'Exact Gate Height',
            'gate height': 'Gate Height',
            'exact gate size': 'Exact Gate Size',
            // Dp end 03-09
            // Dp start VDN-390 23-10
            'pre hung unit depth': 'Pre-hung Jamb Depth',
            'pre-hung unit depth': 'Pre-hung Jamb Depth',
            'prehung unit depth': 'Pre-hung Jamb Depth',
            'pre hung jamb width': 'Pre-hung Jamb Depth',
            'pre-hung jamb width': 'Pre-hung Jamb Depth',
            'prehung jamb width': 'Pre-hung Jamb Depth',
            'pre hung jamb depth': 'Pre-hung Jamb Depth',
            'pre-hung jamb depth': 'Pre-hung Jamb Depth',
            'prehung jamb depth': 'Pre-hung Jamb Depth',
            // Dp end VDN-390 23-10
            // Dp start 26-08 — labeled Exact Door Width / Height / Thickness on quote cart
            'exact door width': 'Exact Door Width',
            'exact door height': 'Exact Door Height',
            // Dp start 26-08 — always "Door Thickness" (never duplicate Exact Door Thickness)
            'exact door thickness': 'Door Thickness',
            // Dp end 26-08
            'door width': 'Exact Door Width',
            'door height': 'Exact Door Height',
            // Dp end 26-08
            'exact door size': 'Exact Door Size',
            'rough opening size': 'Rough Opening Size',
            'finished opening size': 'Finished Opening Size',
            'first opening size': 'First Opening Size',
            'second opening size': 'Second Opening Size',
            // Dp start 25-08 — previously rendered bare/unlabeled and ambiguous on their own
            'transom thickness': 'Transom Thickness',
            'sidelight thickness': 'Sidelight Thickness',
            'gate thickness': 'Gate Thickness',
            'panels per opening': 'Panels per Opening',
            'add trim system': 'Add Trim System',
            'sill width': 'Sill',
            // Dp end 25-08
            // Dp start 26-08 — explain Label: Value for common option rows (order unchanged)
            'door unit design': 'Door Unit Design',
            'select wood': 'Wood',
            wood: 'Wood',
            'wood species': 'Wood',
            'screen & storm inserts': 'Screen & Storm',
            'screen and storm inserts': 'Screen & Storm',
            'select screen type': 'Screen Type',
            // Dp start 03-09 — Select Storm Glass → Storm Glass
            'select storm glass': 'Storm Glass',
            'storm glass': 'Storm Glass',
            'storm glass type': 'Storm Glass',
            // Dp end 03-09
            'insert frame color': 'Insert Frame Color',
            'door setup': 'Door Setup',
            'stile and rail profile': 'Stile and Rail Profile',
            'panel profile': 'Panel Profile',
            'where will the door be located': 'Exposure',
            'door location exposure': 'Exposure',
            exposure: 'Exposure',
            'exterior exposure': 'Exposure',
            'select glass': 'Glass',
            glass: 'Glass',
            'beveled glass': 'Beveled Glass',
            'glass bevel': 'Beveled Glass',
            'select your sidelight style': 'Sidelight Style',
            'sidelight style': 'Sidelight Style',
            'choose swing direction': 'Swing Direction',
            'swing direction': 'Swing Direction',
            'lockset prep': 'Lockset Prep',
            'lockset preparation': 'Lockset Prep',
            // Dp start 27-08
            'optional shelf': 'Optional Shelf',
            shelf: 'Optional Shelf',
            'screen storm inserts': 'Screen & Storm',
            'hardware qty': 'Hardware Quantity',
            'hardware quantity': 'Hardware Quantity',
            // Dp merge code 10-09 start — casing attrs keep Casing prefix (not bare Qty / Length)
            'casing qty': 'Casing Qty',
            'casing quantity': 'Casing Qty',
            'casing length': 'Casing Length',
            // Dp merge code 10-09 end
            // Dp end 27-08
            threshold: 'Threshold',
            brickmolding: 'Brick Molding',
            'brick molding': 'Brick Molding',
            astragal: 'Astragal',
            't astragal': 'T-Astragal',
            // Dp end 26-08
        };
        // Dp start 02-09 — hardware product thickness (separate from door/slab Door Thickness)
        if (nk === 'hardware door thickness') {
            if (typeof dpFormatHardwareThicknessToken === 'function') {
                cleanVal = dpFormatHardwareThicknessToken(cleanVal);
            }
            cleanVal = String(cleanVal || '').trim();
            if (!cleanVal) return '';
            return 'Hardware Door Thickness: ' + cleanVal;
        }
        // Dp end 02-09
        // Dp start 26-08 — product thickness always Label: Value (Door / Sidelight / Transom / Gate)
        if (
            nk === 'door thickness' ||
            nk === 'exact door thickness' ||
            nk === 'exact gate thickness' ||
            nk === 'gate thickness' ||
            nk === 'sidelight thickness' ||
            nk === 'transom thickness'
        ) {
            // Dp merge code 10-09 start — strip inch / _inch from thickness description values
            cleanVal = String(cleanVal || '')
                .replace(/_/g, ' ')
                .replace(/\s+/g, ' ')
                .replace(/\s*(?:inches?|_?inch)\s*$/i, '')
                .trim();
            // Dp merge code 10-09 end
            if (typeof dpDimensionDropdownDisplayLabel === 'function') {
                cleanVal = dpDimensionDropdownDisplayLabel(cleanVal);
            }
            cleanVal = String(cleanVal || '')
                .replace(/\s*(?:inches?|_?inch|t)\s*$/i, '')
                .trim();
            if (!cleanVal || !dpIsSelectedOptionValue(cleanVal)) return '';
            var thickTitle =
                nk === 'sidelight thickness'
                    ? 'Sidelight Thickness'
                    : nk === 'transom thickness'
                        ? 'Transom Thickness'
                        : nk === 'gate thickness' || nk === 'exact gate thickness'
                            ? 'Gate Thickness'
                            : 'Door Thickness';
            return thickTitle + ': ' + cleanVal;
        }
        // Dp end 26-08
        // Dp start 02-09 — storefront: omit Swing Direction placeholder (Verify Swing Direction is admin-only)
        if (
            nk === 'swing direction' ||
            nk === 'choose swing direction' ||
            nk === 'hardware swing direction'
        ) {
            if (/^verify swing direction$/i.test(cleanVal)) return '';
        }
        // Dp end 02-09
        // Dp merge code 10-09 start — measurement int+frac dropdown labels (liquid / door-quote-item__summary parity)
        // Dp start VDN-390 23-10
        if (
            /^(door thickness|exact door thickness|pre hung jamb depth|pre-hung jamb depth|prehung jamb depth|pre hung jamb width|pre-hung jamb width|prehung jamb width|pre hung unit depth|pre-hung unit depth|exact door (width|height|size)|rough opening (width|height|size)|finished opening (width|height|size)|jamb unit size|exact (sidelight|transom|gate) (width|height|size)|sidelight (width|height)|transom (width|height)|gate (width|height))$/.test(
                nk
            )
        ) {
        // Dp end VDN-390 23-10
            try {
                var bitsM = String(cleanVal || '')
                    .trim()
                    .split(/\s+/);
                if (bitsM.length === 2 && /^\d+$/.test(bitsM[0]) && /^\d+(\.\d+)?$/.test(bitsM[1])) {
                    cleanVal = dpCombineDimensionInchesLabel(bitsM[0], bitsM[1]);
                } else if (
                    /^\d+(\.\d+)?$/.test(String(cleanVal || '').trim()) &&
                    typeof dpDimensionDropdownDisplayLabel === 'function'
                ) {
                    cleanVal = dpDimensionDropdownDisplayLabel(cleanVal);
                } else if (/\s+x\s+/i.test(String(cleanVal || '')) && typeof dpDimensionDropdownDisplayLabel === 'function') {
                    cleanVal = String(cleanVal)
                        .split(/\s+x\s+/i)
                        .map(function (tok) {
                            var t = String(tok || '').trim();
                            var um = t.match(/^(.*?)([wht])$/i);
                            var body = um ? String(um[1] || '').trim() : t;
                            var unit = um ? String(um[2] || '').toLowerCase() : '';
                            var bb = body.split(/\s+/);
                            if (bb.length === 2 && /^\d+$/.test(bb[0]) && /^\d+(\.\d+)?$/.test(bb[1])) {
                                body = dpCombineDimensionInchesLabel(bb[0], bb[1]);
                            } else if (/^\d+(\.\d+)?$/.test(body)) {
                                body = dpDimensionDropdownDisplayLabel(body);
                            }
                            return body + unit;
                        })
                        .join(' x ');
                }
            } catch (eMeasFrac) { }
        }
        // Dp merge code 10-09 end
        // Dp start 26-08 — explain: Label: Value when a real option label exists.
        // Measurement lines (Rough Opening / Exact Door Size / Pre-Hung / Door Thickness)
        // stay as they already are via explainMap + dim collapse. Order/structure unchanged.
        if (explainMap[nk]) {
            return explainMap[nk] + ': ' + cleanVal;
        }
        var strippedLabel = dpStripOpeningPrefixFromLabel(label);
        if (strippedLabel !== label) {
            var strippedNk = dpNormalizeFieldKey(strippedLabel);
            if (explainMap[strippedNk]) {
                var prefix = label.slice(0, label.length - strippedLabel.length);
                return prefix + explainMap[strippedNk] + ': ' + cleanVal;
            }
        }
        return label + ': ' + cleanVal;
        // Dp end 26-08
    }

    // Preferred Request-a-Quote description sequences (independent — never merged).
    // Interior / Exterior door selected-items order.
    var DP_QUOTE_DESC_LABEL_ORDER_DOOR = [
        // Dp start 25-08 — Expected Shopify door order (+ screen/storm for PDF parity)
        'Door Unit Design',
        'Select Glass',
        'Beveled Glass',
        'Select Wood',
        'Wood',
        // Dp merge code 10-09 start — gate: Exact Gate Size + Gate Thickness immediately after Wood
        'Exact Gate Size',
        'Exact Gate Width',
        'Gate Width',
        'Exact Gate Height',
        'Gate Height',
        'Gate Thickness',
        // Dp merge code 10-09 end
        'Screen & Storm Inserts',
        'Select Screen Type',
        // Dp start 03-09 — display as Storm Glass (not Select Storm Glass)
        'Storm Glass',
        'Select Storm Glass',
        // Dp end 03-09
        'Insert Frame Color',
        'T-Astragal',
        'Astragal',
        'Stile and Rail Profile',
        'SDL Profile',
        'Panel Profile',
        // Dp start 02-09 — measurement block after panel profile (storefront quote order)
        'Measurements',
        'Finished Opening Size',
        'Rough Opening Size',
        'Exact Door Size',
        'Jamb Unit Size',
        // Dp merge code 10-09 start — Pre-hung Jamb Depth immediately after opening Size line
        // Dp start VDN-390 23-10
        'Pre-hung Jamb Depth',
        'Pre-Hung Jamb Depth',
        'Pre hung Jamb Depth',
        // Dp end VDN-390 23-10
        'Pre-hung Jamb Width',
        'Pre-Hung Jamb Width',
        'Pre hung Jamb Width',
        'Pre-hung Unit Depth',
        'Pre-Hung Unit Depth',
        // Dp merge code 10-09 end
        // Dp start 03-09 — Rough Opening W/H sit with the measurement block (not Finished Opening Size)
        'Rough Opening Width',
        'Rough Opening Height',
        // Dp end 03-09
        'Door Thickness',
        // Dp merge code 10-09 start — (moved above: Pre-hung after Jamb Unit Size)
        // Dp merge code 10-09 end
        'Exact Door Width',
        'Exact Door Height',
        'Exact Door Thickness',
        'Sidelight Location',
        'Sidelight Style',
        'Transom Style',
        'Single or Double Transom?',
        'Door Setup',
        // Dp start 03-09 — Exact Sidelight / Transom Size before product thickness
        'Exact Sidelight Size',
        'Exact Sidelight Width',
        'Sidelight Width',
        'Exact Sidelight Height',
        'Sidelight Height',
        'Exact Transom Size',
        'Exact Transom Width',
        'Transom Width',
        'Exact Transom Height',
        'Transom Height',
        'Sidelight Thickness',
        'Transom Thickness',
        // Dp end 03-09
        'Brick Molding',
        'Rough Opening Width',
        'Rough Opening Height',
        'Finished Opening Width',
        'Finished Opening Height',
        // Dp end 02-09
        'Hinge Finish',
        'Lockset Prep',
        'Optional Shelf',
        'Hardware',
        'Hardware Finish',
        'Finish',
        // --- Dp start 01-09 (quote description: closer color in label order) ---
        'Closer Color',
        // --- Dp end 01-09 ---
        'Hardware Function',
        // Dp start 27-08
        'Hardware Swing Direction',
        'Hardware Door Thickness',
        'Hardware Quantity',
        'Hardware Qty',
        // Dp end 27-08
        'Casing',
        // Dp merge code 10-09 start — Casing Length / Casing Qty (not bare Length / Qty)
        'Casing Length',
        // Dp merge code 10-09 end
        'Length',
        'Thickness',
        'Custom Thickness',
        // Dp start 27-08
        'Casing Qty',
        // Dp end 27-08
        'Choose Swing Direction',
        'Swing Direction',
        'Where will the door be located?',
        'Exposure',
        'Threshold',
        'Dutch Door Bolt',
        'Door Sweep',
        'Door Seal Kit',
        'Priming',
        'Add Priming and Sealing?',
        'Pet Door',
        // Dp merge code 10-09 start — match request-a-quote liquid summary (after Pet Door)
        'Door Stops with Seals',
        'Door Stops',
        // Dp merge code 10-09 end
        // Dp end 25-08
    ];

    // Porch Enclosure / Panel Unit selected-items order (separate from door order above).
    var DP_QUOTE_DESC_LABEL_ORDER_PORCH = [
        // Dp start 25-08 — Wood / Screen-Storm Function / Screen Type / Storm Type /
        // Frame Colour now lead (docx 3.1), ahead of the measurement block that
        // previously pushed them to the end.
        'Transom Style',
        'Panel Unit Design',
        'Select Wood',
        'Screen & Storm Inserts',
        'Select Screen Type',
        // Dp start 03-09 — display as Storm Glass (not Select Storm Glass)
        'Storm Glass',
        'Select Storm Glass',
        // Dp end 03-09
        'Insert Frame Color',
        'Stile and Rail Profile',
        'Panel Profile',
        'Finished Opening Size',
        'Finished Opening Width',
        'Finished Opening Height',
        'Panel Thickness',
        'Panels per opening',
        'Add Trim System',
        'Add Priming and Sealing?',
        'Sill Width',
        'Stops',
        'Astragals',
        // Door #N Swing / Hinge / Lockset — ranked dynamically so #1, #2, #3… stay sequential
        'Where will the door be located?',
        // Dp end 25-08
    ];

    // Collapse dims: Width/Height/Thickness first as "36 0 W / 80 0 H / 1 3/4 T", then depth / other dims
    // Includes Exact Door, Jamb Unit (pre-hung), Rough Opening, Finished Opening aliases.
    var DP_QUOTE_DESC_DIM_LABELS_DOOR = [
        'Exact Door Width',
        'Jamb Unit Width',
        'Door Width',
        'Exact Door Height',
        'Jamb Unit Height',
        'Door Height',
        // Dp start 26-08 — thickness is NOT collapsed into Exact Door Size (avoids
        // "… x 1 1/2t" + duplicate "Door Thickness"). Shown once as Door Thickness.
        // 'Exact Door Thickness',
        // Dp end 26-08
        // Door Thickness omitted from dim collapse — stays labeled separately
        'Pre-hung Unit Depth',
        'Pre-Hung Unit Depth',
        // Dp merge code 10-09 start — same exact-pre-hung field as Unit Depth (must collapse together)
        // Dp start VDN-390 23-10
        'Pre-hung Jamb Depth',
        'Pre-Hung Jamb Depth',
        'Pre hung Jamb Depth',
        // Dp end VDN-390 23-10
        'Pre-hung Jamb Width',
        'Pre-Hung Jamb Width',
        'Pre hung Jamb Width',
        // Dp merge code 10-09 end
        'Exact Sidelight Width',
        'Sidelight Width',
        'Exact Sidelight Height',
        'Sidelight Height',
        // Dp start 03-09 — include Transom / Gate Width so they collapse with Height into Exact … Size
        'Exact Transom Width',
        'Transom Width',
        'Exact Transom Height',
        'Transom Height',
        'Exact Gate Width',
        'Gate Width',
        'Exact Gate Height',
        'Gate Height',
        // Dp end 03-09
        'Rough Opening Height',
        'Rough Opening Width',
        'Finished Opening Width',
        'Finished Opening Height',
    ];

    // Collapse these into one values-only line (porch sequence): 72" W / 80" H / 1 1/8" T
    var DP_QUOTE_DESC_DIM_LABELS_PORCH = ['Finished Opening Width', 'Finished Opening Height'];

    function dpIsHardwareProductQuote(opts, rows) {
        opts = opts || {};
        var type = String(opts._product_type || opts.product_type || '').toLowerCase();
        if (type === 'hardware') return true;
        var list = Array.isArray(rows) ? rows : [];
        var hasHw = false;
        var hasDoor = false;
        for (var i = 0; i < list.length; i++) {
            var rk = dpNormalizeFieldKey((list[i] && (list[i].label || list[i].id)) || '');
            if (
                rk === 'hardware finish' ||
                rk === 'hardware function' ||
                rk === 'hardware door thickness' ||
                rk === 'hardware quantity' ||
                rk === 'hardware qty'
            ) {
                hasHw = true;
            }
            if (
                rk === 'door unit design' ||
                rk === 'panel unit design' ||
                rk === 'exact door size' ||
                rk === 'exact door width' ||
                rk.indexOf('pre hung') !== -1 ||
                rk.indexOf('prehung') !== -1
            ) {
                hasDoor = true;
            }
        }
        return hasHw && !hasDoor && type !== 'millwork';
    }

    function dpIsMillworkQuoteContext(opts, rows) {
        opts = opts || {};
        var type = String(opts._product_type || opts.product_type || '').toLowerCase();
        if (type === 'millwork') return true;
        var col = String(opts._route_collection || opts._collection_handle || '').toLowerCase();
        if (col.indexOf('millwork') !== -1) return true;
        if (opts.custom_thickness != null && String(opts.custom_thickness).trim() !== '') return true;
        if (opts.millwork_custom_length || opts.millwork_wood || opts.millwork_length) return true;
        var list = Array.isArray(rows) ? rows : [];
        for (var i = 0; i < list.length; i++) {
            var rk = dpNormalizeFieldKey((list[i] && (list[i].label || list[i].id)) || '');
            if (
                rk === 'custom thickness' ||
                rk === 'millwork custom thickness' ||
                rk === 'millwork wood' ||
                rk === 'custom length' ||
                rk === 'millwork length'
            ) {
                return true;
            }
        }
        return false;
    }

    function dpOptsHasPorchEnclosureOpenings(opts) {
        try {
            var po = opts && (opts.panel_unit_enclosure_openings || opts._panel_unit_enclosure_openings);
            if (typeof po === 'string') {
                try {
                    po = JSON.parse(po);
                } catch (ePo) {
                    po = [];
                }
            }
            return Array.isArray(po) && po.length > 0;
        } catch (eHas) {
            return false;
        }
    }

    function dpStripOpeningPrefixFromLabel(label) {
        // Dp start 25-08 — also strip the "Porch Opening #1 " / "Panel Opening #2 "
        // prefixes used for multi-opening panel unit fields (previously only bare
        // "Opening 1 " was recognized, so those fields missed exact dim-label match).
        return String(label == null ? '' : label)
            .replace(/^(?:porch\s+opening|panel\s+opening|opening)\s*#?\s*\d+\s+/i, '')
            .trim();
        // Dp end 25-08
    }

    function dpExtractOpeningPrefix(label) {
        var s = String(label == null ? '' : label);
        var m = s.match(/^((?:Porch|Panel)\s+Opening\s*#?\s*\d+\s+)/i);
        return m ? m[1] : '';
    }

    function dpPorchOpeningNumberFromLabel(label) {
        var m = String(label || '').match(/(?:porch|panel)\s+opening\s*#?\s*(\d+)/i);
        return m ? parseInt(m[1], 10) || 0 : 0;
    }

    function dpInsertPorchOpeningGroupBreaks(outLines) {
        outLines = Array.isArray(outLines) ? outLines : [];
        var out = [];
        var prev = 0;
        for (var i = 0; i < outLines.length; i++) {
            var L = outLines[i];
            var n = dpPorchOpeningNumberFromLabel(L);
            if (n && prev && n !== prev) out.push('');
            out.push(L);
            if (n) prev = n;
        }
        return out;
    }

    function dpParsePorchDoorField(label) {
        var key = dpNormalizeFieldKey(dpStripOpeningPrefixFromLabel(label));
        var m = key.match(/^door\s*#?\s*(\d+)\s+(.+)$/);
        if (!m) return null;
        var rest = String(m[2] || '').trim();
        var fieldRank = 9;
        if (/swing/.test(rest)) fieldRank = 0;
        else if (/hinge/.test(rest)) fieldRank = 1;
        else if (/lockset/.test(rest)) fieldRank = 2;
        return { n: parseInt(m[1], 10) || 0, f: fieldRank };
    }

    function dpIsPorchQuoteDescLabels(labels) {
        // Dp merge code 10-09 start — Finished Opening Size is a door/screen-storm measurement method.
        // Do not treat it as porch (that flipped description to Transom Style first).
        // Match Liquid request-a-quote door order; porch only with clear enclosure markers.
        var keys = (Array.isArray(labels) ? labels : []).map(function (l) {
            return dpNormalizeFieldKey(dpStripOpeningPrefixFromLabel(l));
        });
        var hasStrongPorch = false;
        var hasDoorUnit = false;
        var hasPanelUnit = false;
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            if (!k) continue;
            if (
                k === 'door unit design' ||
                k === 'hinge finish' ||
                k === 'lockset prep' ||
                k.indexOf('pre hung') !== -1 ||
                k.indexOf('prehung') !== -1
            ) {
                hasDoorUnit = true;
            }
            if (k === 'panel unit design') hasPanelUnit = true;
            if (
                k === 'panel unit design' ||
                k === 'panels per opening' ||
                k === 'add trim system' ||
                k === 'sill width' ||
                k === 'stops' ||
                k === 'astragals' ||
                /^door\s*#?\s*\d+\s+/.test(k)
            ) {
                hasStrongPorch = true;
            }
        }
        if (hasDoorUnit && !hasStrongPorch) return false;
        if (hasDoorUnit && hasStrongPorch) return !!hasPanelUnit;
        return hasStrongPorch;
        // Dp merge code 10-09 end
    }

    function dpPickQuoteDescLabelOrder(labels) {
        // Independent sequences: porch vs door — never merge into one list.
        if (dpIsPorchQuoteDescLabels(labels)) return DP_QUOTE_DESC_LABEL_ORDER_PORCH;
        return DP_QUOTE_DESC_LABEL_ORDER_DOOR;
    }

    function dpPickQuoteDescDimLabels(order) {
        if (order === DP_QUOTE_DESC_LABEL_ORDER_PORCH) return DP_QUOTE_DESC_DIM_LABELS_PORCH;
        return DP_QUOTE_DESC_DIM_LABELS_DOOR;
    }

    function dpQuoteDescLabelRankInOrder(label, order) {
        order = Array.isArray(order) ? order : DP_QUOTE_DESC_LABEL_ORDER_DOOR;
        var isPorchOrder = order === DP_QUOTE_DESC_LABEL_ORDER_PORCH;
        var openingNum = isPorchOrder ? dpPorchOpeningNumberFromLabel(label) : 0;
        // Door #1, #2, #3… stay as one sequential block after Astragals (Swing → Hinge → Lockset per door).
        var doorInfo = dpParsePorchDoorField(label);
        var fieldRank = null;
        if (doorInfo && isPorchOrder) {
            var blockStart = order.length;
            for (var d = 0; d < order.length; d++) {
                if (dpNormalizeFieldKey(order[d]) === 'astragals') {
                    blockStart = d + 1;
                    break;
                }
            }
            fieldRank = blockStart * 1000 + doorInfo.n * 10 + doorInfo.f;
        }
        var key = fieldRank != null ? '' : dpNormalizeFieldKey(dpStripOpeningPrefixFromLabel(label));
        if (fieldRank == null && !key) fieldRank = 9999;
        // Dp start 03-09 — keep Hardware N + attrs as one block (title → Qty → Closer Color → Door Thickness → Finish)
        if (fieldRank == null) {
        var hwBlock = key.match(/^hardware\s+(\d+)(?:\s+(.+))?$/);
        if (hwBlock) {
            var hwN = parseInt(hwBlock[1], 10) || 0;
            var rest = String(hwBlock[2] || '').trim();
            var hwFieldRank = 0;
            if (rest === 'closer color') hwFieldRank = 1;
            else if (rest === 'door thickness' || rest === 'hardware door thickness') hwFieldRank = 2;
            else if (rest === 'finish') hwFieldRank = 3;
            else if (rest === 'function' || rest === 'hardware function') hwFieldRank = 4;
            else if (/swing/.test(rest)) hwFieldRank = 5;
            else if (rest === 'qty') hwFieldRank = 6;
            else if (rest) hwFieldRank = 7;
            var hwStart = 0;
            for (var hi = 0; hi < order.length; hi++) {
                if (dpNormalizeFieldKey(order[hi]) === 'hardware') {
                    hwStart = hi;
                    break;
                }
            }
            fieldRank = hwStart * 1000 + hwN * 20 + hwFieldRank;
        }
        }
        // Dp end 03-09
        if (fieldRank == null) {
        for (var i = 0; i < order.length; i++) {
            if (dpNormalizeFieldKey(order[i]) === key) {
                fieldRank = i * 1000;
                break;
            }
        }
        }
        if (fieldRank == null) {
        // Soft match (e.g. "Opening 1 Stops" → Stops). Skip Door #N order stubs.
        var best = -1;
        var bestLen = -1;
        for (var j = 0; j < order.length; j++) {
            var ok = dpNormalizeFieldKey(order[j]);
            if (!ok || /^door\s*#?\s*\d+\b/.test(ok)) continue;
            // Dp start 03-09 — do not soft-match Hardware N attrs onto bare Finish / Qty
            if (/^hardware\s+\d+/.test(key)) continue;
            // Dp end 03-09
            if (key === ok || key.indexOf(ok) !== -1 || ok.indexOf(key) !== -1) {
                if (ok.length > bestLen) {
                    bestLen = ok.length;
                    best = j;
                }
            }
        }
        if (best >= 0) fieldRank = best * 1000;
        else fieldRank = 900000 + (key.charCodeAt(0) || 0);
        }
        if (isPorchOrder && openingNum > 0) {
            return 100000 + openingNum * 100000 + fieldRank;
        }
        if (isPorchOrder && openingNum === 0) {
            var finishedStart = -1;
            for (var fs = 0; fs < order.length; fs++) {
                if (dpNormalizeFieldKey(order[fs]) === 'finished opening size') {
                    finishedStart = fs * 1000;
                    break;
                }
            }
            if (finishedStart < 0) {
                for (var fw = 0; fw < order.length; fw++) {
                    if (dpNormalizeFieldKey(order[fw]) === 'finished opening width') {
                        finishedStart = fw * 1000;
                        break;
                    }
                }
            }
            if (finishedStart >= 0 && fieldRank >= finishedStart && fieldRank < 900000) {
                return 100000 + 99 * 100000 + fieldRank;
            }
        }
        return fieldRank;
    }

    function dpIsQuoteDescDimLabel(label, dimLabels) {
        dimLabels = Array.isArray(dimLabels) ? dimLabels : DP_QUOTE_DESC_DIM_LABELS_DOOR;
        var key = dpNormalizeFieldKey(dpStripOpeningPrefixFromLabel(label));
        if (!key) return false;
        // Dp start 25-08 — exact match only. The previous broad width/height/thickness
        // substring fallback here swept unrelated fields (e.g. "Sill Width", "Transom
        // Thickness", hardware "Door Thickness") into the combined Exact Door Size line.
        for (var i = 0; i < dimLabels.length; i++) {
            if (dpNormalizeFieldKey(dimLabels[i]) === key) return true;
        }
        return false;
        // Dp end 25-08
    }

    // Sort role: Width → Height → Thickness first, then Depth, sidelight, transom, rough opening…
    function dpQuoteDescDimRole(label) {
        var key = dpNormalizeFieldKey(dpStripOpeningPrefixFromLabel(label));
        if (!key) return 999;
        // Dp start 03-09 — Gate W/H collapse into Exact Gate Size (not duplicate lines)
        if (/gate/.test(key) && /width/.test(key) && !/thickness/.test(key)) return 35;
        if (/gate/.test(key) && /height/.test(key)) return 36;
        // Dp end 03-09
        if (/sidelight/.test(key) && /width/.test(key) && !/thickness/.test(key)) return 40;
        if (/sidelight/.test(key) && /height/.test(key)) return 45;
        // Dp start 03-09 — Transom Width before Height (collapse into Exact Transom Size)
        if (/transom/.test(key) && /width/.test(key) && !/thickness/.test(key)) return 48;
        // Dp end 03-09
        if (/transom/.test(key) && /height/.test(key)) return 50;
        if (/rough/.test(key) && /width/.test(key)) return 60;
        if (/rough/.test(key) && /height/.test(key)) return 70;
        // Dp merge code 10-09 start — Jamb Unit Width/Height are opening size dims (w/h), NOT Pre-hung depth
        // (role 30/999 was folding them into Pre-hung Jamb Width and dropping height)
        if (/jamb\s*unit/.test(key) && /width/.test(key) && !/pre\s*hung|prehung/.test(key)) return 0;
        if (/jamb\s*unit/.test(key) && /height/.test(key)) return 1;
        // Dp merge code 10-09 end
        // Dp merge code 10-09 start — Pre-hung Jamb Width is depth (not door Exact Width)
        if (/pre\s*hung/.test(key) && /jamb/.test(key) && /width/.test(key)) return 30;
        // Dp merge code 10-09 end
        if (/depth/.test(key) || (/pre\s*hung/.test(key) && !/width|height|thickness/.test(key))) return 30;
        // Primary door / jamb / finished opening W/H/T
        if (/width/.test(key)) return 0;
        if (/height/.test(key)) return 1;
        if (/thickness/.test(key) || /(^| )thick(ness)?$/.test(key)) return 2;
        return 999;
    }

    function dpQuoteDescDimRank(label, dimLabels) {
        var role = dpQuoteDescDimRole(label);
        if (role < 900) return role;
        dimLabels = Array.isArray(dimLabels) ? dimLabels : DP_QUOTE_DESC_DIM_LABELS_DOOR;
        var key = dpNormalizeFieldKey(dpStripOpeningPrefixFromLabel(label));
        for (var i = 0; i < dimLabels.length; i++) {
            if (dpNormalizeFieldKey(dimLabels[i]) === key) return 100 + i;
        }
        return 999;
    }

    // Dp start 24-08 / 25-08 — compact lowercase dim tokens + labeled family groups
    function dpQuoteDescDimUnitSuffix(label) {
        var role = dpQuoteDescDimRole(label);
        if (role === 30) return '';
        if (role === 0 || role === 35 || role === 40 || role === 48 || role === 60) return 'w';
        // --- Dp start 01-09 (sidelight height uses h suffix) ---
        if (role === 1 || role === 36 || role === 45 || role === 50 || role === 70) return 'h';
        // --- Dp end 01-09 ---
        if (role === 2) return 't';
        return '';
    }

    function dpFormatQuoteDescDimToken(label, value) {
        var v = dpTidyLabeledValue(value);
        if (!v || !dpIsSelectedOptionValue(v)) return '';
        if (/size$/i.test(v) && !/\d/.test(v)) return '';
        // Dp merge code 10-09 start — strip inch / _inch before w/h/t suffix
        v = String(v || '')
            .replace(/_/g, ' ')
            .replace(/\s+/g, ' ')
            .replace(/\s*(?:inches?|_?inch)\s*$/i, '')
            .trim();
        // Dp merge code 10-09 end
        // Dp start 26-08 — convert stored decimals (0.375 / 2.25 / "47 0.375") to dropdown labels.
        try {
            var bits = String(v).trim().split(/\s+/);
            if (bits.length === 2 && /^\d+$/.test(bits[0]) && /^\d+(\.\d+)?$/.test(bits[1])) {
                v = dpCombineDimensionInchesLabel(bits[0], bits[1]);
            } else if (/^\d+(\.\d+)?$/.test(String(v).trim()) && typeof dpDimensionDropdownDisplayLabel === 'function') {
                v = dpDimensionDropdownDisplayLabel(v);
            }
        } catch (eDimLab) { }
        // Dp end 26-08
        // Strip trailing zero-fraction so "36 0" → "36" (avoids "36 0w" / "36 Ow")
        v = String(v).replace(/\s+0$/i, '').trim();
        var m = String(v).match(/^(.*?)(?:\s*)([wht])$/i);
        if (m) {
            var body = String(m[1] || '')
                .replace(/\s+0$/i, '')
                .trim();
            var unit = String(m[2] || '').toLowerCase();
            return body ? body + unit : unit;
        }
        var suffix = dpQuoteDescDimUnitSuffix(label);
        if (!suffix) return v;
        return v + suffix;
    }

    function dpQuoteDescDimFamily(label, order) {
        // Dp start 25-08 — porch panel Width/Height/Thickness always collapse into one
        // "Finished Opening Size" line. Previously Panel Thickness fell through to the
        // generic 'door' family below, splitting it from the width/height line.
        if (order === DP_QUOTE_DESC_LABEL_ORDER_PORCH) {
            var openingPrefixFam = typeof dpExtractOpeningPrefix === 'function' ? dpExtractOpeningPrefix(label) : '';
            var famKey = openingPrefixFam ? dpNormalizeFieldKey(openingPrefixFam) : 'finished';
            return {
                id: 'finished|' + famKey,
                title: (openingPrefixFam + 'Finished Opening Size').replace(/\s+/g, ' ').trim()
            };
        }
        // Dp end 25-08
        var role = dpQuoteDescDimRole(label);
        // Dp start 03-09 — Gate / Sidelight / Transom W+H → one Exact … Size line
        if (role === 35 || role === 36) return { id: 'gate', title: 'Exact Gate Size' };
        if (role === 40 || role === 45) return { id: 'sidelight', title: 'Exact Sidelight Size' };
        if (role === 48 || role === 50) return { id: 'transom', title: 'Exact Transom Size' };
        // Dp end 03-09
        // Dp merge code 10-09 start — front title for the shared exact-pre-hung measurement
        // Dp start VDN-390 23-10
        if (role === 30) return { id: 'prehung', title: 'Pre-hung Jamb Depth' };
        // Dp end VDN-390 23-10
        // Dp merge code 10-09 end
        if (role === 60 || role === 70) return { id: 'rough', title: 'Rough Opening Size' };
        // Dp start 26-08 — thickness never joins Exact Door Size collapse
        if (role === 2) return { id: 'door_thickness', title: 'Door Thickness' };
        // Dp end 26-08
        var key = dpNormalizeFieldKey(dpStripOpeningPrefixFromLabel(label));
        if (/finished/.test(key) && /opening/.test(key)) {
            return { id: 'finished', title: 'Finished Opening Size' };
        }
        if (role <= 1) return { id: 'door', title: 'Exact Door Size' };
        return null;
    }

    // Dp merge code 10-09 start — insert Pre-hung after Jamb Unit Size (or other Size); thickness is fallback
    function dpIndexAfterOpeningSizeLine(lines, productThickKey) {
        lines = Array.isArray(lines) ? lines : [];
        var i;
        for (i = 0; i < lines.length; i++) {
            if (/^Jamb Unit Size\s*:/i.test(String(lines[i] || ''))) return i;
        }
        for (i = 0; i < lines.length; i++) {
            if (
                /^(Exact Door Size|Rough Opening Size|Finished Opening Size|Exact Gate Size|Exact Sidelight Size|Exact Transom Size|Pre-Hung Unit Size)\s*:/i.test(
                    String(lines[i] || '')
                )
            ) {
                return i;
            }
        }
        var thickKey = dpNormalizeFieldKey(productThickKey || 'Door Thickness');
        for (i = 0; i < lines.length; i++) {
            var tnk = dpNormalizeFieldKey(lines[i]);
            if (
                tnk.indexOf(thickKey) === 0 ||
                tnk.indexOf('door thickness') === 0 ||
                tnk.indexOf('exact door thickness') === 0 ||
                tnk.indexOf('sidelight thickness') === 0 ||
                tnk.indexOf('transom thickness') === 0 ||
                tnk.indexOf('gate thickness') === 0
            ) {
                return i;
            }
        }
        return -1;
    }
    // Dp merge code 10-09 end

    // Dp merge code 10-09 start — insert Pre-hung after Door Thickness / Exact Door Thickness
    function dpIndexAfterThicknessLine(lines, productThickKey) {
        lines = Array.isArray(lines) ? lines : [];
        var thickKey = dpNormalizeFieldKey(productThickKey || 'Door Thickness');
        var lastThick = -1;
        var i;
        for (i = 0; i < lines.length; i++) {
            var tnk = dpNormalizeFieldKey(lines[i]);
            if (
                tnk.indexOf(thickKey) === 0 ||
                tnk.indexOf('door thickness') === 0 ||
                tnk.indexOf('exact door thickness') === 0 ||
                tnk.indexOf('sidelight thickness') === 0 ||
                tnk.indexOf('transom thickness') === 0 ||
                tnk.indexOf('gate thickness') === 0
            ) {
                lastThick = i;
            }
        }
        if (lastThick >= 0) return lastThick;
        if (typeof dpIndexAfterOpeningSizeLine === 'function') {
            return dpIndexAfterOpeningSizeLine(lines, productThickKey);
        }
        return -1;
    }
    // Dp merge code 10-09 end

    // Dp merge code 10-09 start — strip every Unit Depth / Jamb Width line; emit one Pre-hung Jamb Width
    function dpIsPreHungJambWidthLabelKey(nk) {
        nk = String(nk || '').trim();
        if (!nk) return false;
        // Dp merge code 10-09 start — Jamb Unit Size/Width/Height are NOT Pre-hung depth
        if (nk.indexOf('jamb unit') === 0) return false;
        // Dp merge code 10-09 end
        if (nk.indexOf('pre hung unit depth') === 0 || nk.indexOf('prehung unit depth') === 0) return true;
        if (nk.indexOf('pre hung jamb width') === 0 || nk.indexOf('prehung jamb width') === 0) return true;
        // Dp start VDN-390 23-10
        if (nk.indexOf('pre hung jamb depth') === 0 || nk.indexOf('prehung jamb depth') === 0) return true;
        // Dp end VDN-390 23-10
        return false;
    }

    // Dp merge code 10-09 start — Pre-hung depth only (drop blended "40 9/16 x 8 3/4")
    function dpSanitizePreHungJambWidthValue(val) {
        val = String(val == null ? '' : val)
            .replace(/\s*inches?\s*$/i, '')
            .replace(/[wh]$/i, '')
            .trim();
        if (!val) return '';
        if (!/\s+x\s+/i.test(val) && !/\s+×\s+/i.test(val)) {
            var wholeOnly = parseInt(val, 10);
            // Door/jamb opening widths are typically > 20; depth is smaller
            if (!isNaN(wholeOnly) && wholeOnly > 20) return '';
            return val;
        }
        var parts = val.split(/\s+[x×]\s+/i);
        var depth = '';
        for (var i = 0; i < parts.length; i++) {
            var p = String(parts[i] || '')
                .replace(/[wh]$/i, '')
                .trim();
            if (!p) continue;
            var w = parseInt(p, 10);
            if (!isNaN(w) && w > 0 && w <= 20) {
                depth = p;
            }
        }
        return depth;
    }

    function dpRepairJambUnitSizeAndPreHungLines(lines, opts, rows) {
        lines = Array.isArray(lines) ? lines.slice() : [];
        opts = opts || {};
        rows = rows || [];
        var mt = '';
        try {
            mt = dpNormalizeFieldKey(String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' '));
        } catch (eMt) { }
        var isJambMt =
            mt === 'jamb unit size' || mt === 'pre hung unit size' || mt === 'pre-hung unit size';
        var hasJambSize = lines.some(function (L) {
            return /^Jamb Unit Size\s*:/i.test(String(L || ''));
        });
        var orphanH = '';
        var kept = [];
        var preHungVal = '';
        var sizeW = '';
        var sizeH = '';
        for (var i = 0; i < lines.length; i++) {
            var L = String(lines[i] || '').trim();
            if (!L) continue;
            // Orphan height token left after bad Pre-hung blend
            if (!/:/.test(L) && /^\d+(\s+\d+\/\d+)?$/.test(L)) {
                var ow = parseInt(L, 10);
                if (!isNaN(ow) && ow > 20) {
                    orphanH = L;
                    continue;
                }
            }
            var colon = L.indexOf(':');
            var lab = colon > 0 ? L.slice(0, colon).trim() : '';
            var val = colon > 0 ? L.slice(colon + 1).replace(/^\s+/, '') : '';
            var nk = dpNormalizeFieldKey(lab);
            if (dpIsPreHungJambWidthLabelKey(nk) || nk === 'pre hung jamb width') {
                if (/\s+[x×]\s+/i.test(val)) {
                    var bits = val.split(/\s+[x×]\s+/i);
                    for (var b = 0; b < bits.length; b++) {
                        var part = String(bits[b] || '')
                            .replace(/[wh]$/i, '')
                            .trim();
                        if (!part) continue;
                        var pw = parseInt(part, 10);
                        if (!isNaN(pw) && pw > 20 && !sizeW) sizeW = part;
                        else if (!isNaN(pw) && pw <= 20) preHungVal = part;
                    }
                } else {
                    preHungVal = dpSanitizePreHungJambWidthValue(val) || val;
                }
                continue;
            }
            if (nk === 'jamb unit size' || nk === 'exact sidelight size') {
                // Dp merge code 10-09 start — size line label follows selected measurement type
                // (was: always rename Exact Sidelight Size → Jamb Unit Size)
                // Exact Sidelight Size selected: drop stale Jamb Unit Size (e.g. width-only 10 1/4w)
                if (mt === 'exact sidelight size' && nk === 'jamb unit size') {
                    continue;
                }
                var sizeLine = L;
                if (isJambMt) {
                    hasJambSize = true;
                    if (nk === 'exact sidelight size') {
                        sizeLine = String(L).replace(/^Exact Sidelight Size\s*:/i, 'Jamb Unit Size:');
                    }
                } else if (nk === 'jamb unit size') {
                    hasJambSize = true;
                }
                kept.push(sizeLine);
                continue;
            }
            // Dp merge code 10-09 end / 08-09 (was: always Exact Sidelight Size → Jamb Unit Size)
            kept.push(L);
        }
        if (orphanH && !sizeH) sizeH = orphanH;
        if (isJambMt && !hasJambSize && (sizeW || sizeH)) {
            var toks = [];
            if (sizeW) toks.push(/w$/i.test(sizeW) ? sizeW : sizeW + 'w');
            if (sizeH) toks.push(/h$/i.test(sizeH) ? sizeH : sizeH + 'h');
            if (toks.length) {
                var sizeLine = 'Jamb Unit Size: ' + toks.join(' x ');
                var afterThick = -1;
                for (var t = 0; t < kept.length; t++) {
                    if (/thickness\s*:/i.test(String(kept[t] || ''))) {
                        afterThick = t;
                        break;
                    }
                }
                if (afterThick < 0) kept.unshift(sizeLine);
                else kept.splice(afterThick + 1, 0, sizeLine);
            }
        }
        if (preHungVal) {
            preHungVal = dpSanitizePreHungJambWidthValue(preHungVal) || preHungVal;
            if (preHungVal && !/\s+[x×]\s+/i.test(preHungVal)) {
                // Dp start VDN-390 23-10
                var phLine = 'Pre-hung Jamb Depth: ' + preHungVal;
                // Dp end VDN-390 23-10
                // Dp merge code 10-09 start — after Jamb Unit Size / opening Size
                var phAt = typeof dpIndexAfterOpeningSizeLine === 'function'
                    ? dpIndexAfterOpeningSizeLine(kept, 'Door Thickness')
                    : -1;
                if (phAt < 0) kept.push(phLine);
                else kept.splice(phAt + 1, 0, phLine);
                // Dp merge code 10-09 end
            }
        }
        return kept;
    }
    // Dp merge code 10-09 end

    function dpDedupePreHungJambWidthLines(lines, productThickKey) {
        var depthVal = '';
        var jambVal = '';
        var kept = [];
        var arr = Array.isArray(lines) ? lines : [];
        for (var i = 0; i < arr.length; i++) {
            var L = String(arr[i] || '').trim();
            if (!L) continue;
            var colon = L.indexOf(':');
            var labPart = colon > 0 ? L.slice(0, colon) : L;
            var valPart = colon > 0 ? L.slice(colon + 1).replace(/^\s+/, '') : '';
            var nk = dpNormalizeFieldKey(labPart);
            // Dp merge code 10-09 start — never treat Jamb Unit Size/Width/Height as Pre-hung depth
            if (
                nk === 'jamb unit size' ||
                nk.indexOf('jamb unit width') === 0 ||
                nk.indexOf('jamb unit height') === 0
            ) {
                kept.push(arr[i]);
                continue;
            }
            // Dp merge code 10-09 end
            if (dpIsPreHungJambWidthLabelKey(nk)) {
                if (/jamb\s+width/.test(nk) && nk.indexOf('jamb unit') === -1) {
                    if (valPart) jambVal = valPart;
                } else if (valPart) {
                    depthVal = valPart;
                }
                continue;
            }
            kept.push(arr[i]);
        }
        var val = jambVal || depthVal;
        if (!val) return kept;
        if (jambVal && depthVal && jambVal !== depthVal) {
            // Dp merge code 10-09 start — if one value is multi-part W×H, keep the single depth token
            if (/\s+x\s+/i.test(jambVal) && !/\s+x\s+/i.test(depthVal)) val = depthVal;
            else if (/\s+x\s+/i.test(depthVal) && !/\s+x\s+/i.test(jambVal)) val = jambVal;
            else if (/\d+\s*\/\s*\d+/.test(jambVal) && !/\s+x\s+/i.test(jambVal)) val = jambVal;
            else if (/\d+\s*\/\s*\d+/.test(depthVal) && !/\s+x\s+/i.test(depthVal)) val = depthVal;
            else val = jambVal;
            // Dp merge code 10-09 end
        }
        // Dp merge code 10-09 start — Pre-hung must be depth-only; strip accidental W x H blends
        val = dpSanitizePreHungJambWidthValue(val);
        if (!val) return kept;
        // Dp merge code 10-09 end
        // Dp start VDN-390 23-10
        var oneLine = 'Pre-hung Jamb Depth: ' + val;
        // Dp end VDN-390 23-10
        // Dp merge code 10-09 start — after Door Thickness / Exact Door Thickness
        var afterAt = typeof dpIndexAfterThicknessLine === 'function'
            ? dpIndexAfterThicknessLine(kept, productThickKey)
            : (typeof dpIndexAfterOpeningSizeLine === 'function'
                ? dpIndexAfterOpeningSizeLine(kept, productThickKey)
                : -1);
        if (afterAt < 0) kept.push(oneLine);
        else kept.splice(afterAt + 1, 0, oneLine);
        // Dp merge code 10-09 end
        return kept;
    }
    // Dp merge code 10-09 end

    function dpCollapseQuoteDescDimLines(items, order, opts, rows) {
        items = Array.isArray(items) ? items : [];
        rows = rows || null;
        // Dp start 02-09 — drop stale pre-collapsed size lines; width/height rows rebuild them
        var precollapseDrop = {
            'exact door size': true,
            'rough opening size': true,
            'finished opening size': true,
            'jamb unit size': true,
            'pre hung unit size': true,
            'pre-hung unit size': true,
            // Dp start 03-09 — rebuild Exact … Size from Width / Height rows
            'exact transom size': true,
            'exact sidelight size': true,
            'exact gate size': true,
            // Dp end 03-09
        };
        items = items.filter(function (it) {
            if (!it) return false;
            var pk = dpNormalizeFieldKey((it.label || '') + '');
            return !precollapseDrop[pk];
        });
        // Dp end 02-09
        var dimLabels = dpPickQuoteDescDimLabels(order);
        // Dp start 03-09 — Rough Opening Size selected: collapse W/H into Rough Opening Size (default)
        // Exact Door W/H on jamb rough may still map to Finished Opening Size below.
        var dpMapExactDoorToFinishedOnRough = false;
        try {
            var _frontRough03 = typeof dpWasRoughOpeningSelectedFromFront === 'function'
                ? dpWasRoughOpeningSelectedFromFront(opts, rows)
                : false;
            var _isSlabBrick03 = typeof dpIsNonJambSlabOrBrickSetup === 'function' && dpIsNonJambSlabOrBrickSetup(opts, rows);
            dpMapExactDoorToFinishedOnRough = !!(!_isSlabBrick03 && _frontRough03);
            // Dp merge code 10-09 start — jamb two-tab: keep Exact Door Size label (values live under Exact Door tab)
            if (dpMapExactDoorToFinishedOnRough && typeof dpIsJambTwoTabMeasureMode === 'function'
                && dpIsJambTwoTabMeasureMode(opts, rows)) {
                dpMapExactDoorToFinishedOnRough = false;
            }
            // Dp merge code 10-09 end
        } catch (eJambRough03) { }
        // Dp end 03-09
        var measTitle = 'Exact Door Size';
        // Dp start 02-09 — prefer saved measurement_type for collapse line label (Finished Opening Size, …)
        if (opts && typeof dpResolveMeasurementTypeDisplayLabel === 'function') {
            var measFromOpt = dpResolveMeasurementTypeDisplayLabel(opts, rows);
            if (measFromOpt) measTitle = measFromOpt;
        }
        // Dp end 02-09
        var dimItems = [];
        var rest = [];
        var insertAt = -1;
        var mtEffCollect = dpNormalizeFieldKey(String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' '));
        var isRoughMtCollect = dpIsRoughOpeningMeasurementKey(mtEffCollect);
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            var nk = dpNormalizeFieldKey((it && it.label) || '');
            if (
                nk === 'measurements' ||
                dpIsMeasurementTypeLabel((it && it.value) || '') ||
                dpIsMeasurementTypeLabel((it && it.label) || '')
            ) {
                if (dpIsMeasurementTypeLabel((it && it.value) || '')) measTitle = String(it.value).trim();
                else if (dpIsMeasurementTypeLabel((it && it.label) || '')) measTitle = String(it.label).trim();
                continue;
            }
            if (it && dpIsQuoteDescDimLabel(it.label, dimLabels)) {
                var dimRoleCollect = dpQuoteDescDimRole(it.label);
                var dimLabCollect = dpNormalizeFieldKey((it.label || '') + '');
                // Dp start 02-09 — rough mt: collapse Rough Opening W/H into Rough Opening Size; drop calc Finished W/H
                if (isRoughMtCollect) {
                    if (dimLabCollect === 'finished opening width' || dimLabCollect === 'finished opening height') {
                        continue;
                    }
                }
                // Dp end 02-09
                // Dp start 03-09 — Rough Opening Size selected uses combined Rough Opening Size line (not separate W/H)
                // (removed dpIsJambRoughSeparate keep-separate path)
                // Dp end 03-09
                if (insertAt < 0) insertAt = rest.length;
                dimItems.push(it);
            } else {
                rest.push(it);
            }
        }
        if (!dimItems.length) return rest.length ? rest : items;

        var families = {};
        var familyOrder = [];
        dimItems
            .slice()
            .sort(function (a, b) {
                var ra = dpQuoteDescDimRank(a.label, dimLabels);
                var rb = dpQuoteDescDimRank(b.label, dimLabels);
                if (ra !== rb) return ra - rb;
                return (a.idx || 0) - (b.idx || 0);
            })
            .forEach(function (d) {
                var fam = dpQuoteDescDimFamily(d && d.label, order) || { id: 'other', title: '' };
                var mtKey = dpNormalizeFieldKey(measTitle || '');
                var mtEff = mtKey;
                if (typeof dpEffectiveMeasurementTypeKey === 'function') {
                    mtEff = dpNormalizeFieldKey(String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' '));
                }
                var dimLabKey = dpNormalizeFieldKey((d && d.label) || '');
                // Dp merge code 10-09 start — only use dims that match selected measurement type
                var isJambUnitMt =
                    mtEff === 'jamb unit size' ||
                    mtEff === 'pre hung unit size' ||
                    mtEff === 'pre-hung unit size' ||
                    mtKey === 'jamb unit size' ||
                    mtKey === 'pre hung unit size' ||
                    mtKey === 'pre-hung unit size';
                var isJambUnitDim =
                    dimLabKey === 'jamb unit width' ||
                    dimLabKey === 'jamb unit height' ||
                    dimLabKey.indexOf('jamb unit width') === 0 ||
                    dimLabKey.indexOf('jamb unit height') === 0;
                if (isJambUnitDim && !isJambUnitMt) {
                    return; // stale jamb unit W/H must not join Exact Door / Rough Size
                }
                if (
                    isJambUnitMt &&
                    (dimLabKey === 'rough opening width' ||
                        dimLabKey === 'rough opening height' ||
                        dimLabKey === 'finished opening width' ||
                        dimLabKey === 'finished opening height')
                ) {
                    return; // Jamb Unit Size: do not fetch rough/finished opening dims
                }
                // Dp merge code 10-09 end
                // Dp merge code 10-09 start — door+sidelight/transom: keep Exact Sidelight Width / Exact Transom Height
                // (collapse to Exact … Size only when that measurement type is selected)
                if (fam.id === 'sidelight') {
                    var isExactSlMt09 =
                        mtEff === 'exact sidelight size' || mtKey === 'exact sidelight size';
                    if (!isExactSlMt09) {
                        var roleSl09 = dpQuoteDescDimRole((d && d.label) || '');
                        if (roleSl09 === 40) fam = { id: 'sidelight_w', title: 'Exact Sidelight Width' };
                        else if (roleSl09 === 45) fam = { id: 'sidelight_h', title: 'Exact Sidelight Height' };
                    }
                }
                if (fam.id === 'transom') {
                    var isExactTrMt09 =
                        mtEff === 'exact transom size' || mtKey === 'exact transom size';
                    if (!isExactTrMt09) {
                        var roleTr09 = dpQuoteDescDimRole((d && d.label) || '');
                        if (roleTr09 === 48) fam = { id: 'transom_w', title: 'Exact Transom Width' };
                        else if (roleTr09 === 50) fam = { id: 'transom_h', title: 'Exact Transom Height' };
                    }
                }
                // Dp merge code 10-09 end
                // Dp start 02-09 — rough mt: skip calc Finished Opening W/H in collapse
                if (dpIsRoughOpeningMeasurementKey(mtEff) &&
                    (dimLabKey === 'finished opening width' || dimLabKey === 'finished opening height')) {
                    return;
                }
                // Dp end 02-09
                // Dp start 02-09 — Finished Opening Size (Slab/Brick): label + group even if rows say Rough Opening W/H
                // Dp merge code 10-09 start — Rough Opening Size selected: keep BOTH Finished (Exact Door) + Rough lines
                var frontRoughFam08 = typeof dpWasRoughOpeningSelectedFromFront === 'function' && dpWasRoughOpeningSelectedFromFront(opts, rows);
                var isSlabFam08 = typeof dpIsNonJambSlabOrBrickSetup === 'function' && dpIsNonJambSlabOrBrickSetup(opts, rows);
                // Dp merge code 10-09 start — jamb two-tab: Exact Door dims stay Exact Door Size (not Finished Opening Size)
                var isJambTwoFam09 = typeof dpIsJambTwoTabMeasureMode === 'function' && dpIsJambTwoTabMeasureMode(opts, rows);
                if (frontRoughFam08 && !isSlabFam08 && (fam.id === 'rough' || fam.id === 'finished')) {
                    // MERGE: rough_label_fix — jamb two-tab also keeps Rough Opening Size
                    if (fam.id === 'rough') fam = { id: 'rough', title: 'Rough Opening Size' };
                    else fam = { id: 'finished', title: 'Finished Opening Size' };
                } else if (dpIsFinishedOpeningMeasurementKey(mtEff) && (fam.id === 'rough' || fam.id === 'finished')) {
                    fam = { id: 'finished', title: 'Finished Opening Size' };
                    measTitle = 'Finished Opening Size';
                } else if (mtEff === 'rough opening size' && (fam.id === 'rough' || fam.id === 'finished')) {
                    fam = { id: 'rough', title: measTitle || 'Rough Opening Size' };
                }
                // Dp merge code 10-09 end / 08-09
                // Finished Opening Size: Exact Door W/H are calc fields; do not list separately
                if (dpIsFinishedOpeningMeasurementKey(mtEff) && !frontRoughFam08 && (fam.id === 'door_w' || fam.id === 'door_h')) {
                    return;
                }
                // Dp end 02-09
                // Dp start 02-09 — opening-size collapse label = selected measurement type title
                if (
                    (fam.id === 'rough' || fam.id === 'finished') &&
                    measTitle &&
                    dpIsMeasurementTypeLabel(measTitle)
                ) {
                    fam = { id: fam.id, title: String(measTitle).trim() };
                }
                // Dp end 02-09
                if (fam.id === 'door') {
                    // Don't reuse Rough/Finished Opening as door-slab title (causes duplicate Rough Opening Size lines)
                    var doorTitle = 'Exact Door Size';
                    var doorRole = dpQuoteDescDimRole((d && d.label) || '');
                    // Dp start 26-08 — never fold thickness into Exact Door Size (shown once as Door Thickness)
                    if (doorRole === 2) {
                        fam = { id: 'door_thickness', title: 'Door Thickness' };
                    } else if (mtKey === 'jamb unit size' || mtKey === 'pre hung unit size' || mtKey === 'pre-hung unit size') {
                        // Dp merge code 10-09 start — Exact Door W/H stay Exact Door Size; only Jamb Unit W/H → Jamb Unit Size
                        if (isJambUnitDim) {
                            fam = { id: 'jamb', title: 'Jamb Unit Size' };
                        } else {
                            fam = { id: 'door', title: 'Exact Door Size' };
                        }
                        // Dp merge code 10-09 end
                    } else if (
                        mtKey === 'rough opening size' ||
                        mtKey === 'finished opening size' ||
                        mtKey === 'finished door size'
                    ) {
                        // Dp merge code 10-09 start — keep combined Exact Door Size (Ww x Hh), not separate Width/Height
                        // (jamb two-tab + Finished Opening Size companion Exact Door dims)
                        fam = { id: 'door', title: 'Exact Door Size' };
                        // Dp merge code 10-09 end
                    } else {
                        if (
                            mtKey &&
                            mtKey !== 'rough opening size' &&
                            mtKey !== 'finished opening size' &&
                            mtKey !== 'finished door size' &&
                            mtKey !== 'jamb unit size' &&
                            mtKey !== 'pre hung unit size' &&
                            mtKey !== 'pre-hung unit size'
                        ) {
                            doorTitle = measTitle;
                        }
                        fam = { id: 'door', title: doorTitle };
                    }
                    // Dp end 26-08
                    // Dp start 03-09 — on Rough Opening Size (jamb): Exact Door W/H → Finished Opening Size
                    // Dp merge code 10-09 start — skipped for jamb two-tab (Exact Door Size stays Exact Door Size)
                    if (dpMapExactDoorToFinishedOnRough && (doorRole === 0 || doorRole === 1)) {
                        fam = { id: 'finished', title: 'Finished Opening Size' };
                    }
                    // Dp merge code 10-09 end / 03-09
                }
                if (!families[fam.id]) {
                    families[fam.id] = { title: fam.title, vals: [], seen: {} };
                    familyOrder.push(fam.id);
                }
                var token = dpFormatQuoteDescDimToken(d && d.label, d && d.value);
                if (!token) return;
                // Dp merge code 10-09 start — Size families: at most one w and one h (drop extra width like prehung/jamb)
                if (fam.id === 'door' || fam.id === 'finished' || fam.id === 'rough' || fam.id === 'jamb') {
                    var roleForFam = dpQuoteDescDimRole((d && d.label) || '');
                    if (roleForFam !== 0 && roleForFam !== 1 && roleForFam !== 60 && roleForFam !== 70) {
                        if (roleForFam === 30) {
                            // Dp start VDN-390 23-10
                            fam = { id: 'prehung', title: 'Pre-hung Jamb Depth' };
                            // Dp end VDN-390 23-10
                            if (!families[fam.id]) {
                                families[fam.id] = { title: fam.title, vals: [], seen: {} };
                                familyOrder.push(fam.id);
                            }
                        } else if (roleForFam === 2) {
                            fam = { id: 'door_thickness', title: 'Door Thickness' };
                            if (!families[fam.id]) {
                                families[fam.id] = { title: fam.title, vals: [], seen: {} };
                                familyOrder.push(fam.id);
                            }
                        } else {
                            return;
                        }
                    } else {
                        var isW = /w$/i.test(token);
                        var isH = /h$/i.test(token);
                        var hasW = false;
                        var hasH = false;
                        for (var vi = 0; vi < families[fam.id].vals.length; vi++) {
                            if (/w$/i.test(String(families[fam.id].vals[vi] || ''))) hasW = true;
                            if (/h$/i.test(String(families[fam.id].vals[vi] || ''))) hasH = true;
                        }
                        if (isW && hasW) return;
                        if (isH && hasH) return;
                    }
                }
                // Dp merge code 10-09 end
                // Dp merge code 10-09 start — Pre-hung family must stay depth-only (never join W x H)
                if (fam.id === 'prehung') {
                    var phTok = String(token || '').trim();
                    if (/\s+x\s+/i.test(phTok) || /[wh]$/i.test(phTok)) {
                        return;
                    }
                    // Prefer single depth token; drop door-width-sized wholes (>20)
                    var phWhole = parseInt(phTok, 10);
                    if (!isNaN(phWhole) && phWhole > 20 && families[fam.id].vals.length) {
                        return;
                    }
                }
                // Dp merge code 10-09 end
                var tk = dpNormalizeFieldKey(token);
                if (families[fam.id].seen[tk]) return;
                families[fam.id].seen[tk] = true;
                families[fam.id].vals.push(token);
            });

        var combinedRows = [];
        var seenLines = {};
        familyOrder.forEach(function (fid) {
            var g = families[fid];
            if (!g || !g.vals.length) return;
            // Dp start 26-08 — Door Thickness: plain label (no "t" suffix / not inside Exact Door Size)
            var body;
            var line;
            if (fid === 'door_thickness') {
                body = g.vals
                    .map(function (tok) {
                        return String(tok || '')
                            .replace(/\s*t$/i, '')
                            .trim();
                    })
                    .filter(Boolean)
                    .join(' ');
                line = g.title ? g.title + ': ' + body : body;
            } else {
                // Exact Door Size / Rough Opening: 36w x 80h (thickness excluded)
                body = g.vals.join(' x ');
                line = g.title ? g.title + ': ' + body : body;
            }
            // Dp end 26-08
            var lineKey = dpNormalizeFieldKey(line);
            if (seenLines[lineKey]) return;
            seenLines[lineKey] = true;
            combinedRows.push({
                line: line,
                label: g.title || '',
                value: body,
                rank: dpQuoteDescLabelRankInOrder(g.title || 'Exact Door Width', order),
                idx: dimItems[0].idx || 0,
            });
        });
        if (!combinedRows.length) return rest;
        if (insertAt < 0 || insertAt > rest.length) {
            combinedRows.forEach(function (r) {
                rest.push(r);
            });
        } else {
            rest.splice.apply(rest, [insertAt, 0].concat(combinedRows));
        }
        return rest;
    }
    // Dp end 24-08 / 25-08

    function dpBuildLabeledRowsFromSummary(rows, opts) {
        opts = opts || {};
        var isPorchEnclosure = typeof dpOptsHasPorchEnclosureOpenings === 'function' && dpOptsHasPorchEnclosureOpenings(opts);
        var isMillworkQuote = typeof dpIsMillworkQuoteContext === 'function' && dpIsMillworkQuoteContext(opts, rows);
        var isHardwareQuote = typeof dpIsHardwareProductQuote === 'function' && dpIsHardwareProductQuote(opts, rows);
        // Dp start 26-08 — resolve product thickness once (Label: Value only; no format changes elsewhere)
        var productThickLabel = isPorchEnclosure
            ? 'Panel Thickness'
            : isMillworkQuote
                ? 'Thickness'
            : typeof dpResolveProductThicknessLabel === 'function'
                ? dpResolveProductThicknessLabel(opts, rows)
                : 'Door Thickness';
        var productThickVal = '';
        if (!isPorchEnclosure && !isMillworkQuote && !isHardwareQuote) {
        productThickVal =
            typeof dpFindProductThicknessValue === 'function'
                ? dpFindProductThicknessValue(opts, rows, productThickLabel)
                : typeof dpFindDoorThicknessValue === 'function'
                    ? dpFindDoorThicknessValue(opts, rows)
                    : '';
        if (productThickVal && typeof dpDimensionDropdownDisplayLabel === 'function') {
            productThickVal = dpDimensionDropdownDisplayLabel(productThickVal);
        }
        // Dp merge code 10-09 start — never keep inch / _inch on Door Thickness summary
        productThickVal = String(productThickVal || '')
            .replace(/_/g, ' ')
            .replace(/\s+/g, ' ')
            .replace(/\s*(?:inches?|_?inch|t)\s*$/i, '')
            .trim();
        }
        // Dp merge code 10-09 end
        var productThickKey = dpNormalizeFieldKey(productThickLabel || 'Door Thickness');
        function dpIsBareDoorThicknessDuplicate(val) {
            var s = String(val == null ? '' : val)
                .replace(/\s*t$/i, '')
                .trim();
            if (!s) return false;
            // Known door-thickness tokens (fraction or decimal) — never show unlabeled
            if (
                /^(1\.125|1\.25|1\.375|1\.5|1\.75|2\.25|2\.5|2\.75)$/.test(s) ||
                /^(1\s+1\/8|1\s+1\/4|1\s+3\/8|1\s+1\/2|1\s+3\/4|2\s+1\/4|2\s+1\/2|2\s+3\/4)$/.test(s)
            ) {
                return true;
            }
            if (!productThickVal) return false;
            var a = dpNormalizeFieldKey(s);
            var b = dpNormalizeFieldKey(productThickVal);
            if (a && a === b) return true;
            if (typeof dpDimensionDropdownDisplayLabel === 'function') {
                if (dpNormalizeFieldKey(dpDimensionDropdownDisplayLabel(s)) === b) return true;
            }
            return false;
        }
        // Dp end 26-08
        var seen = {};
        var items = [];
        var labelHints = [];
        var isRoughCtx = dpIsRoughOpeningMeasurementContext(opts, rows);
        (Array.isArray(rows) ? rows : []).forEach(function (row, idx) {
            if (!row) return;
            var split = dpSplitSelectedRow(row);
            var cleanVal = dpTidyLabeledValue(split.value);
            if (!cleanVal || !dpIsSelectedOptionValue(cleanVal)) return;
            if (!split.label) split.label = dpLookupLabelForValue(opts, split.value);
            // Dp start 02-09 — rough mt: drop calc Finished Opening rows from summary input
            if (isRoughCtx && split.label) {
                var roughSkipLab = dpNormalizeFieldKey(split.label);
                if (
                    // Dp start 03-09 — keep Finished Opening Size (Exact Door W/H); skip only calc Finished W/H
                    roughSkipLab === 'finished opening width' ||
                    roughSkipLab === 'finished opening height'
                    // Dp end 03-09
                ) {
                    return;
                }
            }
            // Dp end 02-09
            // --- Dp start 01-09 (quote description: backfill missing labels for bare value rows) ---
            if (!split.label && /^beveled glass$/i.test(cleanVal)) split.label = 'Beveled Glass';
            if (!split.label && /hinges?$/i.test(cleanVal) && !/^verify finish$/i.test(cleanVal)) {
                split.label = 'Hinge Finish';
            }
            if (split.label) split.label = dpHumanizeFieldLabel(split.label);
            // --- Dp end 01-09 ---
            // Dp start 26-08 — hide unlabeled bare thickness (e.g. "1 1/8" / "1.125"); shown once as Door Thickness
            if (!split.label && dpIsBareDoorThicknessDuplicate(cleanVal)) {
                if (!productThickVal) {
                    productThickVal =
                        typeof dpDimensionDropdownDisplayLabel === 'function'
                            ? dpDimensionDropdownDisplayLabel(cleanVal)
                            : String(cleanVal).replace(/\s*t$/i, '').trim();
                }
                return;
            }
            // Dp end 26-08
            // Dp start 27-08 — never list raw measurement int/frac keys (Exact-Door-Width-Int, * Label, …)
            if (split.label && typeof dpIsMeasurementInternalKey === 'function' && dpIsMeasurementInternalKey(split.label)) {
                return;
            }
            // Dp end 27-08
            var line = dpFormatLabeledDescriptionLine(split.label, split.value);
            if (!line) return;
            var key = split.label ? dpNormalizeFieldKey(split.label) : 'val:' + dpNormalizeFieldKey(split.value);
            if (split.label && typeof dpParsePorchDoorField === 'function' && dpParsePorchDoorField(split.label)) {
                key = dpNormalizeFieldKey(split.label) + '|' + dpNormalizeFieldKey(split.value);
            }
            if (!key || seen[key]) return;
            seen[key] = true;
            if (split.label) labelHints.push(split.label);
            items.push({
                line: line,
                label: split.label || '',
                value: cleanVal,
                idx: idx,
            });
        });
        // Dp merge code 10-09 start — Unit Depth + Jamb Width are one front field; keep Jamb Width only
        // Dp start VDN-390 23-10
        (function dpNormalizePrehungJambItems() {
            var targetIdx = -1;
            var toRemove = [];
            for (var i = 0; i < items.length; i++) {
                var nk = dpNormalizeFieldKey((items[i] && items[i].label) || '');
                if (
                    nk === 'pre hung jamb width' || nk === 'pre-hung jamb width' || nk === 'prehung jamb width' ||
                    nk === 'pre hung jamb depth' || nk === 'pre-hung jamb depth' || nk === 'prehung jamb depth' ||
                    nk === 'pre hung unit depth' || nk === 'pre-hung unit depth' || nk === 'prehung unit depth'
                ) {
                    if (targetIdx < 0) {
                        targetIdx = i;
                    } else {
                        toRemove.push(i);
                    }
                }
            }
            for (var r = toRemove.length - 1; r >= 0; r--) {
                items.splice(toRemove[r], 1);
            }
            if (targetIdx >= 0 && items[targetIdx]) {
                var dIt = items[targetIdx];
                var dVal = String((dIt && (dIt.value || '')) || '').trim();
                dIt.label = 'Pre-hung Jamb Depth';
                dIt.line = dVal ? 'Pre-hung Jamb Depth: ' + dVal : 'Pre-hung Jamb Depth';
            }
        })();
        // Dp end VDN-390 23-10
        // Dp merge code 10-09 end
        var order = dpPickQuoteDescLabelOrder(labelHints);
        if (order === DP_QUOTE_DESC_LABEL_ORDER_PORCH) {
            isPorchEnclosure = true;
            productThickVal = '';
        }
        if (isMillworkQuote) productThickVal = '';
        if (isHardwareQuote) productThickVal = '';
        items.forEach(function (it) {
            it.rank = dpQuoteDescLabelRankInOrder(it.label, order);
        });
        items.sort(function (a, b) {
            if (a.rank !== b.rank) return a.rank - b.rank;
            return a.idx - b.idx;
        });
        items = dpCollapseQuoteDescDimLines(items, order, opts, rows);
        if (isPorchEnclosure) {
            items.forEach(function (it) {
                it.rank = dpQuoteDescLabelRankInOrder(it.label, order);
            });
            items.sort(function (a, b) {
                if (a.rank !== b.rank) return a.rank - b.rank;
                return a.idx - b.idx;
            });
        }
        // Drop leaked Exact Door / Door|Sidelight|Transom Thickness — porch uses per-opening Panel Thickness.
        if (isPorchEnclosure) {
            items = items.filter(function (it) {
                if (!it) return false;
                var pk = dpNormalizeFieldKey(
                    typeof dpStripOpeningPrefixFromLabel === 'function'
                        ? dpStripOpeningPrefixFromLabel(it.label || '')
                        : it.label || ''
                );
                if (
                    pk === 'door thickness' ||
                    pk === 'exact door thickness' ||
                    pk === 'sidelight thickness' ||
                    pk === 'transom thickness' ||
                    pk === 'gate thickness' ||
                    pk === 'exact gate thickness' ||
                    pk === 'exact door size' ||
                    pk === 'exact door width' ||
                    pk === 'exact door height'
                ) {
                    return false;
                }
                return true;
            });
        }
        if (isMillworkQuote || isHardwareQuote) {
            items = items.filter(function (it) {
                if (!it) return false;
                var pk = dpNormalizeFieldKey(it.label || '');
                return pk !== 'door thickness' && pk !== 'exact door thickness';
            });
        }
        // Dp start 26-08 — Door Thickness: {{value}} only (strip …t from size lines; place after Rough Opening Size)
        items.forEach(function (it) {
            if (!it) return;
            var lab = dpNormalizeFieldKey((it.label || '') + '');
            if (
                lab === 'exact door size' ||
                lab === 'rough opening size' ||
                lab === 'finished opening size' ||
                lab === 'jamb unit size'
            ) {
                var stripped = String(it.value || it.line || '')
                    .replace(/\s*x\s*\d+(?:\s+\d+\/\d+)?\s*t\b/gi, '')
                    .replace(/\s*x\s*\d+(?:\.\d+)?\s*t\b/gi, '')
                    .trim();
                if (stripped && stripped !== String(it.value || '').trim()) {
                    it.value = stripped
                        .replace(/^Exact Door Size:\s*/i, '')
                        .replace(/^Rough Opening Size:\s*/i, '')
                        .trim();
                    it.line = (it.label || 'Exact Door Size') + ': ' + it.value;
                }
            }
            if (
                !isPorchEnclosure &&
                !isMillworkQuote &&
                !isHardwareQuote &&
                (
                lab === 'exact door thickness' ||
                lab === 'door thickness' ||
                lab === 'exact gate thickness' ||
                lab === 'gate thickness' ||
                lab === 'sidelight thickness' ||
                lab === 'transom thickness'
                )
            ) {
                var tv =
                    productThickVal ||
                    String(it.value || '')
                        .replace(/_/g, ' ')
                        .replace(/\s*(?:inches?|_?inch|t)\s*$/i, '')
                        .trim();
                // Dp merge code 10-09 start — never keep _inch / inch on Door Thickness (quote summary)
                if (typeof dpDimensionDropdownDisplayLabel === 'function') tv = dpDimensionDropdownDisplayLabel(tv);
                tv = String(tv || '')
                    .replace(/_/g, ' ')
                    .replace(/\s+/g, ' ')
                    .replace(/\s*(?:inches?|_?inch|t)\s*$/i, '')
                    .trim();
                // Dp merge code 10-09 end
                it.label = productThickLabel;
                it.value = tv;
                it.line = tv ? productThickLabel + ': ' + tv : '';
            }
        });
        // Dp end 26-08
        // Final de-dupe by normalized line text
        var outLines = [];
        var seenLine = {};
        var hasProductThickOut = false;
        var seenFam = {};
        // Dp start 03-09 — detect multiple hardware so Finish / Qty / Closer Color can repeat per item
        var multiHardwareCount = 0;
        try {
            var _hwMulti = (opts && (opts._hardware_selections || opts.hardware_options)) || [];
            if (typeof _hwMulti === 'string') {
                try {
                    _hwMulti = JSON.parse(_hwMulti);
                } catch (eHwM) {
                    _hwMulti = [];
                }
            }
            if (Array.isArray(_hwMulti)) multiHardwareCount = _hwMulti.length;
        } catch (eHwCount) {
            multiHardwareCount = 0;
        }
        var multiHardware = multiHardwareCount > 1;
        // Dp end 03-09
        items.forEach(function (it) {
            var L = String((it && it.line) || '').trim();
            if (!L) return;
            // Dp start 26-08 — drop unlabeled thickness leftover lines
            if (!/^[^:]+:\s*/.test(L) && dpIsBareDoorThicknessDuplicate(L)) return;
            // Dp end 26-08
            var lineKey = dpNormalizeFieldKey(L);
            var isPorchDoor = typeof dpParsePorchDoorField === 'function' && dpParsePorchDoorField(it.label || '');
            var isHwCasQty = /qty$/i.test(dpNormalizeFieldKey(it.label || ''));
            // Dp start 27-08 — porch Door #N and hardware/casing Qty stay unique
            var lk = it.label && (isPorchDoor || isHwCasQty) ? dpNormalizeFieldKey(it.label) + '|' + lineKey : lineKey;
            // Dp end 27-08
            // Dp start 03-09 — multi hardware: drop orphan bare Finish/Closer Color/Qty (use Hardware N … instead)
            if (multiHardware) {
                var bareHwAttr = dpNormalizeFieldKey(it.label || '');
                if (
                    bareHwAttr === 'finish' ||
                    bareHwAttr === 'closer color' ||
                    bareHwAttr === 'hardware qty' ||
                    bareHwAttr === 'qty' ||
                    bareHwAttr === 'hardware door thickness' ||
                    bareHwAttr === 'hardware function' ||
                    bareHwAttr === 'hardware swing direction'
                ) {
                    return;
                }
            }
            // Dp end 03-09
            // Dp start 03-09 — multi hardware: keep each item's Finish / Qty / Closer Color / Hardware N
            if (
                multiHardware &&
                typeof dpIsMultiHardwareRepeatableDescLabel === 'function' &&
                dpIsMultiHardwareRepeatableDescLabel(it.label || L)
            ) {
                lk = dpNormalizeFieldKey(it.label || '') + '|' + lineKey + '|' + outLines.length;
            }
            // Dp end 03-09
            // Dp start 02-09 — drop duplicate Door Thickness when Sidelight/Transom thickness is the product label
            if (
                productThickKey !== 'door thickness' &&
                (lineKey.indexOf('door thickness') === 0 || lineKey.indexOf('exact door thickness') === 0)
            ) {
                return;
            }
            // Dp end 02-09
            if (
                lineKey.indexOf(productThickKey) === 0 ||
                lineKey.indexOf('door thickness') === 0 ||
                lineKey.indexOf('exact door thickness') === 0 ||
                lineKey.indexOf('sidelight thickness') === 0 ||
                lineKey.indexOf('transom thickness') === 0
            ) {
                if (seenLine[productThickKey]) return;
                seenLine[productThickKey] = true;
                hasProductThickOut = true;
                lk = productThickKey;
            }
            if (seenLine[lk]) return;
            // Dp start 27-08 — one line per field family (Wood vs Wood Type, Storm Glass aliases, …)
            // Dp start 03-09 — skip family collapse for porch Door #N (Swing was collapsing to Door #1 only)
            var fam = '';
            if (!isPorchDoor && !isHwCasQty) {
                fam = typeof dpQuoteDescFieldFamily === 'function' ? dpQuoteDescFieldFamily(it.label || L) : '';
            }
            // Dp end 03-09
            // Dp start 03-09 — do not collapse Finish / Hardware Qty across multiple hardware items
            if (
                multiHardware &&
                fam &&
                typeof dpIsMultiHardwareRepeatableDescLabel === 'function' &&
                dpIsMultiHardwareRepeatableDescLabel(it.label || '')
            ) {
                fam = fam + '|' + lk;
            }
            // Dp end 03-09
            if (fam && seenFam[fam]) return;
            if (fam) seenFam[fam] = true;
            // Dp end 27-08
            seenLine[lk] = true;
            outLines.push(L);
        });
        // Dp start 26-08 — ensure one product thickness line after opening size block
        if (productThickVal) {
            var thickLine = productThickLabel + ': ' + productThickVal;
            // Remove duplicate thickness lines before re-insert
            outLines = outLines.filter(function (L) {
                var nk = dpNormalizeFieldKey(L);
                if (productThickKey !== 'door thickness' && (nk.indexOf('door thickness') === 0 || nk.indexOf('exact door thickness') === 0)) {
                    return false;
                }
                return (
                    nk.indexOf(productThickKey) !== 0 &&
                    nk.indexOf('door thickness') !== 0 &&
                    nk.indexOf('exact door thickness') !== 0 &&
                    nk.indexOf('sidelight thickness') !== 0 &&
                    nk.indexOf('transom thickness') !== 0
                );
            });
            var insertAt = -1;
            for (var ri = 0; ri < outLines.length; ri++) {
                if (/^Rough Opening Size\s*:/i.test(outLines[ri])) {
                    insertAt = ri + 1;
                    break;
                }
            }
            if (insertAt < 0) {
                for (var ei = 0; ei < outLines.length; ei++) {
                    if (/^(Exact Door Size|Rough Opening Size|Finished Opening Size|Jamb Unit Size|Exact Gate Size|Exact Sidelight Size|Exact Transom Size)\s*:/i.test(outLines[ei])) {
                        insertAt = ei + 1;
                        break;
                    }
                }
            }
            if (insertAt < 0) {
                for (var pi = 0; pi < outLines.length; pi++) {
                    if (/^Pre-?Hung Unit Depth\s*:/i.test(outLines[pi])) {
                        insertAt = pi + 1;
                        break;
                    }
                }
            }
            if (insertAt < 0) outLines.push(thickLine);
            else outLines.splice(insertAt, 0, thickLine);
            hasProductThickOut = true;
        }
        // Dp end 26-08
        // Dp start 02-09 / 09-09 — Pre-hung Jamb Width immediately after Door Thickness
        (function dpEnsurePreHungDepthAfterThickness() {
            var preHungLine = '';
            var preHungAt = -1;
            for (var p = 0; p < outLines.length; p++) {
                var pL = String(outLines[p] || '').trim();
                var pColon = pL.indexOf(':');
                var pLab = pColon > 0 ? pL.slice(0, pColon) : pL;
                if (dpIsPreHungJambWidthLabelKey(dpNormalizeFieldKey(pLab))) {
                    preHungLine = pL;
                    preHungAt = p;
                    break;
                }
            }
            if (!preHungLine || preHungAt < 0) return;
            var phColon = preHungLine.indexOf(':');
            var phVal = phColon > 0 ? preHungLine.slice(phColon + 1).replace(/^\s+/, '') : '';
            // Dp start VDN-390 23-10
            preHungLine = phVal ? 'Pre-hung Jamb Depth: ' + phVal : 'Pre-hung Jamb Depth';
            // Dp end VDN-390 23-10
            outLines = outLines.filter(function (_, i) {
                return i !== preHungAt;
            });
            // Dp merge code 10-09 start — after Door Thickness / Exact Door Thickness
            var afterAt = typeof dpIndexAfterThicknessLine === 'function'
                ? dpIndexAfterThicknessLine(outLines, productThickKey)
                : (typeof dpIndexAfterOpeningSizeLine === 'function'
                    ? dpIndexAfterOpeningSizeLine(outLines, productThickKey)
                    : -1);
            // Dp merge code 10-09 end
            if (afterAt < 0) outLines.push(preHungLine);
            else outLines.splice(afterAt + 1, 0, preHungLine);
        })();
        // Dp end 02-09 / 07-09 / 09-09
        // Dp start 02-09 — never list standalone Opening W/H alongside combined Opening Size line
        outLines = dpFilterFinishedOpeningSizeForRoughMt(outLines, opts, rows);
        outLines = dpFilterRedundantOpeningDimensionLines(outLines, opts, rows);
        // Finished Opening Size already shown — drop separate Exact Door W/H calc lines
        outLines = dpFilterRedundantExactDoorDimensionLines(outLines, opts, rows);
        // Dp start 03-09 — Rough Opening Size selected → combined Rough Opening Size: Ww x Hh
        outLines = dpInjectRoughOpeningDescriptionLines(outLines, opts, rows);
        outLines = dpFilterRedundantExactComponentDimensionLines(outLines);
        // Dp merge code 10-09 start — backfill Exact Sidelight Width / Exact Transom Height (door+component)
        outLines = dpEnsureExactSidelightWidthAndTransomHeightLines(outLines, opts, rows);
        // Dp merge code 10-09 end
        // Dp end 03-09
        // Pull every measurement line into one block after Panel Profile
        if (!isPorchEnclosure) {
            outLines = dpEnsureMeasurementBlockAfterPanelProfile(outLines);
        }
        // Dp end 02-09
        // Dp merge code 10-09 start — final pass: Unit Depth + Jamb Width → one "Pre-hung Jamb Width" line
        // (must run after inject/filter so nothing re-adds a second title)
        outLines = dpDedupePreHungJambWidthLines(outLines, productThickKey);
        // Dp merge code 10-09 end
        // Dp merge code 10-09 start — split blended Pre-hung W×depth into Jamb Unit Size + Pre-hung depth
        outLines = dpRepairJambUnitSizeAndPreHungLines(outLines, opts, rows);
        // Dp merge code 10-09 end
        // Dp merge code 10-09 start — Exact Sidelight Size: drop extra/stale Jamb Unit Size (e.g. 10 1/4w)
        (function dpDropStaleJambUnitSizeForExactSidelight09() {
            var mtDrop = '';
            try {
                mtDrop = dpNormalizeFieldKey(
                    String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' ')
                );
            } catch (eDropJamb09) { }
            if (mtDrop !== 'exact sidelight size') return;
            outLines = outLines.filter(function (L) {
                var s = String(L || '');
                return !/^Jamb Unit Size\s*:/i.test(s) && !/^Jamb Unit (Width|Height)\s*:/i.test(s);
            });
        })();
        // Dp merge code 10-09 end
        // MERGE: rough_label_fix — do not rename Rough Opening Size → Finished for jamb two-tab
        // Dp merge code 10-09 start — Exact Door Size: Ww x Hh right after Finished Opening Size
        if (!isPorchEnclosure) {
            outLines = dpEnsureExactDoorSizeAfterFinishedOpening(outLines, opts, rows);
        } else {
            outLines = outLines.filter(function (L) {
                return !/^(Exact Door Size|Exact Door Width|Exact Door Height)\s*:/i.test(String(L || ''));
            });
            outLines = dpInsertPorchOpeningGroupBreaks(outLines);
        }
        // Dp merge code 10-09 end
        // Place product Door Thickness immediately after the selected size line
        // (Exact Door Size / Rough Opening Size / Finished Opening Size / …).
        if (!isPorchEnclosure && !isMillworkQuote && !isHardwareQuote) {
            outLines = dpPlaceProductThicknessAfterSelectedSizeLine(
                outLines,
                opts,
                rows,
                productThickLabel,
                productThickKey
            );
        }
        return outLines;
    }

    // Dp start VDN-390 27-10
    // Final description pass: Pre-hung Unit Depth / Jamb Width / Jamb Depth → one "Pre-hung Jamb Depth" line.
    function dpFinalizePreHungDepthDescriptionText(text) {
        var src = String(text == null ? '' : text).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        if (!/pre.?hung/i.test(src)) return text;
        var lines = src.split('\n');
        var phAt = -1;
        var phVal = '';
        var kept = [];
        lines.forEach(function (L) {
            var s = String(L || '').trim();
            var colon = s.indexOf(':');
            var lab = colon > 0 ? dpNormalizeFieldKey(s.slice(0, colon)) : '';
            if (/^pre ?hung (jamb (depth|width)|unit depth)$/.test(lab)) {
                var v = s.slice(colon + 1).replace(/^\s+/, '');
                if (v && (!phVal || (/\d+\s*\/\s*\d+/.test(v) && !/\d+\s*\/\s*\d+/.test(phVal)))) phVal = v;
                if (phAt < 0) phAt = kept.length;
                return;
            }
            kept.push(L);
        });
        if (phAt >= 0 && phVal) kept.splice(phAt, 0, 'Pre-hung Jamb Depth: ' + phVal);
        return kept.join('\n');
    }
    // Dp end VDN-390 27-10

    // Door Thickness (or Sidelight/Transom/Gate Thickness) right after the front-selected size line.
    function dpPlaceProductThicknessAfterSelectedSizeLine(outLines, opts, rows, productThickLabel, productThickKey) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        if (!outLines.length) return outLines;
        var thickKey = dpNormalizeFieldKey(productThickLabel || productThickKey || 'Door Thickness');
        var thickLines = [];
        var rest = [];
        outLines.forEach(function (L) {
            var s = String(L || '').trim();
            if (!s) return;
            var colon = s.indexOf(':');
            var lab = colon > 0 ? dpNormalizeFieldKey(s.slice(0, colon)) : '';
            if (
                lab === 'door thickness' ||
                lab === 'exact door thickness' ||
                lab === 'sidelight thickness' ||
                lab === 'transom thickness' ||
                lab === 'gate thickness' ||
                lab === 'exact gate thickness'
            ) {
                thickLines.push(s);
            } else {
                rest.push(s);
            }
        });
        if (!thickLines.length) return outLines;

        var mt = '';
        try {
            mt = dpNormalizeFieldKey(
                String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' ')
            );
        } catch (eMtThick) {
            mt = '';
        }
        var sizeMatchers = [];
        if (mt === 'exact door size') {
            sizeMatchers = [/^Exact Door Size\s*:/i];
        } else if (mt === 'rough opening size' || (typeof dpIsRoughOpeningMeasurementKey === 'function' && dpIsRoughOpeningMeasurementKey(mt))) {
            sizeMatchers = [/^Rough Opening Size\s*:/i];
        } else if (mt.indexOf('finished') === 0) {
            sizeMatchers = [/^Finished Opening Size\s*:/i];
        } else if (mt === 'jamb unit size' || mt.indexOf('pre hung') === 0 || mt.indexOf('prehung') === 0) {
            sizeMatchers = [/^Jamb Unit Size\s*:/i, /^Pre-Hung Unit Size\s*:/i];
        } else if (mt === 'exact gate size') {
            sizeMatchers = [/^Exact Gate Size\s*:/i];
        } else if (mt === 'exact sidelight size') {
            sizeMatchers = [/^Exact Sidelight Size\s*:/i];
        } else if (mt === 'exact transom size') {
            sizeMatchers = [/^Exact Transom Size\s*:/i];
        } else {
            sizeMatchers = [
                /^Exact Door Size\s*:/i,
                /^Rough Opening Size\s*:/i,
                /^Finished Opening Size\s*:/i,
                /^Jamb Unit Size\s*:/i,
                /^Exact Gate Size\s*:/i,
                /^Exact Sidelight Size\s*:/i,
                /^Exact Transom Size\s*:/i
            ];
        }

        var sizeAt = -1;
        var mi;
        var i;
        for (mi = 0; mi < sizeMatchers.length && sizeAt < 0; mi++) {
            for (i = 0; i < rest.length; i++) {
                if (sizeMatchers[mi].test(String(rest[i] || ''))) {
                    sizeAt = i;
                    break;
                }
            }
        }
        var insertAt = sizeAt < 0 ? rest.length : sizeAt + 1;
        // Keep Pre-hung Jamb Depth between size and thickness when it already follows the size line
        if (sizeAt >= 0 && insertAt < rest.length) {
            var nextL = String(rest[insertAt] || '');
            // Dp start VDN-390 23-10
            if (
                /^Pre-?hung\s+Jamb\s+(Depth|Width)\s*:/i.test(nextL) ||
                /^Pre-?Hung Unit Depth\s*:/i.test(nextL)
            ) {
                insertAt += 1;
            }
            // Dp end VDN-390 23-10
        }

        var thickLine = thickLines[0];
        for (i = 0; i < thickLines.length; i++) {
            var tLab = String(thickLines[i] || '').split(':')[0] || '';
            if (dpNormalizeFieldKey(tLab) === thickKey) {
                thickLine = thickLines[i];
                break;
            }
        }
        rest.splice(insertAt, 0, thickLine);
        return rest;
    }

    // Dp merge code 10-09 start — collapse Exact Door Width/Height → Exact Door Size after Finished Opening Size
    // Simple ensure: Exact Door W/H + exact-door_* / door_* keys only (no panel/jamb width fallbacks)
    function dpEnsureExactDoorSizeAfterFinishedOpening(outLines, opts, rows) {
        outLines = Array.isArray(outLines) ? outLines.slice() : [];
        opts = opts || {};
        rows = rows || [];
        function stripDim(v) {
            return String(v == null ? '' : v)
                .replace(/\s*inches?\s*$/i, '')
                .replace(/\s*[wh]$/i, '')
                .replace(/\s+0$/i, '')
                .trim();
        }
        // Dp merge code 10-09 start — Gate: Exact Gate Size only (never Exact Door Size) — admin parity
        var mtGate09 = '';
        try {
            mtGate09 = dpNormalizeFieldKey(
                String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' ')
            );
        } catch (eMtG09) { }
        var isGate09 = mtGate09 === 'exact gate size';
        if (!isGate09) {
            var colG09 = String(
                opts._route_collection || opts._collection_handle || opts._product_type || ''
            ).toLowerCase();
            if (colG09.indexOf('gate') !== -1) isGate09 = true;
        }
        if (!isGate09) {
            isGate09 = outLines.some(function (Lg) {
                return /^(Exact Gate Size|Gate Thickness)\s*:/i.test(String(Lg || ''));
            });
        }
        if (isGate09) {
            var gwTok = '';
            var ghTok = '';
            var panelAtG = -1;
            var keptG = [];
            function parseGateOrDoorSize(L) {
                var m = String(L || '').match(/^Exact (?:Gate|Door) Size\s*:\s*(.+)$/i);
                if (!m) return { w: '', h: '' };
                var body = String(m[1] || '').trim();
                var wM = body.match(/(\d+(?:\s+\d+\/\d+)?|\d+\/\d+|\d+(?:\.\d+)?)\s*w\b/i);
                var hM = body.match(/(\d+(?:\s+\d+\/\d+)?|\d+\/\d+|\d+(?:\.\d+)?)\s*h\b/i);
                if (wM || hM) {
                    return { w: wM ? stripDim(wM[1]) : '', h: hM ? stripDim(hM[1]) : '' };
                }
                var parts = body.split(/\s+[x×]\s+/i);
                if (parts.length >= 2) {
                    return { w: stripDim(parts[0]), h: stripDim(parts[1]) };
                }
                return { w: '', h: '' };
            }
            for (var gi = 0; gi < outLines.length; gi++) {
                var gL = String(outLines[gi] || '').trim();
                if (!gL) continue;
                if (/^Panel Profile\s*:/i.test(gL)) {
                    panelAtG = keptG.length;
                    keptG.push(gL);
                    continue;
                }
                if (/^Exact Door Size\s*:/i.test(gL) || /^Exact Gate Size\s*:/i.test(gL)) {
                    var gp = parseGateOrDoorSize(gL);
                    if (gp.w && !gwTok) gwTok = gp.w;
                    if (gp.h && !ghTok) ghTok = gp.h;
                    continue; // drop; rebuild Exact Gate Size below
                }
                if (/^(Exact\s+)?(Gate|Door)\s+Width\s*:/i.test(gL)) {
                    var gwm = gL.match(/:\s*(.+)$/);
                    if (gwm && !gwTok) gwTok = stripDim(gwm[1]);
                    continue;
                }
                if (/^(Exact\s+)?(Gate|Door)\s+Height\s*:/i.test(gL)) {
                    var ghm = gL.match(/:\s*(.+)$/);
                    if (ghm && !ghTok) ghTok = stripDim(ghm[1]);
                    continue;
                }
                // Dp merge code 10-09 start — gate front has no sidelight/transom; drop duplicate bleed lines
                if (
                    /^(Exact\s+)?Sidelight\s+(Width|Height|Size)\s*:/i.test(gL) ||
                    /^(Exact\s+)?Transom\s+(Width|Height|Size)\s*:/i.test(gL)
                ) {
                    continue;
                }
                // Dp merge code 10-09 end
                keptG.push(gL);
            }
            (Array.isArray(rows) ? rows : []).forEach(function (item) {
                if (!item || typeof item === 'string') return;
                var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
                var val = stripDim(item.value != null ? item.value : item.display || '');
                if (!val) return;
                if (
                    (lab === 'exact gate width' ||
                        lab === 'gate width' ||
                        lab === 'exact door width' ||
                        lab === 'door width') &&
                    !gwTok
                ) {
                    gwTok = val;
                }
                if (
                    (lab === 'exact gate height' ||
                        lab === 'gate height' ||
                        lab === 'exact door height' ||
                        lab === 'door height') &&
                    !ghTok
                ) {
                    ghTok = val;
                }
                if ((lab === 'exact gate size' || lab === 'exact door size') && (!gwTok || !ghTok)) {
                    var fromG = parseGateOrDoorSize('Exact Gate Size: ' + val);
                    if (fromG.w && !gwTok) gwTok = fromG.w;
                    if (fromG.h && !ghTok) ghTok = fromG.h;
                }
            });
            if (!gwTok || !ghTok) {
                try {
                    if (!gwTok) {
                        gwTok = stripDim(
                            dpCombineDimensionInchesLabel(
                                dpReadOptKeys(opts, [
                                    'exact-door-width-int',
                                    'exact_door_width_int',
                                    'door_width',
                                    'exact_door_width',
                                    'gate_width',
                                    'gate_width_int',
                                ]),
                                dpReadOptKeys(opts, [
                                    'exact-door-width-frac',
                                    'exact_door_width_frac',
                                    'exact_door_width_fraction',
                                    'door_width_fraction',
                                    'gate_width_frac',
                                    'gate_width_fraction',
                                ])
                            )
                        );
                    }
                    if (!ghTok) {
                        ghTok = stripDim(
                            dpCombineDimensionInchesLabel(
                                dpReadOptKeys(opts, [
                                    'exact-door-height-int',
                                    'exact_door_height_int',
                                    'door_height',
                                    'exact_door_height',
                                    'gate_height',
                                    'gate_height_int',
                                ]),
                                dpReadOptKeys(opts, [
                                    'exact-door-height-frac',
                                    'exact_door_height_frac',
                                    'door_height_fraction',
                                    'door_height_frac',
                                    'gate_height_frac',
                                    'gate_height_fraction',
                                ])
                            )
                        );
                    }
                } catch (eGateRead09) { }
            }
            if (gwTok && ghTok) {
                // Dp merge code 10-09 start — reject frac-only tokens (e.g. 1/2) before emitting Exact Gate Size
                if (/^\d+\s*\/\s*\d+$/.test(gwTok) || /^\d+\s*\/\s*\d+$/.test(ghTok)) {
                    return keptG;
                }
                // Dp merge code 10-09 end
                var gateLine = 'Exact Gate Size: ' + gwTok + 'w x ' + ghTok + 'h';
                // Dp merge code 10-09 start — after Wood: Exact Gate Size then Gate Thickness (not unshift to top)
                var gateThickLine = '';
                var woodAtG = -1;
                var rebuiltG = [];
                for (var rgi = 0; rgi < keptG.length; rgi++) {
                    var rL = String(keptG[rgi] || '');
                    if (/^(Exact\s+)?Gate Thickness\s*:/i.test(rL)) {
                        if (!gateThickLine) gateThickLine = rL;
                        continue;
                    }
                    if (/^(Select\s+)?Wood\s*:/i.test(rL) || /^Wood Species\s*:/i.test(rL)) {
                        woodAtG = rebuiltG.length;
                    }
                    rebuiltG.push(rL);
                }
                keptG = rebuiltG;
                var insertGateAt = woodAtG >= 0 ? woodAtG + 1 : panelAtG >= 0 ? panelAtG + 1 : 0;
                keptG.splice(insertGateAt, 0, gateLine);
                if (gateThickLine) keptG.splice(insertGateAt + 1, 0, gateThickLine);
                // Dp merge code 10-09 end
            }
            return keptG;
        }
        // Dp merge code 10-09 end
        function tokenFromLine(L, which) {
            var m = String(L || '').match(
                which === 'w'
                    ? /^Exact Door Width\s*:\s*(.+)$/i
                    : /^Exact Door Height\s*:\s*(.+)$/i
            );
            if (!m) return '';
            return stripDim(m[1]);
        }
        function parseSizeLine(L) {
            var m = String(L || '').match(/^Exact Door Size\s*:\s*(.+)$/i);
            if (!m) return { w: '', h: '' };
            var body = String(m[1] || '').trim();
            var wM = body.match(/(\d+(?:\s+\d+\/\d+)?|\d+\/\d+|\d+(?:\.\d+)?)\s*w\b/i);
            var hM = body.match(/(\d+(?:\s+\d+\/\d+)?|\d+\/\d+|\d+(?:\.\d+)?)\s*h\b/i);
            if (wM || hM) {
                return { w: wM ? stripDim(wM[1]) : '', h: hM ? stripDim(hM[1]) : '' };
            }
            var parts = body.split(/\s+[x×]\s+/i);
            if (parts.length >= 2) {
                return { w: stripDim(parts[0]), h: stripDim(parts[1]) };
            }
            return { w: '', h: '' };
        }
        var wTok = '';
        var hTok = '';
        var finishedAt = -1;
        var sizeAt = -1;
        var kept = [];
        for (var i = 0; i < outLines.length; i++) {
            var L = String(outLines[i] || '').trim();
            if (!L) continue;
            if (/^Finished Opening Size\s*:/i.test(L)) {
                finishedAt = kept.length;
                kept.push(L);
                continue;
            }
            // Rough Opening Size (jamb two-tab / rough) — same anchor as Finished for Exact Door placement
            if (finishedAt < 0 && /^Rough Opening Size\s*:/i.test(L)) {
                finishedAt = kept.length;
                kept.push(L);
                continue;
            }
            if (/^Exact Door Size\s*:/i.test(L)) {
                var parsed = parseSizeLine(L);
                if (parsed.w && !wTok) wTok = parsed.w;
                if (parsed.h && !hTok) hTok = parsed.h;
                // Keep complete Size; drop incomplete (rebuild below when both dims resolve)
                if (parsed.w && parsed.h) {
                    sizeAt = kept.length;
                    kept.push(L);
                }
                continue;
            }
            if (/^Exact Door Width\s*:/i.test(L)) {
                wTok = tokenFromLine(L, 'w') || wTok;
                continue;
            }
            if (/^Exact Door Height\s*:/i.test(L)) {
                hTok = tokenFromLine(L, 'h') || hTok;
                continue;
            }
            kept.push(L);
        }
        (Array.isArray(rows) ? rows : []).forEach(function (item) {
            if (!item || typeof item === 'string') return;
            var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
            var val = stripDim(item.value != null ? item.value : item.display || '');
            if (!val) return;
            if ((lab === 'exact door width' || lab === 'door width') && !wTok) wTok = val;
            if ((lab === 'exact door height' || lab === 'door height') && !hTok) hTok = val;
            if (lab === 'exact door size' && (!wTok || !hTok)) {
                var fromRow = parseSizeLine('Exact Door Size: ' + val);
                if (fromRow.w && !wTok) wTok = fromRow.w;
                if (fromRow.h && !hTok) hTok = fromRow.h;
            }
        });
        if ((!wTok || !hTok) && typeof dpCombineDimensionInchesLabel === 'function' && typeof dpReadOptKeys === 'function') {
            if (!wTok) {
                wTok = stripDim(
                    dpCombineDimensionInchesLabel(
                        dpReadOptKeys(opts, [
                            'exact-door-width-int',
                            'exact_door_width_int',
                            'exact-door-width',
                            'exact_door_width',
                            'door_width',
                            'door-width',
                        ]),
                        dpReadOptKeys(opts, [
                            'exact-door-width-frac',
                            'exact_door_width_frac',
                            'exact_door_width_fraction_value',
                            'exact_door_width_fraction',
                            'door_width_fraction_value',
                            'door_width_fraction',
                            'exact-door-width-frac_label',
                            'exact_door_width_frac_label',
                        ])
                    )
                );
            }
            if (!hTok) {
                hTok = stripDim(
                    dpCombineDimensionInchesLabel(
                        dpReadOptKeys(opts, [
                            'exact-door-height-int',
                            'exact_door_height_int',
                            'door_height',
                            'door-height',
                            'exact_door_height',
                        ]),
                        dpReadOptKeys(opts, [
                            'exact-door-height-frac',
                            'exact_door_height_frac',
                            'exact_door_height_fraction_value',
                            'door_height_fraction_value',
                            'door_height_fraction',
                            'door_height_frac',
                            'exact-door-height-frac_label',
                        ])
                    )
                );
            }
        }
        // Need both dims — leave description unchanged if Exact Door W/H cannot be resolved
        if (!wTok || !hTok) {
            return outLines;
        }
        var sizeLine = 'Exact Door Size: ' + wTok + 'w x ' + hTok + 'h';
        if (sizeAt >= 0) {
            kept[sizeAt] = sizeLine;
        } else if (finishedAt >= 0) {
            kept.splice(finishedAt + 1, 0, sizeLine);
        } else {
            // No Finished Opening Size: place after Panel Profile / Stile and Rail Profile (not end of list)
            var panelIns = -1;
            for (var pi = 0; pi < kept.length; pi++) {
                if (/^Panel Profile\s*:/i.test(String(kept[pi] || ''))) {
                    panelIns = pi;
                    break;
                }
            }
            if (panelIns < 0) {
                for (var si = 0; si < kept.length; si++) {
                    if (/^Stile and Rail Profile\s*:/i.test(String(kept[si] || ''))) {
                        panelIns = si;
                        break;
                    }
                }
            }
            if (panelIns >= 0) kept.splice(panelIns + 1, 0, sizeLine);
            else kept.push(sizeLine);
            // Dp merge code 10-09 end
        }
        var finIdx = -1;
        var exactIdx = -1;
        var panelIdx = -1;
        for (var j = 0; j < kept.length; j++) {
            if (/^(Panel Profile|Stile and Rail Profile)\s*:/i.test(String(kept[j] || ''))) panelIdx = j;
            if (/^(Finished Opening Size|Rough Opening Size)\s*:/i.test(String(kept[j] || ''))) finIdx = j;
            if (/^Exact Door Size\s*:/i.test(String(kept[j] || ''))) exactIdx = j;
        }
        if (finIdx >= 0 && exactIdx >= 0 && exactIdx !== finIdx + 1) {
            var exactLine = kept.splice(exactIdx, 1)[0];
            if (exactIdx < finIdx) finIdx -= 1;
            kept.splice(finIdx + 1, 0, exactLine);
        } else if (finIdx < 0 && panelIdx >= 0 && exactIdx >= 0 && exactIdx !== panelIdx + 1) {
            // Exact Door Size immediately after Panel Profile / Stile and Rail Profile
            var exactLinePp = kept.splice(exactIdx, 1)[0];
            if (exactIdx < panelIdx) panelIdx -= 1;
            kept.splice(panelIdx + 1, 0, exactLinePp);
            // Dp merge code 10-09 end
        }
        return kept;
    }
    // Dp merge code 10-09 end

    function dpLookupLabelForValue(opts, value) {
        opts = opts || {};
        var want = dpNormalizeFieldKey(dpTidyLabeledValue(value));
        if (!want) return '';
        var props = opts._line_item_properties;
        if (props && typeof props === 'object' && !Array.isArray(props)) {
            var keys = Object.keys(props);
            for (var i = 0; i < keys.length; i++) {
                var k = keys[i];
                if (!k || k.charAt(0) === '_') continue;
                var pv = String(props[k] == null ? '' : props[k]).trim();
                if (dpNormalizeFieldKey(dpTidyLabeledValue(pv)) === want) return k;
            }
        }
        var schema = opts._pricing_schema;
        if (Array.isArray(schema)) {
            for (var s = 0; s < schema.length; s++) {
                var opt = schema[s];
                if (!opt || !opt.id) continue;
                var raw = opts[opt.id];
                if (raw == null || raw === '') continue;
                if (opt.options && Array.isArray(opt.options)) {
                    for (var c = 0; c < opt.options.length; c++) {
                        var ch = opt.options[c];
                        var cl = String((ch && (ch.label || ch.value)) || '').trim();
                        var cv = String((ch && ch.value) || '').trim();
                        if (dpNormalizeFieldKey(cl) === want || dpNormalizeFieldKey(cv) === want) {
                            return String(opt.label || opt.id);
                        }
                    }
                }
                var display = Array.isArray(raw) ? raw.join(', ') : String(raw);
                if (dpNormalizeFieldKey(display) === want) return String(opt.label || opt.id);
            }
        }
        return '';
    }

    // Dp start 25-08 — Expected: Hardware title + Finish:/Hardware Function:/Door Thickness:/Qty:; Casing + Length:/Qty:
    // Dp start 03-09 — multi hardware: emit every _hardware_selections row (Hardware 1 / Hardware 2 …)
    function dpPushHardwareSelectionDescriptionRows(out, row, itemNo, total) {
        if (!row || typeof row !== 'object') return;
        out = Array.isArray(out) ? out : [];
        var n = parseInt(itemNo, 10);
        if (!(n > 0)) n = 1;
        var tot = parseInt(total, 10);
        if (!(tot > 0)) tot = 1;
        var multi = tot > 1;
        // Single: Hardware / Hardware Finish / Hardware Quantity. Multiple: Hardware N + attrs
        var hwLabel = multi ? 'Hardware ' + n : 'Hardware';
        var title = String(row.title || row.product_id || '').trim();
        if (title) out.push({ label: hwLabel, value: title });

        // Dp start 03-09 — multi order: Closer Color → Door Thickness → Finish → Function/Swing → Qty last
        // Dp merge code 10-09 start — storefront labels: Hardware Finish / Hardware Quantity
        var qtyLabel = multi ? 'Hardware ' + n + ' Quantity' : 'Hardware Quantity';
        var closerLabel = multi ? 'Hardware ' + n + ' Closer Color' : 'Closer Color';
        var thickLabel = multi ? 'Hardware ' + n + ' Door Thickness' : 'Hardware Door Thickness';
        var finishLabel = multi ? 'Hardware ' + n + ' Finish' : 'Hardware Finish';
        var funcLabel = multi ? 'Hardware ' + n + ' Function' : 'Hardware Function';
        var swingLabel = multi ? 'Hardware ' + n + ' Swing Direction' : 'Hardware Swing Direction';
        var backsetLabel = multi ? 'Hardware ' + n + ' Backset' : 'Hardware Backset';
        // Dp merge code 10-09 end

        var closerColor = String(row.closer_color_label || row.closer_color_value || '').trim();
        if (closerColor && !/^(select|please select|not selected|none)$/i.test(closerColor)) {
            out.push({ label: closerLabel, value: closerColor });
        }

        var thick = String(row.thickness_label || row.thickness_value || '').trim();
        if (thick) {
            out.push({
                label: thickLabel,
                value: typeof dpFormatHardwareThicknessToken === 'function' ? dpFormatHardwareThicknessToken(thick) : thick,
            });
        }

        var finish = String(row.finish_label || row.finish_value || '').trim();
        if (finish) out.push({ label: finishLabel, value: finish });

        var func = String(row.function_label || row.function_value || '').trim();
        if (func && !/^(select|please select|not selected|none)$/i.test(func)) {
            out.push({ label: funcLabel, value: func });
        }
        if (typeof dpHardwareRowHasSwingField === 'function' && dpHardwareRowHasSwingField(row)) {
            var hwSwing = String(
                row.hardware_swing_direction_label || row.hardware_swing_direction_value || ''
            ).trim();
            if (hwSwing && !/^(select|please select|not selected|none)$/i.test(hwSwing)) {
                out.push({ label: swingLabel, value: hwSwing });
            }
        }

        var backset = String(row.backset_label || row.backset_value || '').trim();
        if (backset && !/^(select|please select|not selected|none)$/i.test(backset)) {
            var cleanBackset = typeof dpCleanHardwareMeasureValue === 'function'
                ? dpCleanHardwareMeasureValue(backset)
                : backset;
            if (cleanBackset) out.push({ label: backsetLabel, value: cleanBackset });
        }

        var hwQty = parseInt(row.qty, 10);
        if (!(hwQty > 0)) hwQty = 1;
        out.push({ label: qtyLabel, value: String(hwQty) });
        // Dp end 03-09
    }

    function dpIsMultiHardwareRepeatableDescLabel(label) {
        var nk = typeof dpNormalizeFieldKey === 'function' ? dpNormalizeFieldKey(label) : String(label || '').toLowerCase();
        if (!nk) return false;
        // Hardware 1 / Hardware 1 Qty / Hardware 1 Finish / …
        if (/^hardware\s+\d+/.test(nk)) return true;
        return (
            nk === 'finish' ||
            nk === 'closer color' ||
            nk === 'hardware function' ||
            nk === 'hardware swing direction' ||
            nk === 'hardware door thickness' ||
            nk === 'door backset' ||
            nk === 'hardware backset' ||
            nk === 'hardware qty' ||
            nk === 'hardware' ||
            nk === 'qty'
        );
    }
    // Dp end 03-09

    function dpExpandHardwareCasingRowsForDescription(rows, opts) {
        rows = Array.isArray(rows) ? rows.slice() : [];
        opts = opts || {};
        function asArr(v) {
            if (Array.isArray(v)) return v;
            if (typeof v === 'string' && v) {
                try {
                    var p = JSON.parse(v);
                    return Array.isArray(p) ? p : [];
                } catch (eP) {
                    return [];
                }
            }
            return [];
        }
        var hw = asArr(opts._hardware_selections || opts.hardware_options);
        var casing = asArr(opts._casing_selections || opts.casing_options);
        var hwTotal = hw.length;
        var hwIdx = 0;
        var casIdx = 0;
        var out = [];
        rows.forEach(function (r) {
            var label = typeof r === 'string' ? '' : (r && (r.label || r.id)) || '';
            var labelKey = String(label).toLowerCase().replace(/[_-]+/g, ' ').trim();
            // Dp start 03-09 — when multiple hardware, drop bare Finish/Qty/… (rebuilt under Hardware N)
            if (
                hwTotal > 1 &&
                (labelKey === 'finish' ||
                    labelKey === 'closer color' ||
                    labelKey === 'hardware function' ||
                    labelKey === 'hardware swing direction' ||
                    labelKey === 'hardware door thickness' ||
                    labelKey === 'door backset' ||
                    labelKey === 'hardware backset' ||
                    labelKey === 'hardware qty' ||
                    labelKey === 'qty' ||
                    /^hardware\s+\d+\s+/.test(labelKey))
            ) {
                return;
            }
            // Dp end 03-09
            if (
                (labelKey === 'hardware' || /^hardware\s+\d+$/.test(labelKey) ||
                    (labelKey.indexOf('hardware') === 0 &&
                        labelKey.indexOf('function') === -1 &&
                        labelKey.indexOf('finish') === -1 &&
                        labelKey.indexOf('swing') === -1 &&
                        labelKey.indexOf('thickness') === -1 &&
                        labelKey.indexOf('qty') === -1 &&
                        labelKey.indexOf('quantity') === -1 &&
                        labelKey.indexOf('closer') === -1))
            ) {
                var row = hw[hwIdx] || null;
                hwIdx += 1;
                if (row && typeof row === 'object') {
                    // Dp start 03-09 — numbered Hardware N when multiple selections
                    dpPushHardwareSelectionDescriptionRows(out, row, hwIdx, hwTotal);
                    // Dp end 03-09
                    return;
                }
            }
            if (
                labelKey.indexOf('casing') === 0 &&
                labelKey.indexOf('qty') === -1 &&
                labelKey.indexOf('quantity') === -1 &&
                // Dp merge code 10-09 start — do not re-expand Casing Length as a casing title
                labelKey.indexOf('length') === -1
                // Dp merge code 10-09 end
            ) {
                var crow = casing[casIdx] || null;
                casIdx += 1;
                if (crow && typeof crow === 'object') {
                    var ctitle = String(crow.title || crow.product_id || '').trim();
                    if (ctitle) out.push({ label: 'Casing', value: ctitle });
                    var clen = String(crow.length_label || crow.length_value || '').trim();
                    // Dp merge code 10-09 start — Casing Length (not bare Length)
                    if (clen) out.push({ label: 'Casing Length', value: clen });
                    // Dp merge code 10-09 end
                    // Dp start 27-08 — selected casing qty (default 1)
                    var casQty = parseInt(crow.qty, 10);
                    if (!(casQty > 0)) casQty = 1;
                    out.push({ label: 'Casing Qty', value: String(casQty) });
                    // Dp end 27-08
                    return;
                }
                var raw = String((r && (r.value || r.display)) || '').trim();
                if (raw) {
                    var parts = raw.split(/\s+—\s+/);
                    var main = String(parts[0] || raw)
                        .replace(/\s*\(×\d+\)\s*$/u, '')
                        .trim();
                    if (main) out.push({ label: 'Casing', value: main });
                    if (parts[1]) {
                        var lenPart = String(parts[1])
                            .replace(/\s*\(×\d+\)\s*$/u, '')
                            .trim();
                        // Dp merge code 10-09 start — Casing Length (not bare Length)
                        if (lenPart) out.push({ label: 'Casing Length', value: lenPart });
                        // Dp merge code 10-09 end
                    }
                    // Dp start 27-08 — qty from combined casing summary "(×N)"
                    var casQ = raw.match(/\(×(\d+)\)\s*$/u);
                    var casQtyFb = casQ ? parseInt(casQ[1], 10) : 1;
                    if (!(casQtyFb > 0)) casQtyFb = 1;
                    out.push({ label: 'Casing Qty', value: String(casQtyFb) });
                    // Dp end 27-08
                    return;
                }
            }
            out.push(r);
        });
        // Dp start 03-09 — append remaining / missing hardware selections (2nd, 3rd, …)
        if (hwTotal > 0) {
            if (hwIdx === 0) {
                for (var hiAll = 0; hiAll < hwTotal; hiAll++) {
                    dpPushHardwareSelectionDescriptionRows(out, hw[hiAll], hiAll + 1, hwTotal);
                }
            } else {
                while (hwIdx < hwTotal) {
                    hwIdx += 1;
                    dpPushHardwareSelectionDescriptionRows(out, hw[hwIdx - 1], hwIdx, hwTotal);
                }
            }
        }
        // Dp end 03-09
        return out;
    }
    // Dp end 25-08

    // Dp start 02-09 — storefront cleanup only (Verify Finish injection is admin/PHP only)
    function dpIsHungPreHungOptionValue(v) {
        var s = dpNormalizeFieldKey(v);
        if (!s) return false;
        if (/slab/.test(s)) return false;
        if (/please select|not selected|^select$/.test(s)) return false;
        return true;
    }

    function dpInjectQuoteDescFallbackRows(rows, opts) {
        rows = Array.isArray(rows) ? rows.slice() : [];
        opts = opts || {};
        // Drop stale placeholder rows — not shown on Request-a-Quote / saved configs
        rows = rows.filter(function (r) {
            if (!r) return false;
            var v = typeof r === 'string' ? r : String((r && (r.value || r.display || r.name)) || '');
            var vk = dpNormalizeFieldKey(v);
            if (vk === 'verify swing direction' || vk === 'verify finish') return false;
            return true;
        });
        // Dp start 02-09 — drop phantom Hardware Swing Direction when hardware product has no swing field
        if (!dpHardwareSelectionsHaveSwingField(opts)) {
            rows = rows.filter(function (r) {
                if (!r) return false;
                var lbl = typeof r === 'string' ? '' : (r && (r.label || r.id)) || '';
                return dpNormalizeFieldKey(lbl) !== 'hardware swing direction';
            });
        }
        // Dp end 02-09
        // Slab-only doors never show Hinge Finish
        var hungCheck = opts.pre_hung || opts.door_setup || '';
        if (!dpIsHungPreHungOptionValue(hungCheck)) {
            var sVal = String(hungCheck).toLowerCase();
            if (sVal.indexOf('slab') !== -1) {
                rows = rows.filter(function (r) {
                    if (!r) return false;
                    var lbl = typeof r === 'string' ? '' : (r && (r.label || r.id)) || '';
                    var n = dpNormalizeFieldKey(lbl);
                    return n !== 'hinge finish';
                });
            }
        }
        return rows;
    }
    // Dp end 02-09

    // Dp start 26-08 — backfill Exact Door / Sidelight / Transom / Pre-Hung (+ fractions) on quote cart
    /** Map stored select values (0.375, 2.25) to dropdown labels (3/8, 2 1/4). */
    function dpDimensionDropdownDisplayLabel(raw) {
        var s = String(raw == null ? '' : raw).trim();
        if (!s) return '';
        // Dp merge code 10-09 start — strip inch / _inch before letter short-circuit (Door Thickness)
        s = s
            .replace(/_/g, ' ')
            .replace(/\s+/g, ' ')
            .replace(/\s*(?:inches?|_?inch)\s*$/i, '')
            .trim();
        // Dp merge code 10-09 end
        if (s === '0' || s === '00' || s === '0/0' || s === '0.0' || s === '0.00') return '0';
        // Already a fraction / mixed label from the dropdown.
        if (/^\d+\s+\d+\/\d+$/.test(s) || /^\d+\/\d+$/.test(s)) return s;
        // Dp start 03-09 — repair missing space ("11/2" → "1 1/2")
        if (/^(\d)(\d+\/\d+)$/.test(s)) {
            return s.replace(/^(\d)(\d+\/\d+)$/, '$1 $2');
        }
        // Dp end 03-09
        if (/[a-z]/i.test(s) && !/^\d+(\.\d+)?$/.test(s)) return s;
        var thickMap = {
            1.125: '1 1/8',
            1.25: '1 1/4',
            1.375: '1 3/8',
            1.5: '1 1/2',
            1.75: '1 3/4',
            2.25: '2 1/4',
            2.5: '2 1/2',
            2.75: '2 3/4',
        };
        if (Object.prototype.hasOwnProperty.call(thickMap, s)) return thickMap[s];
        var n = parseFloat(s);
        if (isNaN(n)) return s;
        for (var tk in thickMap) {
            if (!Object.prototype.hasOwnProperty.call(thickMap, tk)) continue;
            if (Math.abs(parseFloat(tk) - n) < 0.0001) return thickMap[tk];
        }
        var fracMap = [
            { v: 0, l: '0' },
            { v: 0.0625, l: '1/16' },
            { v: 0.125, l: '1/8' },
            { v: 0.1875, l: '3/16' },
            { v: 0.25, l: '1/4' },
            { v: 0.3125, l: '5/16' },
            { v: 0.375, l: '3/8' },
            { v: 0.4375, l: '7/16' },
            { v: 0.5, l: '1/2' },
            { v: 0.5625, l: '9/16' },
            { v: 0.625, l: '5/8' },
            { v: 0.6875, l: '11/16' },
            { v: 0.75, l: '3/4' },
            { v: 0.8125, l: '13/16' },
            { v: 0.875, l: '7/8' },
            { v: 0.9375, l: '15/16' },
        ];
        if (n >= 0 && n < 1) {
            for (var i = 0; i < fracMap.length; i++) {
                if (Math.abs(fracMap[i].v - n) < 0.0001) return fracMap[i].l;
            }
            return s;
        }
        // Mixed inches stored as one decimal (e.g. 47.375 → 47 3/8).
        var intPart = Math.floor(n + 1e-9);
        var fracPart = Math.round((n - intPart) * 10000) / 10000;
        var fracLab = '';
        for (var j = 0; j < fracMap.length; j++) {
            if (Math.abs(fracMap[j].v - fracPart) < 0.0001) {
                fracLab = fracMap[j].l;
                break;
            }
        }
        if (!fracLab || fracLab === '0') return String(intPart);
        return intPart + ' ' + fracLab;
    }

    function dpCombineDimensionInchesLabel(intVal, fracVal) {
        intVal = String(intVal == null ? '' : intVal).trim();
        fracVal = String(fracVal == null ? '' : fracVal).trim();
        // Prefer dropdown labels over raw option values (0.375 → 3/8, 2.25 → 2 1/4).
        intVal = dpDimensionDropdownDisplayLabel(intVal);
        fracVal = dpDimensionDropdownDisplayLabel(fracVal);
        if (
            fracVal === '0' ||
            fracVal === '0/0' ||
            fracVal === '0"' ||
            fracVal === '0 ' ||
            fracVal === '0.0' ||
            fracVal === '00'
        ) {
            fracVal = '';
        }
        if (!intVal && !fracVal) return '';
        // Frac / thickness field sometimes stores the full "4 9/16" or "1 1/8" label alone.
        if (!intVal && fracVal) return fracVal;
        if (intVal && fracVal) {
            if (fracVal.indexOf(intVal) === 0 && /\d/.test(fracVal)) return fracVal;
            // Avoid "47 47 3/8" when int already holds a mixed label.
            // Dp merge code 10-09 start — stale 15/16 frac must not beat a good mixed int (admin was wrong; liquid kept int)
            var mMix = String(intVal).match(/^(\d+)\s+(\d+\/\d+)$/);
            if (mMix) {
                if (String(fracVal) === '15/16' && mMix[2] !== '15/16') return intVal;
                if (mMix[2] === '15/16' && /^\d+\/\d+$/.test(String(fracVal)) && String(fracVal) !== '15/16') {
                    return mMix[1] + ' ' + fracVal;
                }
                if (mMix[2] === '15/16' && /^\d+(\.\d+)?$/.test(String(fracVal))) {
                    var fl = dpDimensionDropdownDisplayLabel(fracVal);
                    if (fl && fl !== '0' && fl !== '15/16') return mMix[1] + ' ' + fl;
                }
            }
            if (/\d+\s+\d+\/\d+/.test(intVal) || /^\d+\/\d+$/.test(intVal)) return intVal;
            // Dp merge code 10-09 end
            return intVal + ' ' + fracVal;
        }
        return intVal || fracVal;
    }

    // Dp merge code 10-09 start — when int+frac locked onto stale 15/16 OR whole-only, prefer setCombined keys
    function dpPreferNonStale1516Dimension(primary, alternates) {
        primary = String(primary == null ? '' : primary).trim();
        if (!primary) return '';
        var isStale1516 = function (s) {
            return /\b15\s*\/\s*16\b/.test(String(s || '').trim());
        };
        var isWholeOnly = function (s) {
            return /^\d+$/.test(String(s || '').trim());
        };
        // Dp merge code 10-09 start — repair bare whole inches missing a fraction
        if (!isStale1516(primary) && !isWholeOnly(primary)) return primary;
        // Dp merge code 10-09 end
        var primaryWhole = '';
        var mWhole = String(primary).match(/^(\d+)\s+\d+\s*\/\s*\d+/);
        if (mWhole) primaryWhole = mWhole[1];
        else {
            mWhole = String(primary).match(/^(\d+)(?:\.\d+)?$/);
            if (mWhole) primaryWhole = mWhole[1];
        }
        var list = Array.isArray(alternates) ? alternates : [];
        for (var i = 0; i < list.length; i++) {
            var alt = String(list[i] == null ? '' : list[i]).trim();
            if (!alt || !/\d/.test(alt)) continue;
            // Skip stale 15/16 alts when primary already has a fraction; whole-only may take mixed 15/16
            if (isStale1516(alt) && !isWholeOnly(primary)) continue;
            if (isWholeOnly(primary) && !/^\d+\s+\d+\s*\/\s*\d+/.test(alt)) continue;
            if (primaryWhole) {
                var mAlt = alt.match(/^(\d+)/);
                if (mAlt && mAlt[1] !== primaryWhole) continue;
            }
            return alt;
        }
        return primary;
    }

    function dpRepairHeightIfStale1516(combined, opts, kind) {
        combined = String(combined == null ? '' : combined).trim();
        if (!combined) return combined;
        // Dp merge code 10-09 start — repair whole-only OR stale 15/16
        var needs = /\b15\s*\/\s*16\b/.test(combined) || /^\d+$/.test(combined);
        if (!needs) return combined;
        // Dp merge code 10-09 end
        opts = opts || {};
        kind = String(kind || 'door').toLowerCase();
        var keys;
        if (kind === 'rough') {
            keys = ['rough_opening_height', 'rough_opening_height_inches', 'rough-opening-height'];
        } else if (kind === 'finished') {
            keys = [
                'finished_opening_height',
                'finished_opening_height_inches',
                'finished-opening-height',
                'exact_door_height',
                'door_height',
            ];
        } else if (kind === 'jamb' || kind === 'jamb_height') {
            keys = [
                'jamb_unit_height',
                'jamb_unit_height_inches',
                'panel_height',
                'panel-height',
                'exact_door_height',
                'door_height',
            ];
        } else if (kind === 'jamb_width') {
            keys = [
                'jamb_unit_width',
                'jamb_unit_width_inches',
                'panel_width',
                'panel-width',
                'exact_door_width',
                'door_width',
            ];
        } else if (kind === 'transom' || kind === 'transom_height') {
            keys = [
                'transom_height_combined',
                'transom_height_combined_inches',
                'panel_transom_height',
                'transom_height',
            ];
        } else if (kind === 'transom_width') {
            keys = ['transom_width_combined', 'transom_width', 'panel_transom_width', 'exact_door_width'];
        } else if (kind === 'width' || kind === 'door_width') {
            keys = [
                'exact_door_width',
                'door_width',
                'finished_opening_width',
                'rough_opening_width',
            ];
        } else {
            keys = [
                'exact_door_height',
                'door_height',
                'finished_opening_height',
                'rough_opening_height',
                'jamb_unit_height',
                'panel_height',
            ];
        }
        var alts = [];
        for (var ki = 0; ki < keys.length; ki++) {
            var raw = opts[keys[ki]];
            if (raw == null || raw === '') continue;
            if (Array.isArray(raw)) raw = raw[0];
            var v = String(raw)
                .replace(/\s*inches?\s*$/i, '')
                .trim();
            if (!v) continue;
            if (typeof dpDimensionDropdownDisplayLabel === 'function') {
                v = dpDimensionDropdownDisplayLabel(v);
            }
            if (v) alts.push(v);
        }
        return dpPreferNonStale1516Dimension(combined, alts);
    }
    // Dp merge code 10-09 end

    function dpMeasurementSummaryFieldSpecs() {
        return [
            {
                label: 'Exact Door Width',
                int: ['exact-door-width-int', 'exact_door_width_int', 'exact_door_width', 'door_width'],
                // Dp merge code 10-09 start — hyphen select + *_value / fraction_value before stale slash labels
                frac: [
                    'exact-door-width-frac',
                    'exact_door_width_frac',
                    'exact_door_width_fraction_value',
                    'exact_door_width_fraction',
                    'door_width_fraction_value',
                    'door_width_fraction',
                    'exact-door-width-frac_label',
                    'exact_door_width_frac_label',
                ],
                // Dp merge code 10-09 end
            },
            {
                label: 'Exact Door Height',
                // Dp merge code 10-09 start — include setCombined exact_door_height (front int+frac mirror)
                int: [
                    'exact-door-height-int',
                    'exact_door_height_int',
                    'door_height',
                    'exact_door_height',
                    'exact-door-height',
                ],
                frac: [
                    'exact-door-height-frac',
                    'exact_door_height_frac',
                    'exact_door_height_fraction_value',
                    'door_height_fraction_value',
                    'door_height_fraction',
                    'door_height_frac',
                    'exact-door-height-frac_label',
                    'exact_door_height_frac_label',
                ],
                // Dp merge code 10-09 end
            },
            // Dp start 26-08 — single Door Thickness line for every measurement type (not inside Exact Door Size)
            {
                label: 'Door Thickness',
                int: [
                    'finished-door-thickness_label',
                    'finished_door_thickness_label',
                    'finished-door-thickness',
                    'finished_door_thickness',
                    'rough-door-thickness_label',
                    'rough_door_thickness_label',
                    'rough-door-thickness',
                    'rough_door_thickness',
                    'exact-door-thickness-frac_label',
                    'exact_door_thickness_frac_label',
                    'exact_door_thickness_frac',
                    'exact_door_thickness',
                    'door_thickness',
                    'door-thickness',
                    'exact-door-thickness-frac',
                    'panel-door-thickness-frac',
                    'exact_door_thickness_inches',
                    'door_thickness_inches',
                ],
                frac: [],
            },
            // Dp end 26-08
            // Pre-hung depth / jamb width: same front select (exact-pre-hung-int + frac).
            {
                // Dp merge code 10-09 start — storefront label is Pre-hung Jamb Depth
                // Dp merge code 10-09 start — ONLY exact-pre-hung* (depth). Never jamb_pre_hung*
                // (jamb_pre_hung_int/frac are Jamb Unit Width on the measure screen).
                // Dp start VDN-390 23-10
                label: 'Pre-hung Jamb Depth',
                // Dp end VDN-390 23-10
                int: [
                    'exact-pre-hung-int',
                    'exact_pre_hung_int',
                    'panel_pre_hung_int',
                    'rough_pre_hung_int',
                    'pre_hung_unit_depth',
                ],
                frac: [
                    'exact-pre-hung-frac',
                    'exact-pre-hung-frac_label',
                    'exact_pre_hung_frac',
                    'exact_pre_hung_fraction_value',
                    'exact_pre_hung',
                    'panel_pre_hung_frac',
                ],
                // Dp merge code 10-09 end
                // Dp merge code 10-09 end
            },
            // Dp merge code 10-09 start — Jamb Unit Size W/H (storefront jamb panel-* selects, not jamb_pre_hung depth)
            {
                label: 'Jamb Unit Width',
                int: [
                    'panel-width-int',
                    'panel_width_int',
                    'panel_width',
                    'exact-door-width-int',
                    'exact_door_width_int',
                    'door_width',
                ],
                frac: [
                    'panel-width-frac',
                    'panel_width_frac',
                    'panel_width_fraction_value',
                    'panel-width-frac_value',
                    'panel_width_fraction',
                    'exact-door-width-frac',
                    'exact_door_width_frac',
                    'exact_door_width_fraction_value',
                    'panel-width-frac_label',
                    'exact-door-width-frac_label',
                ],
            },
            {
                label: 'Jamb Unit Height',
                int: [
                    'panel-height-int',
                    'panel_height_int',
                    'panel_height',
                    'exact-door-height-int',
                    'exact_door_height_int',
                    'door_height',
                ],
                frac: [
                    'panel-height-frac',
                    'panel_height_frac',
                    'panel_height_fraction_value',
                    'panel-height-frac_value',
                    'panel_height_fraction',
                    'exact-door-height-frac',
                    'exact_door_height_frac',
                    'exact_door_height_fraction_value',
                    'door_height_fraction_value',
                    'door_height_fraction',
                    'panel-height-frac_label',
                    'exact-door-height-frac_label',
                ],
            },
            // Dp merge code 10-09 end
            {
                label: 'Exact Sidelight Width',
                // Dp start 03-09 — schema sidelight_width* first (0.25→1/4); compound mirrors last
                // Dp merge code 10-09 start — include hyphen / combined keys from storefront conf
                int: [
                    'sidelight_width',
                    'sidelight_width_int',
                    'sidelight-width',
                    'sidelight-width-int',
                    'sidelight-sidelight-width-int',
                    'sidelight_sidelight_width_int',
                    'sidelight_width_combined',
                ],
                frac: [
                    'sidelight_width_fraction',
                    'sidelight_width_frac',
                    'sidelight-width-frac',
                    'sidelight-width-fraction',
                    'sidelight-sidelight-width-frac',
                    'sidelight_sidelight_width_frac',
                    'sidelight_sidelight_width_fraction',
                ],
                // Dp merge code 10-09 end / 03-09
            },
            // --- Dp start 01-09 (quote description: backfill Exact Sidelight Height) ---
            {
                label: 'Exact Sidelight Height',
                int: [
                    'sidelight_height_int',
                    'sidelight_height',
                    'sidelight-height',
                    'sidelight-height-int',
                    'sidelight-sidelight-height-int',
                    'sidelight_sidelight_height_int',
                    'sidelight_height_combined',
                ],
                frac: [
                    'sidelight_height_frac',
                    'sidelight_height_fraction',
                    'sidelight-height-frac',
                    'sidelight-height-fraction',
                    'sidelight-sidelight-height-frac',
                    'sidelight_sidelight_height_frac',
                    'sidelight_sidelight_height_fraction',
                ],
            },
            // --- Dp end 01-09 ---
            {
                label: 'Exact Transom Height',
                // Dp merge code 10-09 start — hyphen + combined keys (conf setCombined)
                int: [
                    'panel_transom_height_int',
                    'panel-transom-height-int',
                    'panel_transom_height',
                    'transom_height_int',
                    'transom-height-int',
                    'transom_height',
                    'transom_height_combined',
                ],
                frac: [
                    'panel_transom_height_frac',
                    'panel_transom_height_fraction',
                    'panel-transom-height-frac',
                    'panel-transom-height-fraction',
                    'transom_height_frac',
                    'transom_height_fraction',
                    'transom-height-frac',
                ],
                // Dp merge code 10-09 end
            },
            // Dp start 03-09 — Transom Width for Exact Transom Size collapse (W x H)
            {
                label: 'Transom Width',
                int: [
                    'transom_width_int',
                    'transom-width-int',
                    'transom_width',
                    'transom_transom_width_int',
                    'panel_transom_width_int',
                ],
                frac: [
                    'transom_width_frac',
                    'transom_width_fraction',
                    'transom-width-frac',
                    'transom_transom_width_frac',
                    'panel_transom_width_frac',
                ],
            },
            {
                label: 'Transom Height',
                int: [
                    'panel_transom_height_int',
                    'panel_transom_height',
                    'transom_height_int',
                    'transom-height-int',
                    'transom_height',
                    'transom_transom_height_int',
                ],
                frac: [
                    'panel_transom_height_frac',
                    'panel_transom_height_fraction',
                    'transom_height_frac',
                    'transom_height_fraction',
                    'transom-height-frac',
                    'transom_transom_height_frac',
                ],
            },
            // Dp end 03-09
            {
                label: 'Rough Opening Width',
                int: ['rough-width-int', 'rough_width_int'],
                frac: ['rough-width-frac', 'rough-width-frac_label', 'rough_width_frac', 'rough_width_fraction'],
            },
            {
                label: 'Rough Opening Height',
                int: ['rough-height-int', 'rough_height_int'],
                // Dp merge code 10-09 start — live height frac before stale *_label
                frac: [
                    'rough-height-frac',
                    'rough_height_frac',
                    'rough_height_fraction',
                    'rough_height_fraction_value',
                    'exact-door-height-frac',
                    'exact_door_height_frac',
                    'door_height_fraction_value',
                    'door_height_fraction',
                    'door_height_frac',
                    'rough-height-frac_label',
                    'exact-door-height-frac_label',
                ],
                // Dp merge code 10-09 end
            },
            {
                label: 'Finished Opening Width',
                int: ['finished_width_int', 'finished-width-int'],
                frac: ['finished_width_frac', 'finished_width_fraction', 'finished-width-frac'],
            },
            {
                label: 'Finished Opening Height',
                int: ['finished_height_int', 'finished-height-int'],
                // Dp merge code 10-09 start — live height frac / *_value before stale 15/16 labels
                frac: [
                    'finished-height-frac',
                    'finished_height_frac',
                    'finished_height_fraction',
                    'finished_height_fraction_value',
                    'finished-height-frac_value',
                    'exact-door-height-frac',
                    'exact_door_height_frac',
                    'exact_door_height_fraction_value',
                    'door_height_fraction_value',
                    'door_height_fraction',
                    'door_height_frac',
                    'finished-height-frac_label',
                    'exact-door-height-frac_label',
                ],
                // Dp merge code 10-09 end
            },
        ];
    }

    function dpReadOptKeys(opts, ids) {
        opts = opts || {};
        // Dp start 03-09 — when storage (0.25) and *_label (15/16) disagree, trust storage → 1/4.
        // Prefer schema keys over compound sidelight_sidelight_* mirrors (list order + scoring).
        function dpDimDisplay(raw) {
            raw = String(raw == null ? '' : raw).trim();
            if (!raw) return '';
            return typeof dpDimensionDropdownDisplayLabel === 'function' ? dpDimensionDropdownDisplayLabel(raw) : raw;
        }
        function dpDimEquiv(a, b) {
            if (!a || !b) return false;
            return String(dpDimDisplay(a)).toLowerCase() === String(dpDimDisplay(b)).toLowerCase();
        }
        function dpIsCompoundMirror(base) {
            var n = String(base || '').toLowerCase().replace(/-/g, '_');
            return /sidelight_sidelight_|transom_transom_|gate_gate_/.test(n);
        }
        // Dp merge code 10-09 start — prefer live select decimals / *_value over stale "15/16" slash labels
        function dpIsSlashFracLabel(s) {
            return /^\d+\s*\/\s*\d+$/.test(String(s == null ? '' : s).trim());
        }
        function dpIsInchDecimalRaw(s) {
            return /^(?:0|[1-9]\d*)(?:\.\d+)?$/.test(String(s == null ? '' : s).trim());
        }
        function dpReadFracValueSibling(optsObj, baseKey) {
            if (!optsObj || !baseKey) return '';
            var keys = [
                String(baseKey) + '_value',
                String(baseKey).replace(/_label$/i, '') + '_value'
            ];
            if (/_fraction$/i.test(baseKey)) {
                keys.push(String(baseKey) + '_value');
                keys.push(String(baseKey).replace(/_fraction$/i, '_fraction_value'));
            }
            if (/_frac$/i.test(baseKey) || /-frac$/i.test(baseKey)) {
                keys.push(String(baseKey).replace(/_frac$/i, '_fraction_value').replace(/-frac$/i, '-fraction_value'));
                keys.push(String(baseKey).replace(/-/g, '_') + '_value');
            }
            var ki;
            for (ki = 0; ki < keys.length; ki++) {
                var vk = keys[ki];
                if (!vk || optsObj[vk] == null) continue;
                var vv = String(optsObj[vk]).trim();
                if (vv && dpIsInchDecimalRaw(vv)) return vv;
            }
            return '';
        }
        // Dp merge code 10-09 end
        var seen = {};
        var candidates = [];
        var order = 0;
        for (var i = 0; i < ids.length; i++) {
            var k = ids[i];
            if (!k) continue;
            var base = String(k).replace(/_label$/i, '');
            var bases = [base, String(base).replace(/_/g, '-'), String(base).replace(/-/g, '_')];
            for (var bi = 0; bi < bases.length; bi++) {
                var b = bases[bi];
                var nk = String(b || '').toLowerCase().replace(/-/g, '_');
                if (!nk || seen[nk]) continue;
                var raw = opts[b] != null && String(opts[b]).trim() !== '' ? String(opts[b]).trim() : '';
                var labKey = b + '_label';
                var lab = opts[labKey] != null && String(opts[labKey]).trim() !== '' ? String(opts[labKey]).trim() : '';
                // Dp merge code 10-09 start — decimal sibling saved as embedId_fraction_value / selectId_value
                var rawValue = dpReadFracValueSibling(opts, b);
                if (rawValue && (!raw || dpIsSlashFracLabel(raw))) {
                    raw = rawValue;
                } else if (rawValue && raw && dpIsSlashFracLabel(raw) && dpIsInchDecimalRaw(rawValue) && !dpDimEquiv(raw, rawValue)) {
                    raw = rawValue;
                }
                // Dp merge code 10-09 end
                if (!raw && !lab) continue;
                // Dp merge code 10-09 start — only mark seen after a real value (empty underscore must not block hyphen select id)
                seen[nk] = true;
                // Dp merge code 10-09 end
                var src = 'label_only';
                var pick = '';
                if (raw && lab && !dpDimEquiv(raw, lab)) {
                    pick = dpDimDisplay(raw);
                    src = 'raw_over_label';
                } else if (raw) {
                    pick = dpDimDisplay(raw);
                    src = 'raw';
                } else {
                    pick = dpDimDisplay(lab);
                    src = 'label_only';
                }
                if (!pick) continue;
                candidates.push({
                    val: pick,
                    src: src,
                    compound: dpIsCompoundMirror(b),
                    order: order++,
                    numeric: dpIsInchDecimalRaw(raw),
                    // Dp merge code 10-09 start
                    slashOnly: dpIsSlashFracLabel(raw) && !rawValue
                    // Dp merge code 10-09 end
                });
            }
        }
        if (!candidates.length) return '';
        var best = '';
        var bestScore = -1;
        for (var c = 0; c < candidates.length; c++) {
            var row = candidates[c];
            var score = 200 - row.order;
            if (row.src === 'raw_over_label') score += 100;
            else if (row.src === 'raw') {
                score += 60;
                if (row.numeric) score += 15;
            } else score += 5;
            if (row.compound) score -= 45;
            // Dp merge code 10-09 start — demote bare "15/16"-style raw when a numeric decimal candidate exists
            if (row.slashOnly) score -= 40;
            // Dp merge code 10-09 end
            // Dp merge code 10-09 start — demote stale default 15/16 when another frac exists (admin height parity)
            var cVal = String(row.val || '').trim();
            if (cVal === '15/16' || /\b15\/16\b/.test(cVal)) {
                var hasBetter = false;
                for (var o = 0; o < candidates.length; o++) {
                    var ov = String((candidates[o] && candidates[o].val) || '').trim();
                    if (!ov || ov === cVal) continue;
                    if (candidates[o].numeric || (/^\d+\/\d+$/.test(ov) && ov !== '15/16' && ov !== '0')) {
                        hasBetter = true;
                        break;
                    }
                }
                if (hasBetter) score -= 80;
            }
            // Dp merge code 10-09 end
            if (score > bestScore) {
                bestScore = score;
                best = row.val;
            }
        }
        return best;
        // Dp end 03-09
    }

    function dpResolveMeasurementTypeKey(opts, rows) {
        opts = opts || {};
        var raw = opts.measurement_type || opts['measurement-type'] || '';
        if (Array.isArray(raw)) raw = raw[0] || '';
        var fromOpt = dpNormalizeFieldKey(String(raw || '').replace(/_/g, ' '));
        if (fromOpt && fromOpt !== 'measurements') return fromOpt;
        var list = Array.isArray(rows) ? rows : [];
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            if (!item || typeof item === 'string') continue;
            var lab = dpNormalizeFieldKey((item.label || '') + '');
            var val = String(item.value || '').trim();
            if (lab === 'measurements' || lab === 'measurement type' || lab === 'how will you measure') {
                var nk = dpNormalizeFieldKey(val);
                if (nk) return nk;
            }
            if (dpIsMeasurementTypeLabel(val)) return dpNormalizeFieldKey(val);
            if (dpIsMeasurementTypeLabel(item.label || '')) return dpNormalizeFieldKey(item.label || '');
        }
        return fromOpt || '';
    }

    // Dp start 02-09 — Slab/Brick: Finished Opening tab visible; correct stale rough_opening_size token for summary/collapse
    function dpEffectiveMeasurementTypeKey(opts, rows) {
        var mtKey = dpResolveMeasurementTypeKey(opts, rows);
        var nk = dpNormalizeFieldKey(String(mtKey || '').replace(/_/g, ' '));
        if (nk === 'rough opening size' && dpIsNonJambSlabOrBrickSetup(opts, rows)) {
            return 'finished opening size';
        }
        return mtKey;
    }
    // Dp end 02-09

    function dpEnsureMeasurementSummaryRows(opts, rows) {
        opts = opts || {};
        rows = Array.isArray(rows) ? rows.slice() : [];
        var existingIdx = {};
        rows.forEach(function (item, i) {
            if (!item || typeof item === 'string') return;
            var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
            if (lab) existingIdx[lab] = i;
        });
        var mtKey = dpResolveMeasurementContextKey(opts, rows);
        // Dp merge code 10-09 start — Exact Sidelight Size: strip stale Jamb Unit Size/W/H summary rows
        // Gate products: also strip Exact Sidelight / Transom rows (not on front gate measure UI)
        var colGateEnsure09 = String(
            opts._route_collection || opts._collection_handle || opts._product_type || ''
        ).toLowerCase();
        var isGateEnsure09 =
            mtKey === 'exact gate size' || colGateEnsure09.indexOf('gate') !== -1;
        if (
            mtKey === 'exact sidelight size' ||
            mtKey === 'exact transom size' ||
            mtKey === 'exact gate size' ||
            isGateEnsure09
        ) {
            rows = rows.filter(function (item) {
                if (!item || typeof item === 'string') return true;
                var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
                if (
                    lab === 'jamb unit size' ||
                    lab === 'jamb unit width' ||
                    lab === 'jamb unit height'
                ) {
                    return false;
                }
                if (
                    isGateEnsure09 &&
                    (lab === 'exact sidelight width' ||
                        lab === 'sidelight width' ||
                        lab === 'exact sidelight height' ||
                        lab === 'sidelight height' ||
                        lab === 'exact sidelight size' ||
                        lab === 'exact transom width' ||
                        lab === 'transom width' ||
                        lab === 'exact transom height' ||
                        lab === 'transom height' ||
                        lab === 'exact transom size')
                ) {
                    return false;
                }
                return true;
            });
            existingIdx = {};
            rows.forEach(function (item, i) {
                if (!item || typeof item === 'string') return;
                var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
                if (lab) existingIdx[lab] = i;
            });
        }
        // Dp merge code 10-09 end

        function upsertRow(label, combined) {
            if (!label || !combined) return;
            var lk = dpNormalizeFieldKey(label);
            if (!lk) return;
            if (Object.prototype.hasOwnProperty.call(existingIdx, lk)) {
                var idx = existingIdx[lk];
                var cur = String((rows[idx] && rows[idx].value) || '').trim();
                // Always prefer live option values so Pre-Hung Unit Depth / Rough Opening
                // dropdown changes replace stale selected_summary text.
                if (cur !== combined) {
                    rows[idx].value = combined;
                }
                return;
            }
            if (
                lk === 'pre hung unit depth' &&
                (existingIdx['pre-hung unit depth'] != null || existingIdx['prehung unit depth'] != null)
            ) {
                var pIdx =
                    existingIdx['pre-hung unit depth'] != null
                        ? existingIdx['pre-hung unit depth']
                        : existingIdx['prehung unit depth'];
                if (rows[pIdx] && String(rows[pIdx].value || '').trim() !== combined) {
                    rows[pIdx].value = combined;
                }
                return;
            }
            // Dp merge code 10-09 start — Unit Depth / Jamb Width share one summary row (front label)
            // Dp start VDN-390 23-10
            if (
                (lk === 'pre hung jamb width' || lk === 'pre-hung jamb width' || lk === 'prehung jamb width' ||
                 lk === 'pre hung jamb depth' || lk === 'pre-hung jamb depth' || lk === 'prehung jamb depth') &&
                (existingIdx['pre hung unit depth'] != null ||
                    existingIdx['pre-hung unit depth'] != null ||
                    existingIdx['prehung unit depth'] != null ||
                    existingIdx['pre hung jamb width'] != null ||
                    existingIdx['pre-hung jamb width'] != null ||
                    existingIdx['pre hung jamb depth'] != null ||
                    existingIdx['pre-hung jamb depth'] != null)
            ) {
                var jIdx =
                    existingIdx['pre hung jamb depth'] != null
                        ? existingIdx['pre hung jamb depth']
                        : existingIdx['pre-hung jamb depth'] != null
                            ? existingIdx['pre-hung jamb depth']
                            : existingIdx['pre hung jamb width'] != null
                                ? existingIdx['pre hung jamb width']
                                : existingIdx['pre-hung jamb width'] != null
                                    ? existingIdx['pre-hung jamb width']
                                    : existingIdx['pre hung unit depth'] != null
                                        ? existingIdx['pre hung unit depth']
                                        : existingIdx['pre-hung unit depth'] != null
                                            ? existingIdx['pre-hung unit depth']
                                            : existingIdx['prehung unit depth'];
                if (rows[jIdx]) {
                    rows[jIdx].label = 'Pre-hung Jamb Depth';
                    if (String(rows[jIdx].value || '').trim() !== combined) rows[jIdx].value = combined;
                }
                return;
            }
            // Dp end VDN-390 23-10
            // Dp merge code 10-09 end
            // Dp start 26-08 — Exact Door Thickness and Door Thickness are the same display row
            if (lk === 'door thickness' && existingIdx['exact door thickness'] != null) {
                var etIdx = existingIdx['exact door thickness'];
                if (rows[etIdx]) {
                    rows[etIdx].label = 'Door Thickness';
                    rows[etIdx].value = combined;
                }
                existingIdx['door thickness'] = etIdx;
                delete existingIdx['exact door thickness'];
                return;
            }
            if (lk === 'exact door thickness' && existingIdx['door thickness'] != null) {
                var dtIdx = existingIdx['door thickness'];
                if (rows[dtIdx] && String(rows[dtIdx].value || '').trim() !== combined) {
                    rows[dtIdx].value = combined;
                }
                return;
            }
            // Dp end 26-08
            rows.push({ label: label, value: combined });
            existingIdx[lk] = rows.length - 1;
        }

        dpMeasurementSummaryFieldSpecs().forEach(function (spec) {
            var label = spec.label || '';
            if (!label) return;
            var lk = dpNormalizeFieldKey(label);
            // Avoid emitting both Rough + Finished lines for the same stored fields.
            if (
                (mtKey === 'rough opening size' || mtKey === 'rough_opening_size') &&
                (lk === 'finished opening width' || lk === 'finished opening height')
            ) {
                return;
            }
            if (
                (mtKey === 'finished opening size' ||
                    mtKey === 'finished_opening_size' ||
                    mtKey === 'finished opening' ||
                    mtKey === 'finished_opening') &&
                (lk === 'rough opening width' || lk === 'rough opening height')
            ) {
                // Dp start 03-09 — Rough Opening W/H only when front selected Rough Opening Size
                return;
                // Dp end 03-09
            }
            // Dp start 03-09 — skip Rough Opening W/H when front did not select Rough Opening Size
            if (
                (lk === 'rough opening width' || lk === 'rough opening height') &&
                !dpWasRoughOpeningSelectedFromFront(opts, rows)
            ) {
                return;
            }
            // Dp end 03-09
            // Dp merge code 10-09 start — gate products: do not backfill sidelight/transom (not on front)
            if (
                isGateEnsure09 &&
                (lk === 'exact sidelight width' ||
                    lk === 'sidelight width' ||
                    lk === 'exact sidelight height' ||
                    lk === 'sidelight height' ||
                    lk === 'exact sidelight size' ||
                    lk === 'exact transom width' ||
                    lk === 'transom width' ||
                    lk === 'exact transom height' ||
                    lk === 'transom height' ||
                    lk === 'exact transom size')
            ) {
                return;
            }
            // Dp merge code 10-09 end
            // Dp merge code 10-09 start — do not backfill Jamb Unit W/H unless Jamb Unit Size is selected
            // (stale panel-* keys otherwise become extra "Jamb Unit Size: 10 1/4w")
            if (
                (lk === 'jamb unit width' || lk === 'jamb unit height' || lk === 'jamb unit size') &&
                mtKey !== 'jamb unit size' &&
                mtKey !== 'pre hung unit size' &&
                mtKey !== 'pre-hung unit size'
            ) {
                return;
            }
            // Dp merge code 10-09 end
            var combined = dpCombineDimensionInchesLabel(
                dpReadOptKeys(opts, spec.int || []),
                dpReadOptKeys(opts, spec.frac || [])
            );
            if (!combined && (spec.int || []).length && !(spec.frac || []).length) {
                combined = dpReadOptKeys(opts, spec.int || []);
            }
            // Single-field prehung depth stored only on exact_pre_hung_frac / pre_hung_unit_depth.
            // Dp start VDN-390 23-10
            if (!combined && (label === 'Pre-Hung Unit Depth' || label === 'Pre-hung Jamb Depth' || label === 'Pre-hung Jamb Width')) {
            // Dp end VDN-390 23-10
                combined = dpReadOptKeys(opts, [
                    'exact-pre-hung-frac_label',
                    'exact-pre-hung-frac',
                    'exact_pre_hung_frac',
                    'exact_pre_hung',
                    'pre_hung_unit_depth',
                    'pre_hung_unit_depth_inches',
                ]);
                combined = String(combined || '')
                    .replace(/\s*inches?\s*$/i, '')
                    .trim();
            }
            // Dp merge code 10-09 start — height/width: if int+frac became stale 15/16 or whole-only, prefer setCombined
            if (combined && typeof dpRepairHeightIfStale1516 === 'function') {
                if (label === 'Exact Door Height') {
                    combined = dpRepairHeightIfStale1516(combined, opts, 'door');
                } else if (label === 'Exact Door Width') {
                    combined = dpRepairHeightIfStale1516(combined, opts, 'door_width');
                } else if (label === 'Rough Opening Height') {
                    combined = dpRepairHeightIfStale1516(combined, opts, 'rough');
                } else if (label === 'Finished Opening Height') {
                    combined = dpRepairHeightIfStale1516(combined, opts, 'finished');
                } else if (label === 'Jamb Unit Height') {
                    combined = dpRepairHeightIfStale1516(combined, opts, 'jamb');
                } else if (label === 'Jamb Unit Width') {
                    combined = dpRepairHeightIfStale1516(combined, opts, 'jamb_width');
                } else if (label === 'Exact Transom Height' || label === 'Transom Height') {
                    combined = dpRepairHeightIfStale1516(combined, opts, 'transom');
                } else if (label === 'Transom Width') {
                    combined = dpRepairHeightIfStale1516(combined, opts, 'transom_width');
                }
            }
            // Dp merge code 10-09 end
            // Dp merge code 10-09 start — never upsert frac-only (e.g. 1/2) — prefer front setCombined full label
            if (combined && /^\d+\s*\/\s*\d+$/.test(String(combined).trim())) {
                var altFull = '';
                if (label === 'Exact Door Height') {
                    altFull = dpReadOptKeys(opts, ['exact_door_height', 'exact_door_height_inches', 'exact-door-height']);
                } else if (label === 'Exact Door Width') {
                    altFull = dpReadOptKeys(opts, ['exact_door_width', 'exact_door_width_inches', 'exact-door-width']);
                } else if (label === 'Exact Sidelight Width') {
                    altFull = dpReadOptKeys(opts, ['sidelight_width_combined', 'sidelight_width']);
                } else if (label === 'Exact Sidelight Height') {
                    // Only true sidelight keys — never door_height (gates share those keys)
                    altFull = dpReadOptKeys(opts, ['sidelight_height_combined', 'sidelight_height', 'sidelight_height_int']);
                } else if (label === 'Exact Transom Height' || label === 'Transom Height') {
                    altFull = dpReadOptKeys(opts, ['transom_height_combined', 'panel_transom_height']);
                } else if (label === 'Jamb Unit Height') {
                    altFull = dpReadOptKeys(opts, ['jamb_unit_height', 'jamb_unit_height_inches']);
                } else if (label === 'Jamb Unit Width') {
                    altFull = dpReadOptKeys(opts, ['jamb_unit_width', 'jamb_unit_width_inches']);
                }
                altFull = String(altFull || '')
                    .replace(/\s*inches?\s*$/i, '')
                    .trim();
                if (altFull && !/^\d+\s*\/\s*\d+$/.test(altFull)) combined = altFull;
                else combined = '';
            }
            // Dp merge code 10-09 end
            if (!combined) return;
            upsertRow(label, combined);
        });

        // Slab Only / Pre-Hung on Brick Molding: Rough Opening Size tab still writes finished_* fields
        // (rough panel is hidden). Mirror finished → Rough Opening labels when measurement type is rough.
        // Dp start 03-09 — require front Rough Opening Size selection (not stale rough-* keys alone)
        if (
            (mtKey === 'rough opening size' || mtKey === 'rough_opening_size') &&
            dpWasRoughOpeningSelectedFromFront(opts, rows)
        ) {
            // Dp end 03-09
            var rhIntLive = dpReadOptKeys(opts, ['rough-height-int', 'rough_height_int']);
            var rhFracLive = dpReadOptKeys(opts, [
                'rough-height-frac',
                'rough-height-frac_label',
                'rough_height_frac',
                'rough_height_fraction',
            ]);
            var rw = dpCombineDimensionInchesLabel(
                dpReadOptKeys(opts, ['rough-width-int', 'rough_width_int']),
                dpReadOptKeys(opts, ['rough-width-frac', 'rough-width-frac_label', 'rough_width_frac', 'rough_width_fraction'])
            );
            // Dp start 02-09 — Rough Opening Height from live rough int+frac (not Exact Door Height)
            var rh = dpCombineDimensionInchesLabel(rhIntLive, rhFracLive);
            if (!rh) {
                rh = String(
                    dpReadOptKeys(opts, ['rough_opening_height', 'rough_opening_height_inches']) || ''
                )
                    .replace(/\s*inches?\s*$/i, '')
                    .trim();
            }
            // Dp end 02-09
            // Dp merge code 10-09 start — repair stale 15/16 via setCombined
            if (rh && typeof dpRepairHeightIfStale1516 === 'function') {
                rh = dpRepairHeightIfStale1516(rh, opts, 'rough');
            }
            // Dp merge code 10-09 end
            if (!rw) {
                rw = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['finished_width_int', 'finished-width-int', 'panel_width_int']),
                    dpReadOptKeys(opts, ['finished_width_frac', 'finished_width_fraction', 'finished-width-frac'])
                );
            }
            if (!rh) {
                rh = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['finished_height_int', 'finished-height-int', 'panel_height_int']),
                    dpReadOptKeys(opts, ['finished_height_frac', 'finished_height_fraction', 'finished-height-frac'])
                );
            }
            if (!rw) {
                rw = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['exact_door_width_int', 'exact-door-width-int', 'exact_door_width']),
                    dpReadOptKeys(opts, ['exact_door_width_frac', 'exact-door-width-frac', 'exact_door_width_fraction'])
                );
            }
            // Dp start 02-09 — only use Exact Door Height when no rough/finished height keys exist
            if (!rh && !rhIntLive && !rhFracLive) {
                rh = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['exact-door-height-int', 'door_height', 'exact_door_height']),
                    dpReadOptKeys(opts, ['door_height_fraction', 'door_height_frac', 'exact-door-height-frac_label'])
                );
                // Dp merge code 10-09 start
                if (rh && typeof dpRepairHeightIfStale1516 === 'function') {
                    rh = dpRepairHeightIfStale1516(rh, opts, 'door');
                }
                // Dp merge code 10-09 end
            }
            // Dp end 02-09
            /*
            if (!rh) {
              rh = dpCombineDimensionInchesLabel(
                dpReadOptKeys(opts, ['door_height', 'exact_door_height', 'exact-door-height-int']),
                dpReadOptKeys(opts, ['door_height_fraction', 'door_height_frac', 'exact-door-height-frac_label'])
              );
            }
            */
            if (rw) upsertRow('Rough Opening Width', rw);
            if (rh) upsertRow('Rough Opening Height', rh);
            // Drop Finished Opening W/H rows so collapse does not emit a second Finished Opening Size line.
            var keptRough = [];
            var newIdx = {};
            rows.forEach(function (item) {
                if (!item || typeof item === 'string') {
                    keptRough.push(item);
                    return;
                }
                var flk = dpNormalizeFieldKey((item.label || item.id || '') + '');
                if (flk === 'finished opening width' || flk === 'finished opening height') return;
                keptRough.push(item);
                if (flk) newIdx[flk] = keptRough.length - 1;
            });
            rows = keptRough;
            existingIdx = newIdx;
        }

        // Finished Opening Size + Brick Molding / Slab: ensure finished W/H from options (or rough fallback).
        if (
            mtKey === 'finished opening size' ||
            mtKey === 'finished_opening_size' ||
            mtKey === 'finished opening' ||
            mtKey === 'finished_opening'
        ) {
            var fw = dpCombineDimensionInchesLabel(
                dpReadOptKeys(opts, ['finished_width_int', 'finished-width-int', 'exact-door-width-int', 'exact_door_width_int']),
                // Dp merge code 10-09 start — hyphen / decimal before stale slash labels
                dpReadOptKeys(opts, [
                    'finished-width-frac',
                    'finished_width_frac',
                    'finished_width_fraction',
                    'exact-door-width-frac',
                    'exact_door_width_frac',
                    'exact_door_width_fraction_value',
                    'exact_door_width_fraction',
                ])
                // Dp merge code 10-09 end
            );
            var fh = dpCombineDimensionInchesLabel(
                dpReadOptKeys(opts, ['finished_height_int', 'finished-height-int', 'exact-door-height-int', 'door_height']),
                // Dp merge code 10-09 start — live height frac before stale 15/16 labels
                dpReadOptKeys(opts, [
                    'finished-height-frac',
                    'finished_height_frac',
                    'finished_height_fraction',
                    'finished_height_fraction_value',
                    'finished-height-frac_value',
                    'exact-door-height-frac',
                    'exact_door_height_frac',
                    'exact_door_height_fraction_value',
                    'door_height_fraction_value',
                    'door_height_fraction',
                    'door_height_frac',
                    'exact-door-height-frac_label',
                ])
                // Dp merge code 10-09 end
            );
            // Dp merge code 10-09 start — repair stale 15/16 via setCombined
            if (fh && typeof dpRepairHeightIfStale1516 === 'function') {
                fh = dpRepairHeightIfStale1516(fh, opts, 'finished');
            }
            // Dp merge code 10-09 end
            if (!fw) {
                fw = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['rough-width-int', 'rough_width_int', 'exact_door_width_int', 'exact-door-width-int']),
                    dpReadOptKeys(opts, [
                        'rough_width_frac',
                        'rough_width_fraction',
                        'exact_door_width_frac',
                        'exact_door_width_fraction',
                    ])
                );
            }
            if (!fh) {
                fh = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['rough-height-int', 'rough_height_int', 'door_height', 'exact_door_height']),
                    dpReadOptKeys(opts, [
                        'rough-height-frac',
                        'rough-height-frac_label',
                        'rough_height_frac',
                        'rough_height_fraction',
                        'door_height_fraction',
                        'door_height_frac',
                    ])
                );
                // Dp merge code 10-09 start
                if (fh && typeof dpRepairHeightIfStale1516 === 'function') {
                    fh = dpRepairHeightIfStale1516(fh, opts, 'finished');
                }
                // Dp merge code 10-09 end
            }
            if (fw) upsertRow('Finished Opening Width', fw);
            if (fh) upsertRow('Finished Opening Height', fh);
            // Dp merge code 10-09 start — Finished Opening Size tab → Rough Opening Size (skip default 36x80 over live rough)
            (function dpMirrorFinishedToRoughRows09() {
                var isDefaultFin =
                    String(fw || '') === '36' &&
                    String(fh || '') === '80' &&
                    (!dpReadOptKeys(opts, ['finished_width_frac', 'finished-width-frac', 'finished_width_fraction']) ||
                        String(dpReadOptKeys(opts, ['finished_width_frac', 'finished-width-frac', 'finished_width_fraction']) || '0') === '0') &&
                    (!dpReadOptKeys(opts, ['finished_height_frac', 'finished-height-frac', 'finished_height_fraction']) ||
                        String(dpReadOptKeys(opts, ['finished_height_frac', 'finished-height-frac', 'finished_height_fraction']) || '0') === '0');
                // Prefer existing rough_* when Finished is still storefront default
                var rwLive = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['rough-width-int', 'rough_width_int', 'rough_opening_width']),
                    dpReadOptKeys(opts, ['rough-width-frac', 'rough_width_frac', 'rough_width_fraction'])
                );
                var rhLive = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['rough-height-int', 'rough_height_int', 'rough_opening_height']),
                    dpReadOptKeys(opts, ['rough-height-frac', 'rough_height_frac', 'rough_height_fraction'])
                );
                if (isDefaultFin && (rwLive || rhLive)) {
                    if (rwLive) upsertRow('Finished Opening Width', rwLive);
                    if (rhLive) upsertRow('Finished Opening Height', rhLive);
                    if (rwLive) upsertRow('Rough Opening Width', rwLive);
                    if (rhLive) upsertRow('Rough Opening Height', rhLive);
                    return;
                }
                if (fw) upsertRow('Rough Opening Width', fw);
                if (fh) upsertRow('Rough Opening Height', fh);
            })();
            // Dp merge code 10-09 end
            // Dp start 02-09 — drop stale Rough Opening W/H; collapse builds Finished Opening Size from Finished W/H
            var keptFinMt = [];
            var newIdxFin = {};
            rows.forEach(function (item) {
                if (!item || typeof item === 'string') {
                    keptFinMt.push(item);
                    return;
                }
                var flkFin = dpNormalizeFieldKey((item.label || item.id || '') + '');
                if (flkFin === 'rough opening width' || flkFin === 'rough opening height') {
                    // Dp merge code 10-09 start — keep Rough Opening W/H when mirrored from Finished Opening Size tab
                    keptFinMt.push(item);
                    if (flkFin) newIdxFin[flkFin] = keptFinMt.length - 1;
                    return;
                    // Dp merge code 10-09 end
                }
                keptFinMt.push(item);
                if (flkFin) newIdxFin[flkFin] = keptFinMt.length - 1;
            });
            rows = keptFinMt;
            existingIdx = newIdxFin;
            // Dp end 02-09
        }

        // Dp start 03-09 — backfill Rough Opening W/H only when front selected Rough Opening Size
        if (dpWasRoughOpeningSelectedFromFront(opts, rows)) {
            if (typeof dpIsNonJambSlabOrBrickSetup !== 'function' || !dpIsNonJambSlabOrBrickSetup(opts, rows)) {
                var rw03 = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['rough-width-int', 'rough_width_int']),
                    dpReadOptKeys(opts, ['rough-width-frac', 'rough-width-frac_label', 'rough_width_frac', 'rough_width_fraction'])
                );
                var rh03 = dpCombineDimensionInchesLabel(
                    dpReadOptKeys(opts, ['rough-height-int', 'rough_height_int']),
                    dpReadOptKeys(opts, ['rough-height-frac', 'rough-height-frac_label', 'rough_height_frac', 'rough_height_fraction'])
                );
                // Dp merge code 10-09 start — repair stale 15/16 via setCombined
                if (rh03 && typeof dpRepairHeightIfStale1516 === 'function') {
                    rh03 = dpRepairHeightIfStale1516(rh03, opts, 'rough');
                }
                // Dp merge code 10-09 end
                if (rw03) upsertRow('Rough Opening Width', rw03);
                if (rh03) upsertRow('Rough Opening Height', rh03);
            }
        } else {
            // Strip stale mirrored Rough Opening rows when front did not select Rough Opening Size
            var keptNoRough03 = [];
            var newIdxNoRough03 = {};
            rows.forEach(function (item) {
                if (!item || typeof item === 'string') {
                    keptNoRough03.push(item);
                    return;
                }
                var flkNoRough = dpNormalizeFieldKey((item.label || item.id || '') + '');
                if (flkNoRough === 'rough opening width' || flkNoRough === 'rough opening height') return;
                keptNoRough03.push(item);
                if (flkNoRough) newIdxNoRough03[flkNoRough] = keptNoRough03.length - 1;
            });
            rows = keptNoRough03;
            existingIdx = newIdxNoRough03;
        }
        // Dp end 03-09

        // Dp start 26-08 — always one product thickness row; drop duplicate Door / Exact Door Thickness
        (function dpNormalizeProductThicknessRowsLocal() {
            if (typeof dpIsMillworkQuoteContext === 'function' && dpIsMillworkQuoteContext(opts, rows)) return;
            if (typeof dpIsHardwareProductQuote === 'function' && dpIsHardwareProductQuote(opts, rows)) return;
            if (typeof dpApplyProductThicknessToRows === 'function') {
                rows = dpApplyProductThicknessToRows(opts, rows);
                return;
            }
            var thickVal =
                typeof dpFindDoorThicknessValue === 'function'
                    ? dpFindDoorThicknessValue(opts, rows)
                    : dpReadOptKeys(opts, [
                        'finished-door-thickness_label',
                        'finished_door_thickness_label',
                        'finished-door-thickness',
                        'finished_door_thickness',
                        'rough-door-thickness_label',
                        'rough_door_thickness_label',
                        'rough-door-thickness',
                        'rough_door_thickness',
                        'exact-door-thickness-frac_label',
                        'exact_door_thickness_frac_label',
                        'exact_door_thickness_frac',
                        'exact-door-thickness-frac',
                        'exact_door_thickness',
                        'door_thickness',
                        'door-thickness',
                        'panel-door-thickness-frac',
                        'exact_door_thickness_inches',
                        'door_thickness_inches',
                    ]);
            if (thickVal) upsertRow('Door Thickness', thickVal);
            var keptT = [];
            var sawDoorThick = false;
            var newIdxT = {};
            rows.forEach(function (item) {
                if (!item || typeof item === 'string') {
                    keptT.push(item);
                    return;
                }
                var flk = dpNormalizeFieldKey((item.label || item.id || '') + '');
                if (flk === 'exact door thickness' || flk === 'exact gate thickness' || flk === 'gate thickness') {
                    if (sawDoorThick) return;
                    item.label = 'Door Thickness';
                    if (thickVal) item.value = thickVal;
                    else if (typeof dpDimensionDropdownDisplayLabel === 'function') {
                        item.value = dpDimensionDropdownDisplayLabel(item.value);
                    }
                    flk = 'door thickness';
                    sawDoorThick = true;
                } else if (flk === 'door thickness') {
                    if (sawDoorThick) return;
                    if (thickVal) item.value = thickVal;
                    else if (typeof dpDimensionDropdownDisplayLabel === 'function') {
                        item.value = dpDimensionDropdownDisplayLabel(item.value);
                    }
                    sawDoorThick = true;
                }
                keptT.push(item);
                if (flk) newIdxT[flk] = keptT.length - 1;
            });
            rows = keptT;
            existingIdx = newIdxT;
        })();
        // Dp end 26-08

        // Dp merge code 10-09 start — Exact Door / Exact Gate Size from front int+frac (quote + admin listing)
        // Does not change row order beyond placing Size after Finished Opening Size when present.
        (function dpUpsertExactDoorSizeSummary09() {
            var mtUp09 = '';
            try {
                mtUp09 = dpNormalizeFieldKey(
                    String(dpResolveMeasurementContextKey(opts, rows) || '').replace(/_/g, ' ')
                );
            } catch (eMtUp09) { }
            var colUp09 = String(
                opts._route_collection || opts._collection_handle || opts._product_type || ''
            ).toLowerCase();
            var isGateUp09 =
                mtUp09 === 'exact gate size' ||
                colUp09.indexOf('gate') !== -1 ||
                rows.some(function (r) {
                    if (!r || typeof r === 'string') return false;
                    var lk = dpNormalizeFieldKey((r.label || r.id || '') + '');
                    return lk === 'gate thickness' || lk === 'exact gate size' || lk === 'exact gate width';
                });
            // Sidelight/transom-only products: do not invent Exact Door Size here
            if (
                mtUp09 === 'exact sidelight size' ||
                mtUp09 === 'exact transom size' ||
                mtUp09 === 'jamb unit size' ||
                mtUp09 === 'pre hung unit size' ||
                mtUp09 === 'pre-hung unit size'
            ) {
                return;
            }

            function stripWh(v) {
                return String(v == null ? '' : v)
                    .replace(/\s*[wh]$/i, '')
                    .replace(/\s*inches?\s*$/i, '')
                    .trim();
            }
            function isFracOnly(v) {
                return /^\d+\s*\/\s*\d+$/.test(String(v || '').trim());
            }
            function preferFullDim(v, combinedKeys) {
                v = stripWh(v);
                if (!v || !isFracOnly(v)) return v;
                var alt = stripWh(dpReadOptKeys(opts, combinedKeys || []));
                if (alt && !isFracOnly(alt)) return alt;
                return '';
            }

            var ew = '';
            var eh = '';
            rows.forEach(function (item) {
                if (!item || typeof item === 'string') return;
                var sk = dpNormalizeFieldKey((item.label || item.id || '') + '');
                var sv = stripWh(item.value != null ? item.value : item.display || '');
                if (!sv || isFracOnly(sv)) return;
                if (
                    (sk === 'exact door width' || sk === 'exact gate width' || sk === 'gate width') &&
                    !ew
                ) {
                    ew = sv;
                }
                if (
                    (sk === 'exact door height' || sk === 'exact gate height' || sk === 'gate height') &&
                    !eh
                ) {
                    eh = sv;
                }
            });
            if (!ew || !eh) {
                var ewLive = preferFullDim(
                    dpCombineDimensionInchesLabel(
                        dpReadOptKeys(opts, [
                            'exact-door-width-int',
                            'exact_door_width_int',
                            'door_width',
                            'exact_door_width',
                        ]),
                        dpReadOptKeys(opts, [
                            'exact-door-width-frac',
                            'exact_door_width_frac',
                            'exact_door_width_fraction_value',
                            'exact_door_width_fraction',
                            'door_width_fraction',
                        ])
                    ),
                    ['exact_door_width', 'exact_door_width_inches']
                );
                var ehLive = preferFullDim(
                    dpCombineDimensionInchesLabel(
                        dpReadOptKeys(opts, [
                            'exact-door-height-int',
                            'exact_door_height_int',
                            'door_height',
                            'exact_door_height',
                        ]),
                        dpReadOptKeys(opts, [
                            'exact-door-height-frac',
                            'exact_door_height_frac',
                            'exact_door_height_fraction_value',
                            'door_height_fraction',
                            'door_height_frac',
                        ])
                    ),
                    ['exact_door_height', 'exact_door_height_inches']
                );
                if (!ew && ewLive) ew = ewLive;
                if (!eh && ehLive) eh = ehLive;
            }
            ew = preferFullDim(ew, ['exact_door_width', 'exact_door_width_inches']);
            eh = preferFullDim(eh, ['exact_door_height', 'exact_door_height_inches']);
            if (!ew || !eh || isFracOnly(ew) || isFracOnly(eh)) return;

            var sizeLabel = isGateUp09 ? 'Exact Gate Size' : 'Exact Door Size';
            var sizeKey = isGateUp09 ? 'exact gate size' : 'exact door size';
            var sizeVal = ew + 'w x ' + eh + 'h';
            var kept = [];
            var finAt = -1;
            var exactAt = -1;
            rows.forEach(function (item) {
                if (!item || typeof item === 'string') {
                    kept.push(item);
                    return;
                }
                var sk = dpNormalizeFieldKey((item.label || item.id || '') + '');
                if (sk === 'exact door width' || sk === 'exact door height') return;
                if (sk === 'exact gate width' || sk === 'exact gate height') return;
                // Gate: drop Exact Door Size; Door: drop incomplete Exact Gate Size leftovers
                if (isGateUp09 && sk === 'exact door size') return;
                if (!isGateUp09 && sk === 'exact gate size') return;
                if (sk === sizeKey) {
                    item.label = sizeLabel;
                    item.value = sizeVal;
                    exactAt = kept.length;
                    kept.push(item);
                    return;
                }
                if (sk === 'finished opening size') finAt = kept.length;
                kept.push(item);
            });
            if (exactAt < 0) {
                var exactRow = { label: sizeLabel, value: sizeVal };
                if (finAt >= 0) kept.splice(finAt + 1, 0, exactRow);
                else kept.push(exactRow);
            } else if (finAt >= 0 && exactAt !== finAt + 1) {
                var er = kept.splice(exactAt, 1)[0];
                if (exactAt < finAt) finAt -= 1;
                kept.splice(finAt + 1, 0, er);
            }
            rows = kept;
        })();
        // Dp merge code 10-09 end

        return rows;
    }

    function dpCombineMeasurementFractionSummaryRows(rows) {
        rows = Array.isArray(rows) ? rows : [];
        var fracByParent = {};
        var out = [];
        rows.forEach(function (item) {
            if (!item || typeof item === 'string') {
                out.push(item);
                return;
            }
            var label = String(item.label || item.id || '').trim();
            var value = String(item.value || item.display || '').trim();
            if (!label || !value) {
                out.push(item);
                return;
            }
            var nk = dpNormalizeFieldKey(label);
            var m = nk.match(/^(.*?)\s+fraction$/) || nk.match(/^(.*?)\s*\(\s*fraction\s*\)$/);
            if (m && m[1]) {
                fracByParent[String(m[1]).trim()] = value;
                return;
            }
            out.push(item);
        });
        if (!Object.keys(fracByParent).length) return out;
        out.forEach(function (row) {
            if (!row || typeof row === 'string') return;
            var lab = String(row.label || '').trim();
            var val = String(row.value || '').trim();
            var pk = dpNormalizeFieldKey(lab);
            if (!pk || !Object.prototype.hasOwnProperty.call(fracByParent, pk)) return;
            if (/\d+\s+\d+\/\d+/.test(val) || val.indexOf('/') !== -1) return;
            var combined = dpCombineDimensionInchesLabel(val, fracByParent[pk]);
            if (combined) row.value = combined;
        });
        return out;
    }
    // Dp end 26-08

    // Dp start 02-09 — use storefront thickness title (Door / Sidelight / Transom / Gate), not always Door Thickness
    function dpDetectSidelightTransomProductType(opts, rows) {
        opts = opts || {};
        rows = Array.isArray(rows) ? rows : [];
        var i;
        for (i = 0; i < rows.length; i++) {
            var item = rows[i];
            if (!item || typeof item === 'string') continue;
            var lab = dpNormalizeFieldKey((item.label || item.id || '') + '');
            if (lab === 'sidelight thickness') return 'sidelight';
            if (lab === 'transom thickness') return 'transom';
        }
        function colTypeFromHandle(h) {
            h = String(h || '')
                .toLowerCase()
                .replace(/^\/+|\/+$/g, '');
            if (h.indexOf('transom') !== -1) return 'transom';
            if (h.indexOf('sidelight') !== -1) return 'sidelight';
            return '';
        }
        var fromCol = colTypeFromHandle(opts._route_collection || opts._collection_handle || '');
        if (fromCol) return fromCol;
        var cols = opts._product_collection_handles || opts._product_collections || [];
        if (Array.isArray(cols)) {
            for (i = 0; i < cols.length; i++) {
                var entry = cols[i];
                var handle = typeof entry === 'string' ? entry : entry && entry.handle ? entry.handle : '';
                var t = colTypeFromHandle(handle);
                if (t) return t;
            }
        }
        var pname = String(opts._product_name || opts.product_name || '').toLowerCase();
        if (pname.indexOf('transom') !== -1) return 'transom';
        if (pname.indexOf('sidelight') !== -1) return 'sidelight';
        if (
            dpReadOptKeys(opts, [
                'sidelight-sidelight-thickness-frac_label',
                'sidelight-sidelight-thickness-frac',
                'sidelight_sidelight_thickness_frac',
                'sidelight_sidelight_thickness',
                'sidelight-sidelight-thickness',
                'sidelight_thickness',
            ])
        ) {
            return 'sidelight';
        }
        if (
            dpReadOptKeys(opts, [
                'transom-transom-thickness-frac_label',
                'transom-transom-thickness-frac',
                'transom_transom_thickness_frac',
                'transom_transom_thickness',
                'transom-transom-thickness',
                'transom_thickness',
            ])
        ) {
            return 'transom';
        }
        return '';
    }

    function dpResolveProductThicknessLabel(opts, rows) {
        opts = opts || {};
        rows = Array.isArray(rows) ? rows : [];
        var prefer = [
            'sidelight thickness',
            'transom thickness',
            'gate thickness',
            'panel thickness',
            'door thickness',
            'exact door thickness',
            'exact gate thickness',
        ];
        var pi;
        for (pi = 0; pi < prefer.length; pi++) {
            var want = prefer[pi];
            for (var ri = 0; ri < rows.length; ri++) {
                var row = rows[ri];
                if (!row || typeof row === 'string') continue;
                var rk = dpNormalizeFieldKey((row.label || row.id || '') + '');
                if (rk !== want) continue;
                if (want === 'exact door thickness') return 'Door Thickness';
                if (want === 'exact gate thickness') return 'Gate Thickness';
                if (want === 'door thickness') return 'Door Thickness';
                if (want === 'sidelight thickness') return 'Sidelight Thickness';
                if (want === 'transom thickness') return 'Transom Thickness';
                if (want === 'gate thickness') return 'Gate Thickness';
                if (want === 'panel thickness') return 'Panel Thickness';
            }
        }
        var colType = dpDetectSidelightTransomProductType(opts, rows);
        if (colType === 'sidelight') return 'Sidelight Thickness';
        if (colType === 'transom') return 'Transom Thickness';
        var col = String(opts._route_collection || opts._collection_handle || '').toLowerCase();
        if (col.indexOf('gate') !== -1 || col.indexOf('pet-gate') !== -1) return 'Gate Thickness';
        return 'Door Thickness';
    }

    function dpFindProductThicknessValue(opts, rows, label) {
        opts = opts || {};
        rows = Array.isArray(rows) ? rows : [];
        label = String(label || 'Door Thickness');
        var nk = dpNormalizeFieldKey(label);
        var fromKeys = '';
        // Dp start 03-09 — Prefer active panel + hardware when panel keys keep stale defaults
        var roughKeys = [
            'rough-door-thickness_label',
            'rough_door_thickness_label',
            'rough-door-thickness',
            'rough_door_thickness',
        ];
        var finishedKeys = [
            'finished-door-thickness_label',
            'finished_door_thickness_label',
            'finished-door-thickness',
            'finished_door_thickness',
        ];
        var exactKeys = [
            'exact-door-thickness-frac_label',
            'exact_door_thickness_frac_label',
            'exact-door-thickness-frac',
            'exact_door_thickness_frac',
            'exact_door_thickness',
            'door_thickness',
            'door-thickness',
        ];
        var livePanelThickKeys = roughKeys.concat(finishedKeys, exactKeys);
        var sidelightKeys = [
            'sidelight-sidelight-thickness-frac_label',
            'sidelight-sidelight-thickness-frac',
            'sidelight_sidelight_thickness_frac',
            'sidelight_sidelight_thickness',
            'sidelight-sidelight-thickness',
            'sidelight_thickness',
        ];
        var transomKeys = [
            'transom-transom-thickness-frac_label',
            'transom-transom-thickness-frac',
            'transom_transom_thickness_frac',
            'transom_transom_thickness',
            'transom-transom-thickness',
            'transom_thickness',
        ];
        function normThick(v) {
            return String(v || '')
                .replace(/\s*inches?\s*$/i, '')
                .replace(/\s*t$/i, '')
                .trim()
                .toLowerCase();
        }
        function readHwThick() {
            var v = dpReadOptKeys(opts, [
                'thickness_label',
                'thickness_value',
                'hardware_door_thickness',
                'hardware-door-thickness',
            ]);
            if (v) return v;
            var hw = opts._hardware_selections || opts.hardware_options || [];
            if (typeof hw === 'string') {
                try {
                    hw = JSON.parse(hw);
                } catch (eHw) {
                    hw = [];
                }
            }
            if (Array.isArray(hw)) {
                for (var hi = 0; hi < hw.length; hi++) {
                    var row = hw[hi];
                    if (!row || typeof row !== 'object') continue;
                    var t = String(row.thickness_label || row.thickness_value || '').trim();
                    if (t) return t;
                }
            }
            for (var ri = 0; ri < rows.length; ri++) {
                var item = rows[ri];
                if (!item || typeof item !== 'object') continue;
                if (dpNormalizeFieldKey((item.label || item.id || '') + '') === 'hardware door thickness') {
                    var tv = String(item.value || item.display || '').trim();
                    if (tv) return tv;
                }
            }
            return '';
        }
        var mt =
            typeof dpResolveMeasurementContextKey === 'function'
                ? String(dpResolveMeasurementContextKey(opts, rows) || '').toLowerCase()
                : typeof dpResolveMeasurementTypeKey === 'function'
                    ? String(dpResolveMeasurementTypeKey(opts, rows) || '').toLowerCase()
                    : '';
        var panelVal = '';
        if (mt.indexOf('rough') !== -1) panelVal = dpReadOptKeys(opts, roughKeys);
        else if (mt.indexOf('finished') !== -1) panelVal = dpReadOptKeys(opts, finishedKeys);
        else if (
            mt.indexOf('exact') !== -1 ||
            mt.indexOf('jamb') !== -1 ||
            mt.indexOf('slab') !== -1 ||
            mt.indexOf('brick') !== -1 ||
            mt.indexOf('sidelight') !== -1 ||
            mt.indexOf('transom') !== -1 ||
            mt.indexOf('gate') !== -1
        ) {
            panelVal = dpReadOptKeys(opts, exactKeys);
        }
        var hwVal = readHwThick();
        // Door / slab product thickness must never come from suggested-hardware thickness.
        // "Hardware Door Thickness" is a separate field from _hardware_selections.
        var useHwForProductThick =
            nk === 'hardware door thickness' ||
            (typeof dpIsHardwareProductQuote === 'function' && dpIsHardwareProductQuote(opts, rows));
        if (!useHwForProductThick) hwVal = '';
        if (panelVal) {
            fromKeys = panelVal;
        } else if (hwVal) {
            fromKeys = hwVal;
        } else if (nk === 'sidelight thickness') {
            fromKeys = dpReadOptKeys(opts, livePanelThickKeys.concat(sidelightKeys));
        } else if (nk === 'transom thickness') {
            fromKeys = dpReadOptKeys(opts, livePanelThickKeys.concat(transomKeys));
        } else if (nk === 'gate thickness') {
            fromKeys = dpReadOptKeys(opts, [
                'exact-gate-thickness-frac_label',
                'exact_gate_thickness_frac_label',
                'exact-gate-thickness-frac',
                'exact_gate_thickness_frac',
                'gate_thickness',
                'exact_gate_thickness',
            ]);
            if (!fromKeys) fromKeys = dpReadOptKeys(opts, livePanelThickKeys);
        } else {
            fromKeys = dpReadOptKeys(opts, livePanelThickKeys);
            if (!fromKeys && typeof dpFindDoorThicknessValue === 'function') {
                fromKeys = dpFindDoorThicknessValue(opts, rows);
            }
        }
        // Dp end 03-09
        if (!fromKeys) {
            for (var i = 0; i < rows.length; i++) {
                var item2 = rows[i];
                if (!item2 || typeof item2 !== 'object') continue;
                var rowNk = dpNormalizeFieldKey((item2.label || item2.id || '') + '');
                // Do not fill Door Thickness from a Hardware Door Thickness summary row
                if (nk === 'door thickness' || nk === 'exact door thickness') {
                    if (rowNk === 'hardware door thickness' || /^hardware\s+\d+\s+door thickness$/.test(rowNk)) {
                        continue;
                    }
                }
                if (rowNk === nk) {
                    fromKeys = String(item2.value || '').trim();
                    if (fromKeys) break;
                }
            }
        }
        if (!fromKeys && nk !== 'door thickness' && typeof dpFindDoorThicknessValue === 'function') {
            fromKeys = dpFindDoorThicknessValue(opts, rows);
        }
        return String(fromKeys || '')
            .replace(/\s*inches?\s*$/i, '')
            .replace(/\s*t$/i, '')
            .trim();
    }

    function dpApplyProductThicknessToRows(opts, rows) {
        opts = opts || {};
        rows = Array.isArray(rows) ? rows.slice() : [];
        var label = dpResolveProductThicknessLabel(opts, rows);
        var labelKey = dpNormalizeFieldKey(label);
        var thickVal = dpFindProductThicknessValue(opts, rows, label);
        if (!thickVal) return rows;
        if (typeof dpDimensionDropdownDisplayLabel === 'function') thickVal = dpDimensionDropdownDisplayLabel(thickVal);
        thickVal = String(thickVal || '')
            .replace(/\s*t$/i, '')
            .trim();
        if (!thickVal) return rows;
        var kept = [];
        var saw = false;
        var dropDoorThick = labelKey === 'sidelight thickness' || labelKey === 'transom thickness' || labelKey === 'gate thickness';
        rows.forEach(function (item) {
            if (!item || typeof item === 'string') {
                kept.push(item);
                return;
            }
            var flk = dpNormalizeFieldKey((item.label || item.id || '') + '');
            if (dropDoorThick && (flk === 'door thickness' || flk === 'exact door thickness')) return;
            if (
                flk === labelKey ||
                (labelKey === 'door thickness' &&
                    (flk === 'exact door thickness' || flk === 'exact gate thickness' || flk === 'gate thickness'))
            ) {
                if (saw) return;
                item.label = label;
                item.value = thickVal;
                saw = true;
                kept.push(item);
                return;
            }
            kept.push(item);
        });
        if (!saw) kept.push({ label: label, value: thickVal });
        return kept;
    }
    // Dp end 02-09

    // Dp start 26-08 — Liquid-only: find Door Thickness from any saved option / summary shape
    function dpFindDoorThicknessValue(opts, rows) {
        opts = opts || {};
        var known = dpReadOptKeys(opts, [
            'finished-door-thickness_label',
            'finished_door_thickness_label',
            'finished-door-thickness',
            'finished_door_thickness',
            'rough-door-thickness_label',
            'rough_door_thickness_label',
            'rough-door-thickness',
            'rough_door_thickness',
            'exact-door-thickness-frac_label',
            'exact_door_thickness_frac_label',
            'exact_door_thickness_frac',
            'exact-door-thickness-frac',
            'exact_door_thickness',
            'door_thickness',
            'door-thickness',
            'panel-door-thickness-frac',
            'panel_door_thickness',
            'exact_door_thickness_inches',
            'door_thickness_inches',
            'screen_storm_thickness_frac',
            'screen_storm_thickness',
        ]);
        if (known) {
            // Dp merge code 10-09 start — strip inch / _inch (e.g. 1 3/8_inch → 1 3/8)
            return String(known)
                .replace(/_/g, ' ')
                .replace(/\s+/g, ' ')
                .replace(/\s*(?:inches?|_?inch|t)\s*$/i, '')
                .trim();
            // Dp merge code 10-09 end
        }

        function looksThickKey(k) {
            var s = String(k || '')
                .toLowerCase()
                .replace(/[_-]+/g, ' ');
            if (!s) return false;
            if (s.indexOf('thick') === -1) return false;
            // Skip hardware / casing / sidelight / transom thickness extras
            if (s.indexOf('hardware') !== -1 || s.indexOf('casing') !== -1) return false;
            if (s.indexOf('sidelight') !== -1 || s.indexOf('transom') !== -1) return false;
            if (s.indexOf('panel thickness') !== -1 && s.indexOf('door') === -1) return false;
            return true;
        }
        function pickVal(raw) {
            if (raw == null) return '';
            if (Array.isArray(raw)) raw = raw[0];
            var s = String(raw).trim();
            if (!s) return '';
            s = s
                .replace(/\s*inches?\s*$/i, '')
                .replace(/\s*t$/i, '')
                .trim();
            if (typeof dpDimensionDropdownDisplayLabel === 'function') s = dpDimensionDropdownDisplayLabel(s);
            // Accept fraction labels / mixed inches / thickness decimals (1.5 → 1 1/2)
            if (!/\d/.test(s)) return '';
            if (/^0(\.0+)?$/.test(s)) return '';
            if (/^(none|select|please select|--|-)$/i.test(s)) return '';
            return s;
        }
        function extractFromSizeText(text) {
            var s = String(text == null ? '' : text);
            // "80w x 125h x 1 1/2t" or "… x 1.5t" or "… x 1 1/2 t"
            var m = s.match(/\bx\s*(\d+(?:\s+\d+\/\d+)?|\d+(?:\.\d+)?)\s*t\b/i);
            if (!m || !m[1]) return '';
            return pickVal(m[1]);
        }

        var keys = Object.keys(opts);
        var i;
        // Prefer non-empty *_label companions first
        for (i = 0; i < keys.length; i++) {
            var lk = keys[i];
            if (!/_label$/i.test(lk) || !looksThickKey(lk.replace(/_label$/i, ''))) continue;
            var gotL = pickVal(opts[lk]);
            if (gotL) return gotL;
        }
        for (i = 0; i < keys.length; i++) {
            var k = keys[i];
            if (!looksThickKey(k)) continue;
            if (/_label$/i.test(k)) continue;
            // Skip raw key only when a non-empty companion label already exists
            var labCompanion = opts[k + '_label'];
            if (labCompanion != null && String(labCompanion).trim() !== '') continue;
            var got = pickVal(opts[k]);
            if (got) return got;
        }

        // Pricing schema option ids (label/id contains thickness)
        var schema = opts._pricing_schema;
        if (Array.isArray(schema)) {
            for (i = 0; i < schema.length; i++) {
                var opt = schema[i];
                if (!opt || !opt.id) continue;
                var sid = String(opt.id || '');
                var slab = String(opt.label || opt.title || '');
                if (!looksThickKey(sid) && !looksThickKey(slab) && dpNormalizeFieldKey(slab).indexOf('thickness') === -1) {
                    continue;
                }
                var fromSchema = pickVal(opts[sid]) || pickVal(opts[sid + '_label']);
                if (fromSchema) return fromSchema;
            }
        }

        // One-level nested option bags (measurements / dimensions)
        for (i = 0; i < keys.length; i++) {
            var nkNest = keys[i];
            var nest = opts[nkNest];
            if (!nest || typeof nest !== 'object' || Array.isArray(nest)) continue;
            if (String(nkNest).charAt(0) === '_') continue;
            var nestedGot = dpReadOptKeys(nest, [
                'finished-door-thickness',
                'rough-door-thickness',
                'exact-door-thickness-frac',
                'door_thickness',
                'door-thickness',
                'thickness',
            ]);
            if (nestedGot) {
                var ng = pickVal(nestedGot);
                if (ng) return ng;
            }
            var nKeys = Object.keys(nest);
            for (var ni = 0; ni < nKeys.length; ni++) {
                if (!looksThickKey(nKeys[ni])) continue;
                var nv = pickVal(nest[nKeys[ni]]);
                if (nv) return nv;
            }
        }

        var list = Array.isArray(rows) ? rows : [];
        for (i = 0; i < list.length; i++) {
            var item = list[i];
            if (!item) continue;
            var lab = '';
            var val = '';
            if (typeof item === 'string') {
                var m = String(item).match(/^([^:]+):\s*([\s\S]+)$/);
                if (m) {
                    lab = m[1];
                    val = m[2];
                } else {
                    var fromBare = extractFromSizeText(item);
                    if (fromBare) return fromBare;
                    continue;
                }
            } else {
                lab = String(item.label || item.id || '').trim();
                val = String(item.value != null ? item.value : item.display || '').trim();
            }
            var nk = dpNormalizeFieldKey(lab);
            if (
                nk === 'door thickness' ||
                nk === 'exact door thickness' ||
                nk === 'exact gate thickness' ||
                nk === 'gate thickness' ||
                (nk.indexOf('door') !== -1 && nk.indexOf('thickness') !== -1)
            ) {
                var pv = pickVal(val);
                if (pv) return pv;
            }
            // Recover thickness token previously collapsed into Exact/Rough/Finished size lines
            if (
                nk === 'exact door size' ||
                nk === 'rough opening size' ||
                nk === 'finished opening size' ||
                nk === 'jamb unit size'
            ) {
                var fromSize = extractFromSizeText(val) || extractFromSizeText(lab + ': ' + val);
                if (fromSize) return fromSize;
            }
        }

        // Line-item properties / stored summary text fallbacks
        var props = opts._line_item_properties;
        if (props && typeof props === 'object' && !Array.isArray(props)) {
            var pKeys = Object.keys(props);
            for (i = 0; i < pKeys.length; i++) {
                var pk = pKeys[i];
                var pnk = dpNormalizeFieldKey(pk);
                if (!looksThickKey(pk) && pnk.indexOf('door thickness') === -1 && pnk !== 'thickness') continue;
                if (pnk.indexOf('sidelight') !== -1 || pnk.indexOf('transom') !== -1) continue;
                var pp = pickVal(props[pk]);
                if (pp) return pp;
            }
        }
        var stored = String(opts.options_summary || opts._options_summary || opts._admin_quote_description_text || '');
        if (stored) {
            var mm = stored.match(/(?:Exact\s+)?Door\s+Thickness\s*:\s*([^\n\r]+)/i);
            if (mm && mm[1]) {
                var sv = pickVal(mm[1]);
                if (sv) return sv;
            }
            var fromStoredSize = extractFromSizeText(stored);
            if (fromStoredSize) return fromStoredSize;
        }
        return '';
    }
    // Dp end 26-08

    function dpAppendQuantityToDescriptionText(text, opts, item) {
        // Dp merge code 10-09 start — always end description summary with Quantity: N from cart/config QTY
        opts = opts || {};
        item = item || {};
        var qty = Math.max(
            1,
            parseInt(item.quantity, 10) ||
            parseInt(opts._quantity, 10) ||
            parseInt(opts.quantity, 10) ||
            1
        );
        var lines = String(text == null ? '' : text)
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .split('\n')
            .map(function (s) {
                return String(s || '').trim();
            })
            .filter(function (s) {
                return !/^Quantity\s*:/i.test(s);
            });
        lines.push('Quantity: ' + qty);
        return lines.join('\n');
        // Dp merge code 10-09 end
    }

    function dpBuildLabeledQuoteDescription(item) {
        // selected_summary + measurement option backfill (Slab Only finished_* → Rough Opening W/H).
        var opts = (item && item.options) || {};
        var rows = item && item.selected_summary;
        if (!Array.isArray(rows) || !rows.length) {
            rows = opts._selected_summary && Array.isArray(opts._selected_summary) ? opts._selected_summary : [];
        }
        rows = Array.isArray(rows) ? rows.slice() : [];
        // Dp start 25-08 — expand hardware/casing into Expected labeled parts
        rows = dpExpandHardwareCasingRowsForDescription(rows, opts);
        // Dp end 25-08
        // Dp start 25-08 — Swing Direction / Hinge Finish "Verify …" fallback text
        rows = dpInjectQuoteDescFallbackRows(rows, opts);
        // Dp end 25-08
        // Dp start 27-08 — backfill selected options (Lockset Prep, Optional Shelf, defaults)
        try {
            rows = dpMergeExtraOptionsIntoSummaryRows(rows, opts, { skipCatchAll: true });
        } catch (eExtraRows) { }
        // Dp end 27-08
        // Porch enclosure fields (Finished Opening, Stops, Door #N …) from options when present.
        try {
            rows = dpMergePanelUnitEnclosureSummaryRows(rows, opts);
        } catch (ePorchRows) { }
        var hasPorchOpenings = typeof dpOptsHasPorchEnclosureOpenings === 'function' && dpOptsHasPorchEnclosureOpenings(opts);
        var isMillworkQuote = typeof dpIsMillworkQuoteContext === 'function' && dpIsMillworkQuoteContext(opts, rows);
        var isHardwareQuote = typeof dpIsHardwareProductQuote === 'function' && dpIsHardwareProductQuote(opts, rows);
        // Dp start 26-08 — Slab Only stores Rough Opening Size while W/H live in finished_*
        // fields. Backfill Rough/Finished/Exact/Pre-Hung rows from options (same as saved-configs)
        // so quote details show e.g. Rough Opening Size: 36w x 80h.
        try {
            if (!hasPorchOpenings && !isMillworkQuote && !isHardwareQuote) {
                rows = dpEnsureMeasurementSummaryRows(opts, rows);
                rows = dpCombineMeasurementFractionSummaryRows(rows);
            }
        } catch (eMeasQuote) { }
        // Dp start 26-08 — force product thickness line (Door / Sidelight / Transom / Gate)
        try {
            if (!hasPorchOpenings && !isMillworkQuote && !isHardwareQuote && typeof dpApplyProductThicknessToRows === 'function') {
                rows = dpApplyProductThicknessToRows(opts, rows);
            } else if (!hasPorchOpenings && !isMillworkQuote && !isHardwareQuote) {
                var thickForce = dpFindDoorThicknessValue(opts, rows);
                if (thickForce) {
                    var foundThick = false;
                    rows = rows.map(function (r) {
                        if (!r || typeof r === 'string') return r;
                        var flk = dpNormalizeFieldKey((r.label || r.id || '') + '');
                        if (
                            flk === 'door thickness' ||
                            flk === 'exact door thickness' ||
                            flk === 'exact gate thickness' ||
                            flk === 'gate thickness'
                        ) {
                            foundThick = true;
                            return { label: 'Door Thickness', value: thickForce, image: r.image || '' };
                        }
                        return r;
                    });
                    if (!foundThick) {
                        rows.push({ label: 'Door Thickness', value: thickForce });
                    }
                }
            }
        } catch (eThickForce) { }
        // Dp end 26-08
        // Dp merge code 10-09 start — cart QTY last in description (do not list mid-list via label skip)
        var labeledOut = dpBuildLabeledRowsFromSummary(rows, opts).join('\n');
        // Dp start VDN-390 27-10
        labeledOut = dpFinalizePreHungDepthDescriptionText(labeledOut);
        // Dp end VDN-390 27-10
        return typeof dpAppendQuantityToDescriptionText === 'function'
            ? dpAppendQuantityToDescriptionText(labeledOut, opts, item)
            : labeledOut;
        // Dp merge code 10-09 end
    }

    function dpLabeledDescriptionLineToHtml(line) {
        // Dp start 26-08 — bold "Label:" prefix; value stays regular weight
        var s = String(line == null ? '' : line).trim();
        if (!s) return '';
        var colon = s.indexOf(':');
        if (colon > 0) {
            var lab = s.slice(0, colon + 1);
            var val = s.slice(colon + 1).replace(/^\s+/, '');
            return '<strong>' + escapeHtml(lab) + '</strong>' + (val ? ' ' + escapeHtml(val) : '');
        }
        return escapeHtml(s);
        // Dp end 26-08
    }

    function dpLabeledDescriptionLinesHtml(text, expanded) {
        text = String(text == null ? '' : text)
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .trim();
        if (!text) return '';
        var segs = text
            .split('\n')
            .map(function (s) {
                return String(s || '').trim();
            })
            ;
        // Dp start 26-08 — drop duplicate lines (normalized) before render
        var uniq = [];
        var seenSeg = {};
        segs.forEach(function (seg) {
            if (!seg) {
                if (uniq.length && uniq[uniq.length - 1] !== '') uniq.push('');
                return;
            }
            var sk = dpNormalizeFieldKey(seg);
            if (!sk) return;
            // Dp start 27-08 — keep both hardware Qty and casing Qty even when the number matches
            // Dp start 03-09 — keep repeated Hardware N / Finish / Hardware Qty lines for multi hardware
            if (seenSeg[sk]) {
                if (
                    /^qty\s*:/i.test(seg) ||
                    /^hardware\s+\d+\s*:/i.test(seg) ||
                    /^hardware\s+\d+\s+(qty|finish|closer color|door thickness|function|swing direction)\s*:/i.test(seg) ||
                    /^hardware qty\s*:/i.test(seg) ||
                    /^finish\s*:/i.test(seg) ||
                    /^closer color\s*:/i.test(seg) ||
                    /^hardware function\s*:/i.test(seg) ||
                    /^hardware swing direction\s*:/i.test(seg) ||
                    /^hardware door thickness\s*:/i.test(seg)
                ) {
                    sk = sk + '|' + uniq.length;
                } else {
                    return;
                }
            }
            // Dp end 03-09
            // Dp end 27-08
            seenSeg[sk] = true;
            uniq.push(seg);
        });
        segs = uniq;
        // Dp end 26-08
        if (!segs.length) return '';
        var limit = expanded ? segs.length : Math.min(3, segs.length);
        var html = '';
        for (var i = 0; i < limit; i++) {
            if (!segs[i]) {
                html += '<li class="door-quote-item__summary-gap" aria-hidden="true"></li>';
                continue;
            }
            html += '<li>' + dpLabeledDescriptionLineToHtml(segs[i]) + '</li>';
        }
        return { html: html, segs: segs, truncated: !expanded && segs.length > 3 };
    }
    // Dp end 24-08

    function dpHumanizeOptionToken(val) {
        var s = String(val == null ? '' : val).trim();
        if (!s) return '';
        return s
            .replace(/_+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .replace(/\b\w/g, function (ch) {
                return ch.toUpperCase();
            });
    }

    function dpSummaryCell(row) {
        if (row == null) return '';
        if (typeof row === 'string') return String(row).trim();
        return String(row.value != null ? row.value : '').trim();
    }

    function dpFormatSummaryWidthW(val) {
        var s = String(val || '').trim();
        if (!s) return '';
        if (/w$/i.test(s)) return s.replace(/\s+/g, ' ');
        // "12 0" → "12w" (match quote sentence; drop trailing zero fraction)
        s = s.replace(/\s+0$/, '').trim();
        if (!s) return '';
        return s + 'w';
    }

    function dpGetQuoteSelectedSummary(opts, item) {
        opts = opts || {};
        var summary = item && item.selected_summary;
        if (!Array.isArray(summary) || !summary.length) {
            summary = opts._selected_summary && Array.isArray(opts._selected_summary) ? opts._selected_summary : [];
        }
        return Array.isArray(summary) ? summary : [];
    }

    /**
     * Build sentence from five parts:
     *   (8) door · (9) width · (10) sidelight style · (11) location · (12) transom
     * → "(8) with (10) Sidelight On (11) and (12) Transom (9)"
     * e.g. Single Door with Grange Sidelight On Left Only and Westover Transom 12w
     */
    function dpBuildSentenceFromParts(door, widthRaw, style, loc, transom) {
        door = String(door == null ? '' : door).trim();
        widthRaw = String(widthRaw == null ? '' : widthRaw).trim();
        style = String(style == null ? '' : style).trim();
        loc = String(loc == null ? '' : loc).trim();
        transom = String(transom == null ? '' : transom).trim();
        var width = dpFormatSummaryWidthW(widthRaw);
        var locClean = loc.replace(/^on\s+/i, '').trim();

        if (!door && !style && !transom) {
            return { sentence: '', parts: null };
        }

        var bits = [];
        bits.push(door || 'Single Door');
        if (style || transom) {
            bits.push('with');
            if (style) {
                bits.push(style + ' Sidelight');
                if (locClean) bits.push('On ' + locClean);
            }
            if (style && transom) bits.push('and');
            if (transom) bits.push(transom + ' Transom');
        }
        var sentence = bits.join(' ').replace(/\s+/g, ' ').trim();
        if (width && (style || transom)) sentence += ' ' + width;

        return {
            sentence: sentence,
            parts: {
                door: door,
                widthRaw: widthRaw,
                width: width,
                style: style,
                loc: loc,
                locClean: locClean,
                transom: transom,
            },
        };
    }

    function dpBuildSentenceFromSummaryIndexes(summary) {
        summary = Array.isArray(summary) ? summary : [];
        return dpBuildSentenceFromParts(
            dpSummaryCell(summary[8]),
            dpSummaryCell(summary[9]),
            dpSummaryCell(summary[10]),
            dpSummaryCell(summary[11]),
            dpSummaryCell(summary[12])
        );
    }

    /** Prefer description-line indexes 8..12 when they match the confirmed fragment pattern. */
    function dpBuildSentenceFromDescriptionLines(lines) {
        lines = Array.isArray(lines) ? lines : [];
        if (lines.length <= 12) return { sentence: '', parts: null };
        var door = String(lines[8] || '').trim();
        var widthRaw = String(lines[9] || '').trim();
        var style = String(lines[10] || '').trim();
        var loc = String(lines[11] || '').trim();
        var transom = String(lines[12] || '').trim();
        if (!/^(single|double)\s+door$/i.test(door)) return { sentence: '', parts: null };
        if (!style && !transom) return { sentence: '', parts: null };
        return dpBuildSentenceFromParts(door, widthRaw, style, loc, transom);
    }

    function dpLineMatchesSummaryPart(line, part) {
        var L = String(line || '')
            .trim()
            .toLowerCase();
        var p = String(part || '')
            .trim()
            .toLowerCase();
        if (!L || !p) return false;
        if (L === p) return true;
        var pNum = p.replace(/\s+0$/, '').replace(/w$/i, '').trim();
        var lNum = L.replace(/\s+0$/, '').replace(/w$/i, '').trim();
        if (pNum && /^\d/.test(pNum) && lNum === pNum) return true;
        if (p.replace(/^on\s+/i, '') === L.replace(/^on\s+/i, '').replace(/^in\s+/i, '')) return true;
        return false;
    }

    function dpReadDoorMeasureParts(opts) {
        opts = opts || {};
        function readPair(intKeys, fracKeys, wholeKeys) {
            var intPart = '';
            var frac = '';
            var whole = '';
            var i;
            for (i = 0; i < intKeys.length; i++) {
                if (opts[intKeys[i]] != null && String(opts[intKeys[i]]).trim() !== '') {
                    intPart = String(opts[intKeys[i]]).trim();
                    break;
                }
            }
            for (i = 0; i < fracKeys.length; i++) {
                if (opts[fracKeys[i]] != null && String(opts[fracKeys[i]]).trim() !== '') {
                    frac = String(opts[fracKeys[i]]).trim();
                    break;
                }
            }
            for (i = 0; i < wholeKeys.length; i++) {
                if (opts[wholeKeys[i]] != null && String(opts[wholeKeys[i]]).trim() !== '') {
                    whole = String(opts[wholeKeys[i]]).trim();
                    break;
                }
            }
            if (frac === '0' || frac === '0/0' || frac === '0"') {
                frac = '0';
            }
            if (intPart) return { intPart: intPart, frac: frac };
            if (whole) {
                var m = String(whole)
                    .trim()
                    .match(/^(\d+)\s*(.*)$/);
                if (m) return { intPart: m[1], frac: (m[2] || '').trim() || '' };
            }
            return null;
        }
        return {
            width: readPair(
                ['exact_door_width_int', 'door_width_int', 'finished_width_int', 'rough_width_int', 'panel_width_int'],
                [
                    'exact_door_width_frac',
                    'exact_door_width_fraction',
                    'door_width_fraction',
                    'finished_width_fraction',
                    'rough_width_fraction',
                ],
                ['exact_door_width', 'door_width', 'finished_width', 'rough_width']
            ),
            height: readPair(
                ['exact_door_height_int', 'door_height_int', 'finished_height_int', 'rough_height_int', 'door_height'],
                [
                    'exact_door_height_frac',
                    'exact_door_height_fraction',
                    'door_height_fraction',
                    'finished_height_fraction',
                    'rough_height_fraction',
                ],
                ['exact_door_height', 'door_height', 'finished_height', 'rough_height']
            ),
        };
    }

    /** "36 0" / "80 0" → "36w 0" / "80h 0" using door width/height from options. */
    function dpAnnotateDoorMeasureLines(text, opts) {
        var measures = dpReadDoorMeasureParts(opts || {});
        var w = measures.width;
        var h = measures.height;
        var lines = String(text == null ? '' : text)
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .split('\n');
        return lines
            .map(function (line) {
                var L = String(line || '').trim();
                if (!L) return L;
                if (/\d+\s*[wh]\b/i.test(L)) return L;
                var bare = L.match(/^(\d+)(?:\s+(.+))?$/);
                if (!bare) return L;
                var intPart = bare[1];
                var rest = (bare[2] || '').trim();
                if (w && String(w.intPart) === intPart) {
                    return rest !== '' ? intPart + 'w ' + rest : intPart + 'w';
                }
                if (h && String(h.intPart) === intPart) {
                    return rest !== '' ? intPart + 'h ' + rest : intPart + 'h';
                }
                return L;
            })
            .filter(Boolean)
            .join('\n');
    }

    function dpIsSslStCodeLine(line) {
        return /^(ssl|st|sl)[\s_-]*0*\d+$/i.test(String(line || '').trim());
    }

    /**
     * Build sidelight/transom sentence from description lines[8..12] (user-confirmed),
     * else selected_summary[8..12]. Remove the five fragment lines + leftover Ssl/St codes.
     */
    function dpCollapseSidelightTransomLines(text, opts, summary) {
        opts = opts || {};
        var lines = String(text == null ? '' : text)
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .split('\n')
            .map(function (l) {
                return String(l || '').trim();
            })
            .filter(Boolean);
        if (!lines.length) return '';

        summary = Array.isArray(summary) ? summary : dpGetQuoteSelectedSummary(opts, null);
        var fromLines = dpBuildSentenceFromDescriptionLines(lines);
        var built = fromLines.sentence && fromLines.parts ? fromLines : dpBuildSentenceFromSummaryIndexes(summary);
        var sentence = built.sentence;
        var parts = built.parts;
        var usedLineIndexes = !!(fromLines.sentence && fromLines.parts);

        if (!sentence || !parts) {
            // Still drop internal style codes (Ssl 01 / St 01) from the list
            var strippedOnly = lines.filter(function (l) {
                return !dpIsSslStCodeLine(l);
            });
            return dpAnnotateDoorMeasureLines(strippedOnly.join('\n'), opts);
        }

        console.log('[Quote sentence] (8) with (10) Sidelight On (11) and (12) Transom (9) =>', sentence, parts);

        var out = [];
        var inserted = false;

        if (usedLineIndexes) {
            for (var i = 0; i < lines.length; i++) {
                if (i >= 8 && i <= 12) {
                    if (!inserted) {
                        out.push(sentence);
                        inserted = true;
                    }
                    continue;
                }
                if (/^(single|double)\s+door\s+with\b/i.test(lines[i])) {
                    if (!inserted) {
                        out.push(sentence);
                        inserted = true;
                    }
                    continue;
                }
                if (dpIsSslStCodeLine(lines[i])) continue;
                out.push(lines[i]);
            }
        } else {
            for (var k = 0; k < lines.length; k++) {
                var line = lines[k];
                if (/^(single|double)\s+door\s+with\b/i.test(line)) {
                    if (!inserted) {
                        out.push(sentence);
                        inserted = true;
                    }
                    continue;
                }
                if (dpIsSslStCodeLine(line)) continue;
                if (
                    dpLineMatchesSummaryPart(line, parts.door) ||
                    dpLineMatchesSummaryPart(line, parts.style) ||
                    dpLineMatchesSummaryPart(line, parts.loc) ||
                    dpLineMatchesSummaryPart(line, parts.locClean) ||
                    dpLineMatchesSummaryPart(line, parts.transom) ||
                    dpLineMatchesSummaryPart(line, parts.widthRaw) ||
                    dpLineMatchesSummaryPart(line, parts.width)
                ) {
                    if (!inserted) {
                        out.push(sentence);
                        inserted = true;
                    }
                    continue;
                }
                out.push(line);
            }
        }
        if (!inserted) out.unshift(sentence);

        var seen = {};
        var collapsed = out
            .filter(function (line) {
                if (dpIsSslStCodeLine(line)) return false;
                var key = line.toLowerCase();
                if (seen[key]) return false;
                seen[key] = true;
                return true;
            })
            .join('\n');
        return dpAnnotateDoorMeasureLines(collapsed, opts);
    }

    /**
     * TEMP debug: dump option keys/values so we can pick which fields build the
     * "Single Door with … Sidelight … Transom …" sentence. Check browser console.
     */
    function dpDebugQuoteSentenceKeys(item) {
        // Opt-in only: set window.__doorQuoteDebugSentenceKeys = true in the console.
        if (typeof window === 'undefined' || !window.__doorQuoteDebugSentenceKeys) return;
        try {
            var opts = (item && item.options) || {};
            var pairs = {};
            var interesting = [];
            Object.keys(opts).forEach(function (key) {
                var val = opts[key];
                if (val == null || val === '' || val === false) return;
                if (typeof val === 'object' && !Array.isArray(val) && !Object.keys(val).length) return;
                pairs[key] = val;
                if (/sidelight|transom|door_unit|unit_design|doorUnit|location|style|design|width|height/i.test(key)) {
                    interesting.push({ key: key, value: val });
                }
            });
            var summary = dpGetQuoteSelectedSummary(opts, item);
            console.groupCollapsed(
                '[Quote sentence keys] config #' +
                (item && item.id != null ? item.id : '?') +
                ' — ' +
                String((item && item.product_title) || opts._product_title || '')
            );
            console.log('1) Interesting option keys:');
            console.table(interesting);
            console.log('2) All option key → value pairs:');
            console.log(pairs);
            console.log('3) selected_summary by index (sentence uses 8,9,10,11,12):');
            summary.forEach(function (row, i) {
                console.log('(' + i + ')', (row && row.label) || '', '→', row && row.value != null ? row.value : row);
            });
            console.log('4) Description-line formula uses indexes 8..12 when present:');
            console.log('    (8) with (10) Sidelight On (11) and (12) Transom (9)');
            console.log('    e.g. Single Door with Grange Sidelight On Left Only and Westover Transom 12w');
            var built = dpBuildSentenceFromSummaryIndexes(summary);
            console.log('5) Fallback from selected_summary[8..12] =>', built.sentence);
            console.log('6) Stored options_summary (first 1500 chars):');
            console.log(String(opts.options_summary || opts._options_summary || item.options_summary || '').slice(0, 1500));
            console.groupEnd();
        } catch (eDbg) {
            console.warn('[Quote sentence keys] debug failed', eDbg);
        }
    }

    /**
     * Same description pipeline as admin PDF / Create Draft Order quote_description:
     * DoorDescription (or saved summary) + every selected value, one per line.
     */
    function buildUnifiedQuoteDescription(item) {
        var opts = (item && item.options) || {};
        var summary = dpGetQuoteSelectedSummary(opts, item);
        dpDebugQuoteSentenceKeys(item);
        // Dp start 26-08 — prefer Label:Value builder (Exact Door Width/Height, Sidelight,
        // Transom, Pre-Hung + fractions) so stored options_summary matches quote UI / PHP PDF.
        try {
            var labeledPrimary = dpBuildLabeledQuoteDescription(item);
            if (labeledPrimary && String(labeledPrimary).trim()) {
                // dpBuildLabeledQuoteDescription already appends Quantity
                return String(labeledPrimary).trim();
            }
        } catch (eLabeledPrimary) { }
        // Dp end 26-08
        var text = '';
        var stored = String(
            opts._admin_quote_description_text ||
            opts.options_summary ||
            opts._options_summary ||
            item.options_summary ||
            ''
        ).trim();
        if (stored && stored.indexOf('\n') !== -1) {
            text = stored
                .split(/\r?\n/)
                .map(function (line) {
                    return dpNormalizeDescriptionValue(line);
                })
                .filter(Boolean)
                .join('\n');
            text = dpCollapseSidelightTransomLines(text, opts, summary);
            // Dp start VDN-390 27-10
            text = dpFinalizePreHungDepthDescriptionText(text);
            // Dp end VDN-390 27-10
            return dpAppendQuantityToDescriptionText(text, opts, item);
        }
        if (stored && stored.indexOf(' / ') !== -1) {
            text = stored;
        }
        try {
            if (!text && window.DoorDescription && typeof window.DoorDescription.build === 'function') {
                var pType = String(item.product_type || opts._product_type || '');
                if (/screen|storm|interior|exterior|porch/i.test(pType)) {
                    text =
                        window.DoorDescription.build({
                            config: opts,
                            schema: window.__doorConfigSchema,
                            productTitle: item.product_title || opts._product_title || '',
                            productType: pType,
                        }) || '';
                }
            }
        } catch (eBuildDesc) { }

        var rows = collectQuoteDescriptionRows(item);
        text = dpAppendSelectedSummaryToDescription(text, rows);
        text = dpFormatDescriptionMultiline(text);
        text = dpCollapseSidelightTransomLines(text, opts, summary);
        // Dp start VDN-390 27-10
        text = dpFinalizePreHungDepthDescriptionText(text);
        // Dp end VDN-390 27-10
        return dpAppendQuantityToDescriptionText(text, opts, item);
    }

    function summaryLines(item, expanded) {
        try {
            // Dp start 24-08 — quote page display only: "Label : Value" from product-page selected items
            var labeledText = dpBuildLabeledQuoteDescription(item);
            if (labeledText) {
                var renderedL = dpLabeledDescriptionLinesHtml(labeledText, expanded);
                if (renderedL && renderedL.html) {
                    var outHtmlL =
                        '<ul class="door-quote-item__summary door-quote-item__summary--spec">' + renderedL.html + '</ul>';
                    if (renderedL.segs.length > 3) {
                        outHtmlL +=
                            '<button type="button" class="door-quote-item__more" data-toggle-more="' +
                            escapeHtml(String(item.id)) +
                            '">' +
                            (expanded ? 'Less details' : '+ More Details') +
                            '</button>';
                    }
                    return outHtmlL;
                }
            }
            // Dp end 24-08
            var text = buildUnifiedQuoteDescription(item);
            if (text) {
                var rendered = dpDescriptionLinesHtml(text, expanded);
                if (rendered && rendered.html) {
                    var outHtml =
                        '<ul class="door-quote-item__summary door-quote-item__summary--spec">' + rendered.html + '</ul>';
                    if (rendered.segs.length > 3) {
                        outHtml +=
                            '<button type="button" class="door-quote-item__more" data-toggle-more="' +
                            escapeHtml(String(item.id)) +
                            '">' +
                            (expanded ? 'Less details' : '+ More Details') +
                            '</button>';
                    }
                    return outHtml;
                }
            }
        } catch (eSpecLines) { }

        var rows = collectQuoteDescriptionRows(item);
        var limit = expanded ? rows.length : Math.min(3, rows.length);
        var html = '<ul class="door-quote-item__summary door-quote-item__summary--spec">';
        for (var i = 0; i < limit; i++) {
            var r = rows[i];
            if (typeof r === 'string') {
                var s1 = dpNormalizeDescriptionValue(r);
                if (s1) html += '<li>' + escapeHtml(s1) + '</li>';
            } else {
                var value = dpNormalizeDescriptionValue((r && (r.value || r.display || r.name)) || '');
                if (value) html += '<li>' + escapeHtml(value) + '</li>';
            }
        }
        html += '</ul>';
        if (rows.length > 3) {
            html +=
                '<button type="button" class="door-quote-item__more" data-toggle-more="' +
                escapeHtml(String(item.id)) +
                '">' +
                (expanded ? 'Less details' : '+ More Details') +
                '</button>';
        }
        return html;
    }

    function getItemFriendlyName(item) {
        if (!item) return '';
        if (item.options && item.options._friendly_name) return String(item.options._friendly_name).trim();
        if (item.friendly_name) return String(item.friendly_name).trim();
        return '';
    }

    function setItemFriendlyName(item, name) {
        if (!item) return;
        var val = (name || '').trim();
        if (!item.options || typeof item.options !== 'object') item.options = {};
        if (val) {
            item.options._friendly_name = val;
            item.friendly_name = val;
        } else {
            delete item.options._friendly_name;
            delete item.friendly_name;
        }
    }

    function syncFriendlyNamesFromDom() {
        if (!listEl || !saveLaterNamingMode) return;
        var inputs = listEl.querySelectorAll('[data-friendly-input]');
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            var id = input.getAttribute('data-friendly-input');
            var val = (input.value || '').trim();
            for (var j = 0; j < items.length; j++) {
                if (String(items[j].id) === String(id)) {
                    setItemFriendlyName(items[j], val);
                    break;
                }
            }
        }
        persistItems();
    }

    function setSaveLaterNamingMode(on) {
        saveLaterNamingMode = !!on;
        if (root) {
            if (saveLaterNamingMode) root.classList.add('is-save-later-naming');
            else root.classList.remove('is-save-later-naming');
        }
        if (saveLaterBtn) {
            saveLaterBtn.textContent = saveLaterNamingMode ? 'Confirm Save' : 'Save For Later';
        }
    }

    function keepElementViewportTop(el, fn) {
        var topBefore = el ? el.getBoundingClientRect().top : null;
        fn();
        if (!el || topBefore == null) return;
        var adjust = function () {
            var delta = el.getBoundingClientRect().top - topBefore;
            if (delta) window.scrollBy(0, delta);
        };
        adjust();
        if (typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(adjust);
        }
        try {
            el.focus({ preventScroll: true });
        } catch (eFocusKeep) { }
    }

    function enterSaveLaterNamingMode() {
        if (!items.length) return;
        if (!ensureReadyForSubmit('save')) return;
        keepElementViewportTop(saveLaterBtn, function () {
            setSaveLaterNamingMode(true);
            render();
            hideMsg();
        });
    }

    function friendlyNameBlock(item) {
        if (!saveLaterNamingMode) return '';
        var current = getItemFriendlyName(item);
        var id = escapeHtml(String(item.id));
        return (
            '<div class="door-quote-item__friendly">' +
            '<div class="door-quote-item__friendly-field">' +
            '<label for="door-quote-friendly-' +
            id +
            '">Nickname <span class="fw-400">(optional — for this door)</span></label>' +
            '<input id="door-quote-friendly-' +
            id +
            '" type="text" data-friendly-input="' +
            id +
            '" ' +
            'placeholder="e.g. Kitchen backdoor" value="' +
            escapeHtml(current) +
            '" autocomplete="off">' +
            '</div>' +
            '<button type="button" class="door-quote-item__friendly-submit" data-friendly-submit="' +
            id +
            '">Save nickname</button>' +
            '</div>'
        );
    }

    function render() {
        if (!listEl) return;
        if (!items.length) {
            setSaveLaterNamingMode(false);
            listEl.innerHTML =
                '<div class="door-quote-empty"><p>Your quote cart is empty.</p><a class="common-btn" href="/collections/all">Explore More Doors</a></div>';
            if (footerEl) footerEl.style.display = 'none';
            return;
        }
        if (footerEl) footerEl.style.display = 'flex';
        listEl.innerHTML = items
            .map(function (item) {
                var expanded = !!item._expanded;
                var productUrl = buildQuoteItemProductUrl(item);
                var img = item.product_image_url
                    ? '<img class="door-quote-item__img" src="' + escapeHtml(item.product_image_url) + '" alt="">'
                    : '<div class="door-quote-item__img--ph" aria-hidden="true">Door</div>';
                img = wrapQuoteProductLink(img, productUrl, 'door-quote-item__img-link');
                var titleText = escapeHtml(item.product_title || 'Project #' + item.id);
                var titleHtml = wrapQuoteProductLink(titleText, productUrl, 'door-quote-item__title-link');
                var qty = Math.max(1, parseInt(item.quantity, 10) || 1);
                var namingClass = saveLaterNamingMode ? ' is-naming-mode' : '';
                return (
                    '<article class="door-quote-item' +
                    namingClass +
                    '" data-id="' +
                    escapeHtml(String(item.id)) +
                    '">' +
                    img +
                    '<div class="door-quote-item__detail">' +
                    '<h2 class="door-quote-item__title p-large fw-600 mb-8">' +
                    titleHtml +
                    '</h2>' +
                    summaryLines(item, expanded) +
                    friendlyNameBlock(item) +
                    '</div>' +
                    '<div class="door-quote-item__actions">' +
                    '<div class="door-quote-qty">' +
                    '<label>Quantity</label>' +
                    '<div class="door-quote-qty__ctrl">' +
                    '<button type="button" data-qty-delta="-1" data-id="' +
                    escapeHtml(String(item.id)) +
                    '" aria-label="Decrease quantity">−</button>' +
                    '<span>' +
                    qty +
                    '</span>' +
                    '<button type="button" data-qty-delta="1" data-id="' +
                    escapeHtml(String(item.id)) +
                    '" aria-label="Increase quantity">+</button>' +
                    '</div>' +
                    '</div>' +
                    '<button type="button" class="door-quote-remove common-btn btn-woodDust" data-remove="' +
                    escapeHtml(String(item.id)) +
                    '">Remove <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none"><path d="M9.16667 3.16667V2.63333C9.16667 1.8866 9.16667 1.51323 9.02134 1.22801C8.89351 0.97713 8.68954 0.773156 8.43865 0.645325C8.15344 0.5 7.78007 0.5 7.03333 0.5H5.96667C5.21993 0.5 4.84656 0.5 4.56135 0.645325C4.31046 0.773156 4.10649 0.97713 3.97866 1.22801C3.83333 1.51323 3.83333 1.8866 3.83333 2.63333V3.16667M5.16667 6.83333V10.1667M7.83333 6.83333V10.1667M0.5 3.16667H12.5M11.1667 3.16667V10.6333C11.1667 11.7534 11.1667 12.3135 10.9487 12.7413C10.7569 13.1176 10.451 13.4236 10.0746 13.6153C9.64682 13.8333 9.08677 13.8333 7.96667 13.8333H5.03333C3.91323 13.8333 3.35318 13.8333 2.92535 13.6153C2.54903 13.4236 2.24307 13.1176 2.05132 12.7413C1.83333 12.3135 1.83333 11.7534 1.83333 10.6333V3.16667" stroke="#806730" stroke-linecap="round" stroke-linejoin="round"/></svg>  </button>' +
                    '</div>' +
                    '</article>'
                );
            })
            .join('');
    }

    function syncQuoteFolderDivSelect() {
        if (!folderSelect) return;
        var divApi = window.DoorConf2Update || window.DoorConf2Hardware;
        if (divApi && typeof divApi.enhanceDoorSelectWithDivDropdown === 'function') {
            try {
                divApi.enhanceDoorSelectWithDivDropdown(folderSelect);
                var divWrap = folderSelect.nextElementSibling;
                if (!(divWrap && divWrap.classList && divWrap.classList.contains('door-div-select'))) {
                    var parent = folderSelect.parentNode;
                    divWrap = parent ? parent.querySelector('.door-div-select') : null;
                }
                if (divWrap && typeof divApi.rebuildDoorDivSelectOptions === 'function') {
                    divApi.rebuildDoorDivSelectOptions(folderSelect, divWrap);
                } else if (divWrap && typeof divApi.syncDoorDivSelectFromNative === 'function') {
                    divApi.syncDoorDivSelectFromNative(folderSelect, divWrap);
                }
                return;
            } catch (eEnhApi) { }
        }
        enhanceQuoteFolderSelectLocal(folderSelect);
    }

    function enhanceQuoteFolderSelectLocal(selectEl) {
        if (!selectEl || selectEl.tagName !== 'SELECT') return;
        var existing = selectEl.nextElementSibling;
        if (existing && existing.classList && existing.classList.contains('door-div-select')) {
            rebuildQuoteFolderDivOptions(selectEl, existing);
            return;
        }
        selectEl.classList.add('door-native-select--enhanced');
        selectEl.setAttribute('data-door-div-select', '1');

        var divWrap = document.createElement('div');
        divWrap.className = 'door-div-select';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'door-div-select__btn';
        btn.setAttribute('aria-haspopup', 'listbox');
        btn.setAttribute('aria-expanded', 'false');

        var labelSpan = document.createElement('span');
        labelSpan.className = 'door-div-select__label';
        btn.appendChild(labelSpan);

        var iconSpan = document.createElement('span');
        iconSpan.className = 'door-div-select__icon';
        iconSpan.innerHTML =
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        btn.appendChild(iconSpan);

        var list = document.createElement('div');
        list.className = 'door-div-select__list';
        list.setAttribute('role', 'listbox');

        function closeWrap() {
            divWrap.classList.remove('door-div-select--open');
            btn.setAttribute('aria-expanded', 'false');
        }
        function syncFromNative() {
            var opt = selectEl.options[selectEl.selectedIndex];
            labelSpan.textContent = opt ? String(opt.textContent || opt.value || '').trim() : '';
            Array.prototype.forEach.call(list.querySelectorAll('.door-div-select__item'), function (item) {
                var match = String(item.getAttribute('data-value') || '') === String(selectEl.value || '');
                item.setAttribute('aria-selected', match ? 'true' : 'false');
            });
        }
        function rebuild() {
            while (list.firstChild) list.removeChild(list.firstChild);
            Array.prototype.forEach.call(selectEl.options || [], function (opt) {
                if (opt.disabled) return;
                var item = document.createElement('button');
                item.type = 'button';
                item.className = 'door-div-select__item';
                item.setAttribute('role', 'option');
                item.setAttribute('data-value', String(opt.value));
                item.textContent = String(opt.textContent || opt.value || '').trim();
                item.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    selectEl.value = String(opt.value);
                    try {
                        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
                    } catch (eCh) { }
                    syncFromNative();
                    closeWrap();
                });
                list.appendChild(item);
            });
            syncFromNative();
        }

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var willOpen = !divWrap.classList.contains('door-div-select--open');
            document.querySelectorAll('.door-quote-wrap .door-div-select--open').forEach(function (el) {
                if (el !== divWrap) el.classList.remove('door-div-select--open');
            });
            divWrap.classList.toggle('door-div-select--open', willOpen);
            btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
        if (!window.__doorQuoteDivSelectDocClose) {
            window.__doorQuoteDivSelectDocClose = true;
            document.addEventListener('click', function (e) {
                if (e.target && e.target.closest && e.target.closest('.door-quote-wrap .door-div-select')) return;
                document.querySelectorAll('.door-quote-wrap .door-div-select--open').forEach(function (el) {
                    el.classList.remove('door-div-select--open');
                    var b = el.querySelector('.door-div-select__btn');
                    if (b) b.setAttribute('aria-expanded', 'false');
                });
            });
        }

        rebuild();
        divWrap.appendChild(btn);
        divWrap.appendChild(list);
        if (selectEl.parentNode) selectEl.parentNode.insertBefore(divWrap, selectEl.nextSibling);
        selectEl.__quoteRebuildDiv = rebuild;
    }

    function rebuildQuoteFolderDivOptions(selectEl, divWrap) {
        if (!selectEl || !divWrap) return;
        if (typeof selectEl.__quoteRebuildDiv === 'function') {
            selectEl.__quoteRebuildDiv();
            return;
        }
        var list = divWrap.querySelector('.door-div-select__list');
        var labelSpan = divWrap.querySelector('.door-div-select__label');
        if (!list) return;
        while (list.firstChild) list.removeChild(list.firstChild);
        Array.prototype.forEach.call(selectEl.options || [], function (opt) {
            if (opt.disabled) return;
            var item = document.createElement('button');
            item.type = 'button';
            item.className = 'door-div-select__item';
            item.setAttribute('role', 'option');
            item.setAttribute('data-value', String(opt.value));
            item.textContent = String(opt.textContent || opt.value || '').trim();
            item.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                selectEl.value = String(opt.value);
                try {
                    selectEl.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (eCh2) { }
                if (labelSpan) labelSpan.textContent = item.textContent;
                Array.prototype.forEach.call(list.querySelectorAll('.door-div-select__item'), function (el) {
                    el.setAttribute('aria-selected', el === item ? 'true' : 'false');
                });
                divWrap.classList.remove('door-div-select--open');
            });
            list.appendChild(item);
        });
        var opt = selectEl.options[selectEl.selectedIndex];
        if (labelSpan) labelSpan.textContent = opt ? String(opt.textContent || opt.value || '').trim() : '';
    }

    function loadFolders() {
        if (!folderSelect || !email) {
            syncQuoteFolderDivSelect();
            return;
        }
        var cartMeta = readCart();
        var preferredId = cartMeta.preferred_folder_id != null ? String(cartMeta.preferred_folder_id) : '';
        if (!preferredId && items.length) {
            for (var i = 0; i < items.length; i++) {
                if (items[i] && items[i].source_folder_id != null && items[i].source_folder_id !== '') {
                    preferredId = String(items[i].source_folder_id);
                    break;
                }
            }
        }
        Promise.all([
            fetch(apiBase + '/api/folders.php?email=' + encodeURIComponent(email) + '&exclude_fully_quoted=1').then(
                function (r) {
                    return parseFetchJson(r).then(function (parsed) {
                        return parsed && parsed.data ? parsed.data : [];
                    });
                }
            ),
            fetch(apiBase + '/api/configurations.php?email=' + encodeURIComponent(email) + '&include_quote_cart=1')
                .then(function (r) {
                    return parseFetchJson(r).then(function (parsed) {
                        return parsed && parsed.data ? parsed.data : null;
                    });
                })
                .catch(function () {
                    return null;
                }),
        ])
            .then(function (results) {
                var list = Array.isArray(results[0]) ? results[0] : [];
                var configs = results[1];
                var statsReady = Array.isArray(configs);
                var stats = {};
                if (statsReady) {
                    configs.forEach(function (c) {
                        if (!c || c.folder_id == null || c.folder_id === '') return;
                        var id = String(c.folder_id);
                        if (!stats[id]) stats[id] = { total: 0, quoted: 0 };
                        stats[id].total += 1;
                        if (c.is_quoted === 1 || c.is_quoted === true || c.is_quoted === '1') stats[id].quoted += 1;
                    });
                }
                function isBlocked(f) {
                    if (!f) return true;
                    if (f.fully_quoted === 1 || f.fully_quoted === true || f.fully_quoted === '1') return true;
                    var qs = String(f.quote_status || '').toLowerCase();
                    if (qs === 'quoted' || qs === 'quote_requested') return true;
                    var os = String(f.order_status || '').toLowerCase();
                    if (os === 'draft' || os === 'paid' || os === 'ordered') return true;
                    if (String(f.shopify_draft_order_id || '').trim()) return true;
                    if (statsReady) {
                        var st = stats[String(f.id)];
                        if (!st || st.total <= 0) return true;
                        if (st.quoted >= st.total) return true;
                    }
                    return false;
                }
                while (folderSelect.firstChild) folderSelect.removeChild(folderSelect.firstChild);
                var placeholder = document.createElement('option');
                placeholder.value = '';
                placeholder.textContent = 'Select a project...';
                folderSelect.appendChild(placeholder);
                list.forEach(function (f) {
                    if (isBlocked(f)) return;
                    var opt = document.createElement('option');
                    opt.value = String(f.id);
                    opt.textContent = f.name || 'Project ' + f.id;
                    folderSelect.appendChild(opt);
                });
                var o = document.createElement('option');
                o.value = '__new__';
                o.textContent = '+ New project...';
                folderSelect.appendChild(o);
                if (preferredId && folderSelect.querySelector('option[value="' + preferredId.replace(/"/g, '') + '"]')) {
                    folderSelect.value = preferredId;
                } else {
                    folderSelect.selectedIndex = 0;
                }
                if (newFolderInput) {
                    var isNew = folderSelect.value === '__new__';
                    newFolderInput.style.display = isNew ? 'block' : 'none';
                    if (!isNew) newFolderInput.value = '';
                }
                syncQuoteFolderDivSelect();
            })
            .catch(function () {
                syncQuoteFolderDivSelect();
            });
    }

    function getSelectedProject() {
        if (!folderSelect) return null;
        var folderValue = folderSelect.value;
        if (!folderValue) return null;
        if (folderValue === '__new__') {
            var name = newFolderInput && newFolderInput.value ? newFolderInput.value.trim() : '';
            if (!name) return null;
            return { folder_id: null, folder_name: name, saved_project_name: name };
        }
        var folderId = parseInt(folderValue, 10);
        if (isNaN(folderId)) return null;
        var label = '';
        if (folderSelect.options && folderSelect.selectedIndex >= 0) {
            label = (folderSelect.options[folderSelect.selectedIndex].text || '').trim();
        }
        return {
            folder_id: folderId,
            folder_name: null,
            saved_project_name: label || 'Project ' + folderId,
        };
    }

    function createAutoProject() {
        return fetch(apiBase + '/api/folders.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                auto_name: 1,
                customer_email: email,
                first_name: firstName,
                last_name: lastName,
            }),
        })
            .then(function (r) {
                return parseFetchJson(r);
            })
            .then(function (result) {
                if (!result.ok || !result.data || result.data.id == null) {
                    throw new Error((result.data && result.data.error) || 'Failed to create project');
                }
                var folderId = parseInt(result.data.id, 10);
                var folderName = (result.data.name || '').trim() || String(folderId);
                if (folderSelect) {
                    var opt = document.createElement('option');
                    opt.value = String(folderId);
                    opt.textContent = folderName;
                    var newOpt = folderSelect.querySelector('option[value="__new__"]');
                    if (newOpt) folderSelect.insertBefore(opt, newOpt);
                    else folderSelect.appendChild(opt);
                    folderSelect.value = String(folderId);
                    if (newFolderInput) {
                        newFolderInput.style.display = 'none';
                        newFolderInput.value = '';
                    }
                    syncQuoteFolderDivSelect();
                }
                return {
                    folder_id: folderId,
                    folder_name: null,
                    saved_project_name: folderName,
                };
            });
    }

    function resolveProject() {
        var project = getSelectedProject();
        if (project) return Promise.resolve(project);
        if (folderSelect && folderSelect.value === '__new__') {
            var typed = newFolderInput && newFolderInput.value ? newFolderInput.value.trim() : '';
            if (typed) {
                return Promise.resolve({ folder_id: null, folder_name: typed, saved_project_name: typed });
            }
        }
        return createAutoProject();
    }

    function load() {
        // Logged in but profile incomplete → finish profile, then return here.
        if (email && !profileComplete) {
            setAuthReturnToQuoteCart();
            window.location.replace(withRoot(completeProfileUrl));
            return;
        }

        var cart = readCart();
        items = Array.isArray(cart.items) ? cart.items.slice() : [];
        removedSourceIds = normalizeRemovedSourceIds(cart.removed_source_config_ids);
        render();
        if (email && removedSourceIds.length) deleteRemovedSavedConfigs();
        syncQuoteFolderDivSelect();
        loadFolders();
        try {
            var intent = localStorage.getItem('door_quote_auth_intent') || '';
            if (intent && email && profileComplete) {
                localStorage.removeItem('door_quote_auth_intent');
                if (intent === 'save' && items.length) {
                    setSaveLaterNamingMode(true);
                    render();
                    hideMsg();
                } else if (intent === 'quote' && items.length) {
                    showMsg('You are signed in. Review your quote and click Request Quote when ready.', 'info');
                }
            }
        } catch (eIntentLoad) { }
    }

    function updateQty(id, delta) {
        var item = null;
        for (var i = 0; i < items.length; i++) {
            if (String(items[i].id) === String(id)) {
                item = items[i];
                break;
            }
        }
        if (!item) return;
        item.quantity = Math.max(1, (parseInt(item.quantity, 10) || 1) + delta);
        if (item.options && typeof item.options === 'object') {
            item.options._quantity = item.quantity;
            // Dp merge code 10-09 start — refresh stored summary Quantity line when cart QTY changes
            try {
                delete item._quote_unified_summary;
                var refreshed = buildUnifiedQuoteDescription(item);
                if (refreshed) {
                    item._quote_unified_summary = refreshed;
                    item.options.options_summary = refreshed;
                    item.options._options_summary = refreshed;
                }
            } catch (eQtySum) { }
            // Dp merge code 10-09 end
        }
        persistItems();
        render();
    }

    function removeItem(id) {
        var removed = null;
        items = items.filter(function (it) {
            if (String(it.id) === String(id)) {
                removed = it;
                return false;
            }
            return true;
        });
        var sourceId =
            removed && removed.source_config_id != null && removed.source_config_id !== ''
                ? rememberRemovedSourceId(removed.source_config_id)
                : 0;
        persistItems();
        render();
        if (sourceId) {
            deleteSavedConfig(sourceId).then(function (result) {
                if (result && result.ok) {
                    forgetRemovedSourceId(sourceId);
                    persistItems();
                }
            });
        }
    }

    function buildOptionsSummary(it) {
        var text = '';
        try {
            text = buildUnifiedQuoteDescription(it);
        } catch (eDesc) { }
        if (text) return text;

        var rows = collectQuoteDescriptionRows(it);
        var parts = [];
        if (Array.isArray(rows)) {
            rows.forEach(function (r) {
                if (typeof r === 'string' && r) {
                    var s = dpNormalizeDescriptionValue(r);
                    if (s) parts.push(s);
                } else if (r && typeof r === 'object') {
                    var value = dpNormalizeDescriptionValue(r.value || r.display || r.name || '');
                    if (value) parts.push(value);
                }
            });
        }
        return parts.join('\n');
    }

    function postConfigFromCartItem(it, extra) {
        var opts = Object.assign({}, it.options || {});
        opts._quantity = Math.max(1, parseInt(it.quantity, 10) || 1);
        if (it.product_title) opts._product_title = it.product_title;
        if (it.product_image_url) opts._product_image_url = it.product_image_url;
        if (it.product_handle) opts._product_handle = it.product_handle;
        if (it.product_type) opts._product_type = it.product_type;
        if (it.product_sku) opts._product_sku = it.product_sku;
        var friendly = getItemFriendlyName(it);
        if (friendly) opts._friendly_name = friendly;
        else delete opts._friendly_name;

        // Persist the exact Request-a-Quote description for draft order + PDF parity.
        // Reuse cached summary when submitCart already built it (avoids 2× heavy work per item).
        var unifiedSummary = '';
        if (it && it._quote_unified_summary) {
            unifiedSummary = String(it._quote_unified_summary);
        } else {
            try {
                unifiedSummary = buildUnifiedQuoteDescription(it);
            } catch (eSum) { }
            if (it && unifiedSummary) it._quote_unified_summary = unifiedSummary;
        }
        if (unifiedSummary) {
            opts.options_summary = unifiedSummary;
            opts._options_summary = unifiedSummary;
        }

        var sourceId =
            it.source_config_id != null && it.source_config_id !== '' ? parseInt(it.source_config_id, 10) : NaN;
        var isQuote = extra && (extra.is_quoted === 1 || extra.is_quoted === '1' || extra.is_quoted === true);

        // Items added from My Projects: update the original row (no clone).
        // On Request Quote: mark quoted and remove from the project folder.
        if (!isNaN(sourceId) && sourceId > 0) {
            var putPayload = {
                id: sourceId,
                email: email,
                options: opts,
                quantity: opts._quantity,
                basePrice: it.base_price || 0,
                computedPrice: it.computed_price != null ? it.computed_price : it.applied_unit_price || 0,
                in_quote_cart: 0,
                is_quoted: isQuote ? 1 : 0,
            };
            if (friendly) putPayload.friendly_name = friendly;
            // Do not clear folder on quote — leave the design in its project.
            // Only set folder when saving for later / moving.
            if (!isQuote) {
                if (extra && extra.folder_id != null) {
                    putPayload.folder_id = extra.folder_id;
                } else if (extra && extra.folder_name) {
                    putPayload.folder_name = extra.folder_name;
                } else if (it.source_folder_id != null && it.source_folder_id !== '') {
                    putPayload.folder_id = it.source_folder_id;
                }
            }
            return fetch(apiBase + '/api/configurations.php', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(putPayload),
            }).then(function (r) {
                return parseFetchJson(r);
            });
        }

        var payload = Object.assign(
            {
                customerEmail: email,
                baseProductId: it.base_product_id || opts._product_id || '',
                productTitle: it.product_title || '',
                productImageUrl: it.product_image_url || '',
                productHandle: it.product_handle || '',
                variantId: it.variant_id || opts._variant_id || '',
                options: opts,
                notesFromCustomer: '',
                basePrice: it.base_price || 0,
                computedPrice: it.computed_price != null ? it.computed_price : it.applied_unit_price || 0,
                quantity: opts._quantity,
                in_quote_cart: 0,
            },
            extra || {}
        );
        if (friendly) payload.friendly_name = friendly;
        return fetch(apiBase + '/api/configurations.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        }).then(function (r) {
            return parseFetchJson(r);
        });
    }

    function postHubspotDeal(it, configId, projectName, callRequested, folderId, dealId) {
        var qty = Math.max(1, parseInt(it.quantity, 10) || 1);
        var unit =
            it.computed_price != null
                ? Number(it.computed_price)
                : it.applied_unit_price != null
                    ? Number(it.applied_unit_price)
                    : Number(it.base_price) || 0;
        var appliedLine = Math.round(unit * qty * 100) / 100;
        var summary = it && it._quote_unified_summary ? String(it._quote_unified_summary) : buildOptionsSummary(it);
        if (it && summary && !it._quote_unified_summary) it._quote_unified_summary = summary;
        var lineProps = { 'Config ID': String(configId) };
        if (summary) lineProps.Options = summary;
        var payload = {
            product_id: it.base_product_id || '',
            product_handle: it.product_handle || '',
            product_title: it.product_title || 'Project #' + configId,
            product_sku: it.product_sku || '',
            product_type: it.product_type || '',
            options: it.options || {},
            options_summary: summary,
            line_item_properties: lineProps,
            quantity: qty,
            base_price: Number(it.base_price) || 0,
            applied_price: appliedLine,
            currency: 'USD',
            customer_email: email,
            customer_first_name: firstName,
            customer_last_name: lastName,
            call_requested: callRequested,
            saved_project_name: projectName,
            config_id: String(configId),
            folder_id: folderId != null && folderId !== '' ? String(folderId) : '',
        };
        if (!payload.folder_id) delete payload.folder_id;
        if (dealId) payload.deal_id = String(dealId);
        return fetch(hubspotEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        }).then(function (r) {
            return parseFetchJson(r);
        });
    }

    function submitCart(mode, btn) {
        if (!items.length) return;
        if (!ensureReadyForSubmit(mode === 'save' ? 'save' : 'quote')) return;

        if (mode === 'save') {
            syncFriendlyNamesFromDom();
        } else if (saveLaterNamingMode) {
            setSaveLaterNamingMode(false);
            render();
        }

        btn.disabled = true;
        btn.textContent = mode === 'quote' ? 'Submitting…' : 'Saving…';
        if (requestBtn) requestBtn.disabled = true;
        if (saveLaterBtn) saveLaterBtn.disabled = true;
        hideMsg();

        resolveProject()
            .then(function (project) {
                return deleteRemovedSavedConfigs().then(function () {
                    return project;
                });
            })
            .then(function (project) {
                var pending = items.slice();
                var folderExtra = { in_quote_cart: 0, is_quoted: mode === 'quote' ? 1 : 0 };
                if (project.folder_id != null) folderExtra.folder_id = project.folder_id;
                if (project.folder_name) folderExtra.folder_name = project.folder_name;
                var callRequested = mode === 'quote' ? 'YES' : '--';
                var hubspotFailures = 0;

                // Pre-build descriptions once (was previously done twice per item).
                pending.forEach(function (it) {
                    if (!it || it._quote_unified_summary) return;
                    try {
                        it._quote_unified_summary = buildUnifiedQuoteDescription(it) || '';
                    } catch (ePreSum) {
                        it._quote_unified_summary = '';
                    }
                });

                // 1) Save all configs in parallel (was sequential — main wait with 8–9 items).
                return Promise.all(
                    pending.map(function (it) {
                        return postConfigFromCartItem(it, folderExtra).then(function (result) {
                            if (!result.ok || !result.data || result.data.id == null) {
                                throw new Error((result.data && result.data.error) || 'Failed to save project');
                            }
                            return {
                                it: it,
                                configId: result.data.id,
                                folderId: result.data.folder_id != null ? result.data.folder_id : project.folder_id,
                            };
                        });
                    })
                ).then(function (savedRows) {
                    if (!savedRows.length) return { hubspotFailures: 0 };

                    // 2) First HubSpot call creates/finds the deal; remaining attach in parallel.
                    var first = savedRows[0];
                    var rest = savedRows.slice(1);
                    return postHubspotDeal(
                        first.it,
                        first.configId,
                        project.saved_project_name,
                        callRequested,
                        first.folderId,
                        ''
                    ).then(function (hsFirst) {
                        var hubspotDealId = '';
                        if (hsFirst.ok && hsFirst.data && hsFirst.data.success && hsFirst.data.dealId) {
                            hubspotDealId = String(hsFirst.data.dealId);
                        }
                        if (!hsFirst.ok || !hsFirst.data || !hsFirst.data.success) {
                            hubspotFailures += 1;
                            if (typeof console !== 'undefined' && console.error) {
                                console.error('[door-quote] HubSpot failed for config', first.configId, hsFirst.data);
                            }
                        }

                        if (!rest.length) return { hubspotFailures: hubspotFailures };

                        return Promise.all(
                            rest.map(function (row) {
                                return postHubspotDeal(
                                    row.it,
                                    row.configId,
                                    project.saved_project_name,
                                    callRequested,
                                    row.folderId,
                                    hubspotDealId
                                ).then(function (hs) {
                                    if (!hs.ok || !hs.data || !hs.data.success) {
                                        hubspotFailures += 1;
                                        if (typeof console !== 'undefined' && console.error) {
                                            console.error('[door-quote] HubSpot failed for config', row.configId, hs.data);
                                        }
                                    }
                                });
                            })
                        ).then(function () {
                            return { hubspotFailures: hubspotFailures };
                        });
                    });
                });
            })
            .then(function (result) {
                var quoteItems = mode === 'quote' ? items.slice() : [];
                items = [];
                setSaveLaterNamingMode(false);
                persistItems();
                render();
                btn.disabled = false;
                btn.textContent = mode === 'quote' ? 'Request Quote' : 'Save For Later';
                if (requestBtn) requestBtn.disabled = false;
                if (saveLaterBtn) saveLaterBtn.disabled = false;
                var hubspotFailures = result && result.hubspotFailures ? result.hubspotFailures : 0;
                if (hubspotFailures) {
                    showMsg(
                        (mode === 'quote' ? 'Quote saved.' : 'Designs saved.') +
                        ' Custom app updated, but ' +
                        hubspotFailures +
                        ' HubSpot deal(s) failed.',
                        'error'
                    );
                } else if (mode === 'quote') {
                    showMsg('Your quote request was submitted. Our team will follow up soon.', 'ok');
                    try {
                        var quoteValue = 0;
                        var itemCount = 0;
                        for (var qi = 0; qi < quoteItems.length; qi++) {
                            var qIt = quoteItems[qi];
                            var qQty = Math.max(1, parseInt(qIt && qIt.quantity, 10) || 1);
                            var qUnit = Number(
                                qIt && qIt.computed_price != null
                                    ? qIt.computed_price
                                    : qIt && qIt.applied_unit_price != null
                                        ? qIt.applied_unit_price
                                        : qIt && qIt.base_price
                            ) || 0;
                            itemCount += qQty;
                            quoteValue += qUnit * qQty;
                        }
                        window.dataLayer = window.dataLayer || [];
                        var quoteTransactionId = 'quote_' + Date.now();
                        window.dataLayer.push({
                            event: 'quote_request_success',
                            transaction_id: quoteTransactionId
                        });
                        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
                            Shopify.analytics.publish('quote_request_success', {
                                transaction_id: quoteTransactionId,
                                value: 250,
                                currency: 'USD',
                                email: email || '',
                                phone: phone || ''
                            });
                        }
                        if (typeof gtag === 'function') {
                            var userData = {};
                            if (email) userData.email = email;
                            if (phone) userData.phone_number = phone;
                            if (userData.email || userData.phone_number) {
                                gtag('set', 'user_data', userData);
                            }
                            gtag('event', 'conversion', {
                                send_to: 'AW-993618508/9LFMCIyc4gcQzNTl2QM',
                                value: 250,
                                currency: 'USD',
                                transaction_id: quoteTransactionId
                            });
                        }
                    } catch (eQuoteDl) { }
                } else {
                    var path = '/pages/my-saved-doors';
                    window.location.href = withRoot(path);
                }
            })
            .catch(function (err) {
                btn.disabled = false;
                btn.textContent =
                    mode === 'quote' ? 'Request Quote' : saveLaterNamingMode ? 'Confirm Save' : 'Save For Later';
                if (requestBtn) requestBtn.disabled = false;
                if (saveLaterBtn) saveLaterBtn.disabled = false;
                // Dp start 27-08 — empty API bodies used to surface "Unexpected end of JSON input"
                var errMsg = err && err.message ? String(err.message) : '';
                if (!errMsg || /unexpected end of json/i.test(errMsg) || /failed to execute 'json'/i.test(errMsg)) {
                    errMsg = 'Something went wrong while submitting. Please try again.';
                }
                showMsg(errMsg, 'error');
                // Dp end 27-08
            });
    }

    if (folderSelect) {
        folderSelect.addEventListener('change', function () {
            if (!newFolderInput) return;
            var isNew = folderSelect.value === '__new__';
            newFolderInput.style.display = isNew ? 'block' : 'none';
            if (!isNew) newFolderInput.value = '';
        });
    }

    listEl.addEventListener('click', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.getAttribute('data-friendly-submit')) {
            var fid = t.getAttribute('data-friendly-submit');
            var input = listEl.querySelector('[data-friendly-input="' + fid.replace(/"/g, '') + '"]');
            var val = input ? (input.value || '').trim() : '';
            for (var i = 0; i < items.length; i++) {
                if (String(items[i].id) === String(fid)) {
                    setItemFriendlyName(items[i], val);
                    break;
                }
            }
            persistItems();
            t.textContent = val ? 'Nickname saved' : 'Cleared';
            t.classList.add('is-saved');
            var btnRef = t;
            setTimeout(function () {
                if (!btnRef) return;
                btnRef.textContent = 'Save nickname';
                btnRef.classList.remove('is-saved');
            }, 1600);
            return;
        }
        if (t.getAttribute('data-toggle-more')) {
            if (saveLaterNamingMode) syncFriendlyNamesFromDom();
            var tid = t.getAttribute('data-toggle-more');
            items.forEach(function (it) {
                if (String(it.id) === String(tid)) it._expanded = !it._expanded;
            });
            render();
            return;
        }
        if (t.getAttribute('data-qty-delta')) {
            if (saveLaterNamingMode) syncFriendlyNamesFromDom();
            updateQty(t.getAttribute('data-id'), parseInt(t.getAttribute('data-qty-delta'), 10) || 0);
            return;
        }
        var removeEl =
            (t.closest && t.closest('[data-remove]')) || (t.getAttribute && t.getAttribute('data-remove') ? t : null);
        if (removeEl) {
            if (saveLaterNamingMode) syncFriendlyNamesFromDom();
            removeItem(removeEl.getAttribute('data-remove'));
        }
    });

    if (requestBtn) {
        requestBtn.addEventListener('click', function () {
            // Guest / incomplete profile: login → complete-profile → back to quote cart.
            if (!ensureReadyForSubmit('quote')) return;
            submitCart('quote', requestBtn);
        });
    }

    if (saveLaterBtn) {
        saveLaterBtn.addEventListener('click', function () {
            if (!saveLaterNamingMode) {
                enterSaveLaterNamingMode();
                return;
            }
            submitCart('save', saveLaterBtn);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', load);
    } else {
        load();
    }
})();
